import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Date: any;
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: any;
  /** The `DateTimeOffset` scalar type represents a date, time and offset from UTC. `DateTimeOffset` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTimeOffset: any;
  Decimal: any;
  /** The `Milliseconds` scalar type represents a period of time represented as the total number of milliseconds. */
  Milliseconds: any;
  /** The `Seconds` scalar type represents a period of time represented as the total number of seconds. */
  Seconds: any;
};

/** Alternative path for the content item */
export type AliasPart = {
  __typename?: 'AliasPart';
  alias?: Maybe<Scalars['String']>;
};

/** the alias part of the content item */
export type AliasPartInput = {
  /** the alias of the content item is equal to */
  alias?: Maybe<Scalars['String']>;
  /** the alias of the content item is not equal to */
  alias_not?: Maybe<Scalars['String']>;
  /** the alias of the content item is in collection */
  alias_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the alias of the content item is not in collection */
  alias_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the alias of the content item contains the string */
  alias_contains?: Maybe<Scalars['String']>;
  /** the alias of the content item does not contain the string */
  alias_not_contains?: Maybe<Scalars['String']>;
  /** the alias of the content item starts with the string */
  alias_starts_with?: Maybe<Scalars['String']>;
  /** the alias of the content item does not start with the string */
  alias_not_starts_with?: Maybe<Scalars['String']>;
  /** the alias of the content item ends with the string */
  alias_ends_with?: Maybe<Scalars['String']>;
  /** the alias of the content item does not end with the string */
  alias_not_ends_with?: Maybe<Scalars['String']>;
};

/** Custom URLs (permalinks) for your content item. */
export type AutoroutePart = {
  __typename?: 'AutoroutePart';
  /** The permalinks for your content item. */
  path: Scalars['String'];
};

/** the custom URL part of the content item */
export type AutoroutePartInput = {
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
};

/** A BagPart allows to add content items directly within another content item */
export type BagPart = {
  __typename?: 'BagPart';
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
};


/** A BagPart allows to add content items directly within another content item */
export type BagPartContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

/** Represents a link to the parent content item, and the order that content item is represented. */
export type ContainedPart = {
  __typename?: 'ContainedPart';
  listContentItemId: Scalars['String'];
  order: Scalars['Int'];
};

/** the list part of the content item */
export type ContainedPartInput = {
  /** the content item id of the parent list of the content item to filter is equal to */
  listContentItemId?: Maybe<Scalars['ID']>;
  /** the content item id of the parent list of the content item to filter is not equal to */
  listContentItemId_not?: Maybe<Scalars['ID']>;
  /** the content item id of the parent list of the content item to filter is in collection */
  listContentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item id of the parent list of the content item to filter is not in collection */
  listContentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type ContentItem = {
  author: Scalars['String'];
  contentItemId: Scalars['String'];
  contentItemVersionId: Scalars['String'];
  contentType: Scalars['String'];
  createdUtc?: Maybe<Scalars['DateTime']>;
  displayText?: Maybe<Scalars['String']>;
  latest: Scalars['Boolean'];
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  owner: Scalars['String'];
  published: Scalars['Boolean'];
  publishedUtc?: Maybe<Scalars['DateTime']>;
};

export type ContentPickerField = {
  __typename?: 'ContentPickerField';
  /** content item ids */
  contentItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
};


export type ContentPickerFieldContentItemIdsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type ContentPickerFieldContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};





/** The widget alignment. */
export enum FlowAlignment {
  /** Left alignment. */
  Left = 'Left',
  /** Center alignment. */
  Center = 'Center',
  /** Right alignment. */
  Right = 'Right',
  /** Justify alignment. */
  Justify = 'Justify'
}

export type FlowMetadata = {
  __typename?: 'FlowMetadata';
  alignment?: Maybe<FlowAlignment>;
  size?: Maybe<Scalars['Int']>;
};

/** A FlowPart allows to add content items directly within another content item */
export type FlowPart = {
  __typename?: 'FlowPart';
  /** The widgets. */
  widgets?: Maybe<Array<Maybe<ContentItem>>>;
};

/** Represents a Tags - Generic . */
export type GenericTag = ContentItem & {
  __typename?: 'GenericTag';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  value?: Maybe<Scalars['String']>;
};

export type GenericTagOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the GenericTag content item filters */
export type GenericTagWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<GenericTagWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<GenericTagWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<GenericTagWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
};

export type GridSettings = {
  __typename?: 'GridSettings';
  /** Boolean field */
  loadMore?: Maybe<Scalars['Boolean']>;
};

/** Represents a Home page banner. */
export type Homepagebanner = ContentItem & {
  __typename?: 'Homepagebanner';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type HomepagebannerOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the Homepagebanner content item filters */
export type HomepagebannerWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<HomepagebannerWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<HomepagebannerWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<HomepagebannerWhereInput>>>;
};

/** Content stored as HTML. */
export type HtmlBodyPart = {
  __typename?: 'HtmlBodyPart';
  /** the HTML content */
  html?: Maybe<Scalars['String']>;
};

/** Represents a Content block - Icons. */
export type IconBlockRow = ContentItem & {
  __typename?: 'IconBlockRow';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};


/** Represents a Content block - Icons. */
export type IconBlockRowContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

export type IconBlockRowOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the IconBlockRow content item filters */
export type IconBlockRowWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<IconBlockRowWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<IconBlockRowWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<IconBlockRowWhereInput>>>;
};

/** Represents a pages content- cards [ Manual ] . */
export type ImgTitleContentCardGroup = ContentItem & {
  __typename?: 'ImgTitleContentCardGroup';
  /** The author of the content item */
  author: Scalars['String'];
  /** A BagPart allows to add content items directly within another content item */
  cards?: Maybe<BagPart>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type ImgTitleContentCardGroupOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the ImgTitleContentCardGroup content item filters */
export type ImgTitleContentCardGroupWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImgTitleContentCardGroupWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImgTitleContentCardGroupWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImgTitleContentCardGroupWhereInput>>>;
};

export type LinkField = {
  __typename?: 'LinkField';
  /** the text of the link */
  text?: Maybe<Scalars['String']>;
  /** the url of the link */
  url?: Maybe<Scalars['String']>;
};

/** Represents a collection of content items. */
export type ListPart = {
  __typename?: 'ListPart';
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
};


/** Represents a collection of content items. */
export type ListPartContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

/** the localization part of the content item */
export type LocalizationInputObjectType = {
  /** the culture of the content item to filter is equal to */
  culture?: Maybe<Scalars['String']>;
  /** the culture of the content item to filter is not equal to */
  culture_not?: Maybe<Scalars['String']>;
  /** the culture of the content item to filter is in collection */
  culture_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the culture of the content item to filter is not in collection */
  culture_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the culture of the content item to filter contains the string */
  culture_contains?: Maybe<Scalars['String']>;
  /** the culture of the content item to filter does not contain the string */
  culture_not_contains?: Maybe<Scalars['String']>;
  /** the culture of the content item to filter starts with the string */
  culture_starts_with?: Maybe<Scalars['String']>;
  /** the culture of the content item to filter does not start with the string */
  culture_not_starts_with?: Maybe<Scalars['String']>;
  /** the culture of the content item to filter ends with the string */
  culture_ends_with?: Maybe<Scalars['String']>;
  /** the culture of the content item to filter does not end with the string */
  culture_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization set of the content item to filter */
  localizationSet: Scalars['String'];
};

/** Localization cultures for your content item. */
export type LocalizationPart = {
  __typename?: 'LocalizationPart';
  /** The culture for your content item. */
  culture: Scalars['String'];
  /** The localizations of the content item. */
  localizations?: Maybe<Array<Maybe<ContentItem>>>;
  /** The localization set for your content item. */
  localizationSet: Scalars['String'];
};


/** Localization cultures for your content item. */
export type LocalizationPartLocalizationsArgs = {
  culture?: Maybe<Scalars['String']>;
};

/** Represents a Tags - Location . */
export type LocationTag = ContentItem & {
  __typename?: 'LocationTag';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  value?: Maybe<Scalars['String']>;
};

export type LocationTagOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the LocationTag content item filters */
export type LocationTagWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<LocationTagWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<LocationTagWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<LocationTagWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
};

/** Content stored as Markdown. You can also query the HTML interpreted version of Markdown. */
export type MarkdownBodyPart = {
  __typename?: 'MarkdownBodyPart';
  /** the HTML representation of the markdown content */
  html?: Maybe<Scalars['String']>;
  /** the markdown value */
  markdown?: Maybe<Scalars['String']>;
};

/** Content stored as Markdown. You can also query the HTML interpreted version of Markdown. */
export type MarkdownField = {
  __typename?: 'MarkdownField';
  /** the HTML representation of the markdown content */
  html?: Maybe<Scalars['String']>;
  /** the markdown value */
  markdown?: Maybe<Scalars['String']>;
};

export type MediaAsset = {
  __typename?: 'MediaAsset';
  /** The date and time in UTC when the asset was last modified. */
  lastModifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The length of the file. */
  length: Scalars['Int'];
  /** The name of the asset. */
  name: Scalars['String'];
  /** The url to the asset. */
  path?: Maybe<Scalars['String']>;
};

export type MediaField = {
  __typename?: 'MediaField';
  /** the media paths */
  paths?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the absolute urls of the media items */
  urls?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MediaFieldPathsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type MediaFieldUrlsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


/** the order by direction */
export enum OrderByDirection {
  /** orders content items in ascending order */
  Asc = 'ASC',
  /** orders content items in descending order */
  Desc = 'DESC'
}

export type PageMetaData = {
  __typename?: 'PageMetaData';
  /** Text field */
  description?: Maybe<Scalars['String']>;
  /** Text field */
  keywords?: Maybe<Scalars['String']>;
  /** Text field */
  label?: Maybe<Scalars['String']>;
  /** MediaField */
  thumbnail?: Maybe<MediaField>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** Represents a Accordion. */
  accordion?: Maybe<Array<Maybe<Accordion>>>;
  /** Represents a Complex accordion group (with related items). */
  accordionGroup?: Maybe<Array<Maybe<AccordionGroup>>>;
  /** Represents a Article. */
  article?: Maybe<Array<Maybe<Article>>>;
  articleByLocation?: Maybe<Array<Maybe<Article>>>;
  /** Represents a Card - Article. */
  articleCard?: Maybe<Array<Maybe<ArticleCard>>>;
  articleList?: Maybe<Array<Maybe<Article>>>;
  /** Represents a banner. */
  banner?: Maybe<Array<Maybe<Banner>>>;
  /** Represents a Campaign. */
  campaign?: Maybe<Array<Maybe<Campaign>>>;
  campaignByLocation?: Maybe<Array<Maybe<Campaign>>>;
  /** Represents a Card - Campaign. */
  campaignCard?: Maybe<Array<Maybe<CampaignCard>>>;
  campaignList?: Maybe<Array<Maybe<Campaign>>>;
  /** Represents a Content block - HTML . */
  content?: Maybe<Array<Maybe<Content>>>;
  /** Represents a Card - Content external link. */
  contentExternalLinkCard?: Maybe<Array<Maybe<ContentExternalLinkCard>>>;
  /** Represents a Content block - Feature introduction. */
  contentIntro?: Maybe<Array<Maybe<ContentIntro>>>;
  /** Content items are instances of content types, just like objects are instances of classes. */
  contentItem?: Maybe<ContentItem>;
  /** Represents a Content block - Content page cards. */
  contentPageCards?: Maybe<Array<Maybe<ContentPageCards>>>;
  /** Represents a Content block List- Content Page card. */
  contentPageCardsGroup?: Maybe<Array<Maybe<ContentPageCardsGroup>>>;
  /** Represents a UNFE Country. */
  country?: Maybe<Array<Maybe<Country>>>;
  /** Represents a Item - Definition. */
  definitionItem?: Maybe<Array<Maybe<DefinitionItem>>>;
  /** Represents a Document . */
  downloadCard?: Maybe<Array<Maybe<DownloadCard>>>;
  /** Represents a Grid - Download document . */
  downloadGrid?: Maybe<Array<Maybe<DownloadGrid>>>;
  /** Represents a Download -  Media. */
  downloadMediaCard?: Maybe<Array<Maybe<DownloadMediaCard>>>;
  /** Represents a Content block - External Feature CTA. */
  externalFeatureCta?: Maybe<Array<Maybe<ExternalFeatureCta>>>;
  /** Represents a Content block - External link cards. */
  externalLinkCardGroup?: Maybe<Array<Maybe<ExternalLinkCardGroup>>>;
  /** Represents a Fact Sheet. */
  factSheet?: Maybe<Array<Maybe<FactSheet>>>;
  /** Represents a Card - Fact sheet. */
  factSheetCard?: Maybe<Array<Maybe<FactSheetCard>>>;
  /** Represents a Grid - Fact sheets. */
  factSheetGrid?: Maybe<Array<Maybe<FactSheetGrid>>>;
  factSheetList?: Maybe<Array<Maybe<FactSheet>>>;
  factSheetsByLocation?: Maybe<Array<Maybe<FactSheet>>>;
  /** Represents a Image - Feature Image. */
  featureImg?: Maybe<Array<Maybe<FeatureImg>>>;
  /** Represents a Feature logo row. */
  featureLogoRow?: Maybe<Array<Maybe<FeatureLogoRow>>>;
  /** Represents a Item- Figure. */
  figureBlock?: Maybe<Array<Maybe<FigureBlock>>>;
  /** Represents a Carousel - Figures. */
  figuresBlock?: Maybe<Array<Maybe<FiguresBlock>>>;
  /** Represents a Footer. */
  footer?: Maybe<Array<Maybe<Footer>>>;
  /** Represents a Tags - Generic . */
  genericTag?: Maybe<Array<Maybe<GenericTag>>>;
  /** Represents a Image - Hero. */
  heroImage?: Maybe<Array<Maybe<HeroImage>>>;
  /** Represents a Home page. */
  homepage?: Maybe<Array<Maybe<Homepage>>>;
  /** Represents a Home page banner. */
  homepagebanner?: Maybe<Array<Maybe<Homepagebanner>>>;
  /** Represents a Item - Icon content. */
  iconBlock?: Maybe<Array<Maybe<IconBlock>>>;
  /** Represents a Content block - Icons. */
  iconBlockRow?: Maybe<Array<Maybe<IconBlockRow>>>;
  /** Represents a Iframe. */
  iframe?: Maybe<Array<Maybe<Iframe>>>;
  /** Represents a Content block - Image content. */
  imageContent?: Maybe<Array<Maybe<ImageContent>>>;
  /** Represents a Grid - Image content cards. */
  imageContentCardGrid?: Maybe<Array<Maybe<ImageContentCardGrid>>>;
  /** Represents a Carousel - Image Gallery. */
  imageGalleryCarousel?: Maybe<Array<Maybe<ImageGalleryCarousel>>>;
  /** Represents a Image  - item (title , caption, description). */
  imageItem?: Maybe<Array<Maybe<ImageItem>>>;
  /** Represents a Feature card - Image article card. */
  imgArticleCard?: Maybe<Array<Maybe<ImgArticleCard>>>;
  /** Represents a Feature card - Image campaign card. */
  imgCampaignCard?: Maybe<Array<Maybe<ImgCampaignCard>>>;
  /** Represents a Feature card - Image content card. */
  imgContentBlock?: Maybe<Array<Maybe<ImgContentBlock>>>;
  /** Represents a Feature card - Image page card. */
  imgContentCard?: Maybe<Array<Maybe<ImgContentCard>>>;
  /** Represents a Feature card - Image fact sheet card. */
  imgFactSheetCard?: Maybe<Array<Maybe<ImgFactSheetCard>>>;
  /** Represents a Grid - Image group. */
  imgGroup?: Maybe<Array<Maybe<ImgGroup>>>;
  /** Represents a pages content- cards [ Manual ] . */
  imgTitleContentCardGroup?: Maybe<Array<Maybe<ImgTitleContentCardGroup>>>;
  /** Represents a Instagram. */
  instagram?: Maybe<Array<Maybe<Instagram>>>;
  /** Represents a Carousel - Instagram. */
  instagramContentCarousel?: Maybe<Array<Maybe<InstagramContentCarousel>>>;
  /** Represents a Instagram feed. */
  instagramFeed?: Maybe<Array<Maybe<InstagramFeed>>>;
  /** Represents a Content block - Internal Feature CTA. */
  internalFeatureCta?: Maybe<Array<Maybe<InternalFeatureCta>>>;
  /** Represents a UNFE Region. */
  locationRegion?: Maybe<Array<Maybe<LocationRegion>>>;
  /** Represents a Tags - Location . */
  locationTag?: Maybe<Array<Maybe<LocationTag>>>;
  /** Represents a Map - Country. */
  mapCountry?: Maybe<Array<Maybe<MapCountry>>>;
  /** Represents a Map - Region. */
  mapRegion?: Maybe<Array<Maybe<MapRegion>>>;
  /** Media assets are items that are part of your media library. */
  mediaAssets?: Maybe<Array<Maybe<MediaAsset>>>;
  /** Represents a Carousel - Media Download . */
  mediaDownloadCarousel?: Maybe<Array<Maybe<MediaDownloadCarousel>>>;
  /** Represents a Newsletter. */
  newsletter?: Maybe<Array<Maybe<Newsletter>>>;
  /** Represents a page template - About us. */
  pageAboutUs?: Maybe<Array<Maybe<PageAboutUs>>>;
  /** Represents a page template - Act now. */
  pageActNow?: Maybe<Array<Maybe<PageActNow>>>;
  /** Represents a Card - Page. */
  pageCard?: Maybe<Array<Maybe<PageCard>>>;
  /** Represents a page template - Challenges & Solutions. */
  pageChallenges?: Maybe<Array<Maybe<PageChallenges>>>;
  /** Represents a page template - Contact us. */
  pageContactUs?: Maybe<Array<Maybe<PageContactUs>>>;
  /** Represents a page templates - Definitions. */
  pageDefinitions?: Maybe<Array<Maybe<PageDefinitions>>>;
  /** Represents a page template - Donate. */
  pageDonate?: Maybe<Array<Maybe<PageDonate>>>;
  /** Represents a page template - History of equal rights. */
  pageEqualRights?: Maybe<Array<Maybe<PageEqualRights>>>;
  /** Represents a page template - FAQs. */
  pageFaqs?: Maybe<Array<Maybe<PageFaqs>>>;
  /** Represents a page template - General content. */
  pageGeneralContent?: Maybe<Array<Maybe<PageGeneralContent>>>;
  /** Represents a page template - Know the facts. */
  pageKnowTheFacts?: Maybe<Array<Maybe<PageKnowTheFacts>>>;
  /** Represents a Page template - Newsletter. */
  pageNewsletter?: Maybe<Array<Maybe<PageNewsletter>>>;
  /** Represents a page template - Our campaigns. */
  pageOurCampaigns?: Maybe<Array<Maybe<PageOurCampaigns>>>;
  /** Represents a page template - Our work. */
  pageOurWork?: Maybe<Array<Maybe<PageOurWork>>>;
  /** Represents a page template - UN Resources. */
  pageResources?: Maybe<Array<Maybe<PageResources>>>;
  /** Represents a page template - History of the right to love. */
  pageRightToLove?: Maybe<Array<Maybe<PageRightToLove>>>;
  /** Represents a page template - Updates. */
  pageUpdates?: Maybe<Array<Maybe<PageUpdates>>>;
  /** Represents a page template - What we do. */
  pageWhatWeDo?: Maybe<Array<Maybe<PageWhatWeDo>>>;
  /** Represents a Related Articles. */
  relatedArticles?: Maybe<Array<Maybe<RelatedArticles>>>;
  /** Represents a Related Campaigns. */
  relatedCampaigns?: Maybe<Array<Maybe<RelatedCampaigns>>>;
  /** Represents a Related Fact sheets. */
  relatedFactSheets?: Maybe<Array<Maybe<RelatedFactSheets>>>;
  /** Represents a Accordion - Simple. */
  simpleAccordion?: Maybe<Array<Maybe<SimpleAccordion>>>;
  /** Represents a Accordion Group - Simple. */
  simpleAccordionGroup?: Maybe<Array<Maybe<SimpleAccordionGroup>>>;
  /** Represents a Content block - simple content. */
  simpleContentBlock?: Maybe<Array<Maybe<SimpleContentBlock>>>;
  /** Represents a Card - Simple content. */
  simpleContentCard?: Maybe<Array<Maybe<SimpleContentCard>>>;
  /** Represents a Grid - Terms. */
  simpleContentGrid?: Maybe<Array<Maybe<SimpleContentGrid>>>;
  /** Represents a Carousel - Simple page card . */
  simplePageCardCarousel?: Maybe<Array<Maybe<SimplePageCardCarousel>>>;
  /** The active cultures configured for the site. */
  siteCultures?: Maybe<Array<Maybe<SiteCulture>>>;
  /** Represents a Content block - Social content . */
  socialContentCard?: Maybe<Array<Maybe<SocialContentCard>>>;
  /** Represents a UNFE Social platform. */
  socialPlatform?: Maybe<Array<Maybe<SocialPlatform>>>;
  /** Represents a Sub header. */
  subheader?: Maybe<Array<Maybe<Subheader>>>;
  /** Represents a Subscription. */
  subscription?: Maybe<Array<Maybe<Subscription>>>;
  /** Represents a Taxonomy. */
  taxonomy?: Maybe<Array<Maybe<Taxonomy>>>;
  /** Represents a UNFE Content Item. */
  unfeContentItem?: Maybe<Array<Maybe<UnfeContentItem>>>;
  /** Represents a UNFE home page item. */
  unfeHomePage?: Maybe<Array<Maybe<UnfeHomePage>>>;
  /** Represents a Map. */
  unfeMap?: Maybe<Array<Maybe<UnfeMap>>>;
  /** Represents a UNFE Sitemap. */
  unfeNavigation?: Maybe<Array<Maybe<UnfeNavigation>>>;
  /** Represents a UNFE Navigation Item. */
  unfeNavItem?: Maybe<Array<Maybe<UnfeNavItem>>>;
  /** Represents a Youtube Video. */
  youtubeVideo?: Maybe<Array<Maybe<YoutubeVideo>>>;
};


export type QueryAccordionArgs = {
  where?: Maybe<AccordionWhereInput>;
  orderBy?: Maybe<AccordionOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryAccordionGroupArgs = {
  where?: Maybe<AccordionGroupWhereInput>;
  orderBy?: Maybe<AccordionGroupOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryArticleArgs = {
  where?: Maybe<ArticleWhereInput>;
  orderBy?: Maybe<ArticleOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryArticleByLocationArgs = {
  parameters?: Maybe<Scalars['String']>;
};


export type QueryArticleCardArgs = {
  where?: Maybe<ArticleCardWhereInput>;
  orderBy?: Maybe<ArticleCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryArticleListArgs = {
  parameters?: Maybe<Scalars['String']>;
};


export type QueryBannerArgs = {
  where?: Maybe<BannerWhereInput>;
  orderBy?: Maybe<BannerOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryCampaignArgs = {
  where?: Maybe<CampaignWhereInput>;
  orderBy?: Maybe<CampaignOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryCampaignByLocationArgs = {
  parameters?: Maybe<Scalars['String']>;
};


export type QueryCampaignCardArgs = {
  where?: Maybe<CampaignCardWhereInput>;
  orderBy?: Maybe<CampaignCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryCampaignListArgs = {
  parameters?: Maybe<Scalars['String']>;
};


export type QueryContentArgs = {
  where?: Maybe<ContentWhereInput>;
  orderBy?: Maybe<ContentOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryContentExternalLinkCardArgs = {
  where?: Maybe<ContentExternalLinkCardWhereInput>;
  orderBy?: Maybe<ContentExternalLinkCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryContentIntroArgs = {
  where?: Maybe<ContentIntroWhereInput>;
  orderBy?: Maybe<ContentIntroOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryContentItemArgs = {
  contentItemId: Scalars['String'];
};


export type QueryContentPageCardsArgs = {
  where?: Maybe<ContentPageCardsWhereInput>;
  orderBy?: Maybe<ContentPageCardsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryContentPageCardsGroupArgs = {
  where?: Maybe<ContentPageCardsGroupWhereInput>;
  orderBy?: Maybe<ContentPageCardsGroupOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryCountryArgs = {
  where?: Maybe<CountryWhereInput>;
  orderBy?: Maybe<CountryOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryDefinitionItemArgs = {
  where?: Maybe<DefinitionItemWhereInput>;
  orderBy?: Maybe<DefinitionItemOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryDownloadCardArgs = {
  where?: Maybe<DownloadCardWhereInput>;
  orderBy?: Maybe<DownloadCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryDownloadGridArgs = {
  where?: Maybe<DownloadGridWhereInput>;
  orderBy?: Maybe<DownloadGridOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryDownloadMediaCardArgs = {
  where?: Maybe<DownloadMediaCardWhereInput>;
  orderBy?: Maybe<DownloadMediaCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryExternalFeatureCtaArgs = {
  where?: Maybe<ExternalFeatureCtaWhereInput>;
  orderBy?: Maybe<ExternalFeatureCtaOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryExternalLinkCardGroupArgs = {
  where?: Maybe<ExternalLinkCardGroupWhereInput>;
  orderBy?: Maybe<ExternalLinkCardGroupOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFactSheetArgs = {
  where?: Maybe<FactSheetWhereInput>;
  orderBy?: Maybe<FactSheetOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFactSheetCardArgs = {
  where?: Maybe<FactSheetCardWhereInput>;
  orderBy?: Maybe<FactSheetCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFactSheetGridArgs = {
  where?: Maybe<FactSheetGridWhereInput>;
  orderBy?: Maybe<FactSheetGridOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFactSheetListArgs = {
  parameters?: Maybe<Scalars['String']>;
};


export type QueryFactSheetsByLocationArgs = {
  parameters?: Maybe<Scalars['String']>;
};


export type QueryFeatureImgArgs = {
  where?: Maybe<FeatureImgWhereInput>;
  orderBy?: Maybe<FeatureImgOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFeatureLogoRowArgs = {
  where?: Maybe<FeatureLogoRowWhereInput>;
  orderBy?: Maybe<FeatureLogoRowOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFigureBlockArgs = {
  where?: Maybe<FigureBlockWhereInput>;
  orderBy?: Maybe<FigureBlockOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFiguresBlockArgs = {
  where?: Maybe<FiguresBlockWhereInput>;
  orderBy?: Maybe<FiguresBlockOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryFooterArgs = {
  where?: Maybe<FooterWhereInput>;
  orderBy?: Maybe<FooterOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryGenericTagArgs = {
  where?: Maybe<GenericTagWhereInput>;
  orderBy?: Maybe<GenericTagOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryHeroImageArgs = {
  where?: Maybe<HeroImageWhereInput>;
  orderBy?: Maybe<HeroImageOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryHomepageArgs = {
  where?: Maybe<HomepageWhereInput>;
  orderBy?: Maybe<HomepageOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryHomepagebannerArgs = {
  where?: Maybe<HomepagebannerWhereInput>;
  orderBy?: Maybe<HomepagebannerOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryIconBlockArgs = {
  where?: Maybe<IconBlockWhereInput>;
  orderBy?: Maybe<IconBlockOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryIconBlockRowArgs = {
  where?: Maybe<IconBlockRowWhereInput>;
  orderBy?: Maybe<IconBlockRowOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryIframeArgs = {
  where?: Maybe<IframeWhereInput>;
  orderBy?: Maybe<IframeOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImageContentArgs = {
  where?: Maybe<ImageContentWhereInput>;
  orderBy?: Maybe<ImageContentOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImageContentCardGridArgs = {
  where?: Maybe<ImageContentCardGridWhereInput>;
  orderBy?: Maybe<ImageContentCardGridOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImageGalleryCarouselArgs = {
  where?: Maybe<ImageGalleryCarouselWhereInput>;
  orderBy?: Maybe<ImageGalleryCarouselOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImageItemArgs = {
  where?: Maybe<ImageItemWhereInput>;
  orderBy?: Maybe<ImageItemOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImgArticleCardArgs = {
  where?: Maybe<ImgArticleCardWhereInput>;
  orderBy?: Maybe<ImgArticleCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImgCampaignCardArgs = {
  where?: Maybe<ImgCampaignCardWhereInput>;
  orderBy?: Maybe<ImgCampaignCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImgContentBlockArgs = {
  where?: Maybe<ImgContentBlockWhereInput>;
  orderBy?: Maybe<ImgContentBlockOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImgContentCardArgs = {
  where?: Maybe<ImgContentCardWhereInput>;
  orderBy?: Maybe<ImgContentCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImgFactSheetCardArgs = {
  where?: Maybe<ImgFactSheetCardWhereInput>;
  orderBy?: Maybe<ImgFactSheetCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImgGroupArgs = {
  where?: Maybe<ImgGroupWhereInput>;
  orderBy?: Maybe<ImgGroupOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryImgTitleContentCardGroupArgs = {
  where?: Maybe<ImgTitleContentCardGroupWhereInput>;
  orderBy?: Maybe<ImgTitleContentCardGroupOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryInstagramArgs = {
  where?: Maybe<InstagramWhereInput>;
  orderBy?: Maybe<InstagramOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryInstagramContentCarouselArgs = {
  where?: Maybe<InstagramContentCarouselWhereInput>;
  orderBy?: Maybe<InstagramContentCarouselOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryInstagramFeedArgs = {
  where?: Maybe<InstagramFeedWhereInput>;
  orderBy?: Maybe<InstagramFeedOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryInternalFeatureCtaArgs = {
  where?: Maybe<InternalFeatureCtaWhereInput>;
  orderBy?: Maybe<InternalFeatureCtaOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryLocationRegionArgs = {
  where?: Maybe<LocationRegionWhereInput>;
  orderBy?: Maybe<LocationRegionOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryLocationTagArgs = {
  where?: Maybe<LocationTagWhereInput>;
  orderBy?: Maybe<LocationTagOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryMapCountryArgs = {
  where?: Maybe<MapCountryWhereInput>;
  orderBy?: Maybe<MapCountryOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryMapRegionArgs = {
  where?: Maybe<MapRegionWhereInput>;
  orderBy?: Maybe<MapRegionOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryMediaAssetsArgs = {
  path?: Maybe<Scalars['String']>;
  includeSubDirectories?: Maybe<Scalars['Boolean']>;
};


export type QueryMediaDownloadCarouselArgs = {
  where?: Maybe<MediaDownloadCarouselWhereInput>;
  orderBy?: Maybe<MediaDownloadCarouselOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryNewsletterArgs = {
  where?: Maybe<NewsletterWhereInput>;
  orderBy?: Maybe<NewsletterOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageAboutUsArgs = {
  where?: Maybe<PageAboutUsWhereInput>;
  orderBy?: Maybe<PageAboutUsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageActNowArgs = {
  where?: Maybe<PageActNowWhereInput>;
  orderBy?: Maybe<PageActNowOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageCardArgs = {
  where?: Maybe<PageCardWhereInput>;
  orderBy?: Maybe<PageCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageChallengesArgs = {
  where?: Maybe<PageChallengesWhereInput>;
  orderBy?: Maybe<PageChallengesOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageContactUsArgs = {
  where?: Maybe<PageContactUsWhereInput>;
  orderBy?: Maybe<PageContactUsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageDefinitionsArgs = {
  where?: Maybe<PageDefinitionsWhereInput>;
  orderBy?: Maybe<PageDefinitionsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageDonateArgs = {
  where?: Maybe<PageDonateWhereInput>;
  orderBy?: Maybe<PageDonateOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageEqualRightsArgs = {
  where?: Maybe<PageEqualRightsWhereInput>;
  orderBy?: Maybe<PageEqualRightsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageFaqsArgs = {
  where?: Maybe<PageFaqsWhereInput>;
  orderBy?: Maybe<PageFaqsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageGeneralContentArgs = {
  where?: Maybe<PageGeneralContentWhereInput>;
  orderBy?: Maybe<PageGeneralContentOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageKnowTheFactsArgs = {
  where?: Maybe<PageKnowTheFactsWhereInput>;
  orderBy?: Maybe<PageKnowTheFactsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageNewsletterArgs = {
  where?: Maybe<PageNewsletterWhereInput>;
  orderBy?: Maybe<PageNewsletterOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageOurCampaignsArgs = {
  where?: Maybe<PageOurCampaignsWhereInput>;
  orderBy?: Maybe<PageOurCampaignsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageOurWorkArgs = {
  where?: Maybe<PageOurWorkWhereInput>;
  orderBy?: Maybe<PageOurWorkOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageResourcesArgs = {
  where?: Maybe<PageResourcesWhereInput>;
  orderBy?: Maybe<PageResourcesOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageRightToLoveArgs = {
  where?: Maybe<PageRightToLoveWhereInput>;
  orderBy?: Maybe<PageRightToLoveOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageUpdatesArgs = {
  where?: Maybe<PageUpdatesWhereInput>;
  orderBy?: Maybe<PageUpdatesOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryPageWhatWeDoArgs = {
  where?: Maybe<PageWhatWeDoWhereInput>;
  orderBy?: Maybe<PageWhatWeDoOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryRelatedArticlesArgs = {
  where?: Maybe<RelatedArticlesWhereInput>;
  orderBy?: Maybe<RelatedArticlesOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryRelatedCampaignsArgs = {
  where?: Maybe<RelatedCampaignsWhereInput>;
  orderBy?: Maybe<RelatedCampaignsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryRelatedFactSheetsArgs = {
  where?: Maybe<RelatedFactSheetsWhereInput>;
  orderBy?: Maybe<RelatedFactSheetsOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySimpleAccordionArgs = {
  where?: Maybe<SimpleAccordionWhereInput>;
  orderBy?: Maybe<SimpleAccordionOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySimpleAccordionGroupArgs = {
  where?: Maybe<SimpleAccordionGroupWhereInput>;
  orderBy?: Maybe<SimpleAccordionGroupOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySimpleContentBlockArgs = {
  where?: Maybe<SimpleContentBlockWhereInput>;
  orderBy?: Maybe<SimpleContentBlockOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySimpleContentCardArgs = {
  where?: Maybe<SimpleContentCardWhereInput>;
  orderBy?: Maybe<SimpleContentCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySimpleContentGridArgs = {
  where?: Maybe<SimpleContentGridWhereInput>;
  orderBy?: Maybe<SimpleContentGridOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySimplePageCardCarouselArgs = {
  where?: Maybe<SimplePageCardCarouselWhereInput>;
  orderBy?: Maybe<SimplePageCardCarouselOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySocialContentCardArgs = {
  where?: Maybe<SocialContentCardWhereInput>;
  orderBy?: Maybe<SocialContentCardOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySocialPlatformArgs = {
  where?: Maybe<SocialPlatformWhereInput>;
  orderBy?: Maybe<SocialPlatformOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySubheaderArgs = {
  where?: Maybe<SubheaderWhereInput>;
  orderBy?: Maybe<SubheaderOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QuerySubscriptionArgs = {
  where?: Maybe<SubscriptionWhereInput>;
  orderBy?: Maybe<SubscriptionOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryTaxonomyArgs = {
  where?: Maybe<TaxonomyWhereInput>;
  orderBy?: Maybe<TaxonomyOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryUnfeContentItemArgs = {
  where?: Maybe<UnfeContentItemWhereInput>;
  orderBy?: Maybe<UnfeContentItemOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryUnfeHomePageArgs = {
  where?: Maybe<UnfeHomePageWhereInput>;
  orderBy?: Maybe<UnfeHomePageOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryUnfeMapArgs = {
  where?: Maybe<UnfeMapWhereInput>;
  orderBy?: Maybe<UnfeMapOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryUnfeNavigationArgs = {
  where?: Maybe<UnfeNavigationWhereInput>;
  orderBy?: Maybe<UnfeNavigationOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryUnfeNavItemArgs = {
  where?: Maybe<UnfeNavItemWhereInput>;
  orderBy?: Maybe<UnfeNavItemOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type QueryYoutubeVideoArgs = {
  where?: Maybe<YoutubeVideoWhereInput>;
  orderBy?: Maybe<YoutubeVideoOrderByInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
};


export type SectionIntro = {
  __typename?: 'SectionIntro';
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type SiteCulture = {
  __typename?: 'SiteCulture';
  /** The culture code. */
  culture?: Maybe<Scalars['String']>;
  /** Whether this is the default culture. */
  default?: Maybe<Scalars['Boolean']>;
};

/** publication status */
export enum Status {
  /** published content item version */
  Published = 'PUBLISHED',
  /** draft content item version */
  Draft = 'DRAFT',
  /** the latest version, either published or draft */
  Latest = 'LATEST',
  /** all historical versions */
  All = 'ALL'
}

/** Represents a Taxonomy. */
export type Taxonomy = ContentItem & {
  __typename?: 'Taxonomy';
  /** Alternative path for the content item */
  alias?: Maybe<AliasPart>;
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  taxonomy?: Maybe<TaxonomyPart>;
};

export type TaxonomyField = {
  __typename?: 'TaxonomyField';
  /** the taxonomy content item */
  taxonomyContentItem?: Maybe<ContentItem>;
  /** taxonomy content item id */
  taxonomyContentItemId?: Maybe<Scalars['String']>;
  /** term content item ids */
  termContentItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the term content items */
  termContentItems?: Maybe<Array<Maybe<ContentItem>>>;
};


export type TaxonomyFieldTermContentItemIdsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type TaxonomyFieldTermContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

export type TaxonomyOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

export type TaxonomyPart = {
  __typename?: 'TaxonomyPart';
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
  termContentType: Scalars['String'];
};


export type TaxonomyPartContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

/** the Taxonomy content item filters */
export type TaxonomyWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<TaxonomyWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<TaxonomyWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<TaxonomyWhereInput>>>;
  /** the alias part of the content item */
  alias?: Maybe<AliasPartInput>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
};

/** Represents a Accordion. */
export type Accordion = ContentItem & {
  __typename?: 'accordion';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

/** Represents a Complex accordion group (with related items). */
export type AccordionGroup = ContentItem & {
  __typename?: 'accordionGroup';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type AccordionGroupOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the accordionGroup content item filters */
export type AccordionGroupWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<AccordionGroupWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<AccordionGroupWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<AccordionGroupWhereInput>>>;
};

export type AccordionOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the accordion content item filters */
export type AccordionWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<AccordionWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<AccordionWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<AccordionWhereInput>>>;
};

/** Represents a Article. */
export type Article = ContentItem & {
  __typename?: 'article';
  /** A BagPart allows to add content items directly within another content item */
  articleVideo?: Maybe<BagPart>;
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Date field */
  date?: Maybe<Scalars['Date']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  galleryCarousel?: Maybe<BagPart>;
  /** Content stored as HTML. */
  htmlBody?: Maybe<HtmlBodyPart>;
  /** Boolean field */
  isFeature?: Maybe<Scalars['Boolean']>;
  /** Text field */
  keywords?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** TaxonomyField */
  locations?: Maybe<TaxonomyField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  relatedContent?: Maybe<BagPart>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
  /** TaxonomyField */
  tags?: Maybe<TaxonomyField>;
  /** MediaField */
  thumbnail?: Maybe<MediaField>;
};

/** Represents a Card - Article. */
export type ArticleCard = ContentItem & {
  __typename?: 'articleCard';
  /** ContentPickerField */
  article?: Maybe<ContentPickerField>;
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type ArticleCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the articleCard content item filters */
export type ArticleCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ArticleCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ArticleCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ArticleCardWhereInput>>>;
};

export type ArticleOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the article content item filters */
export type ArticleWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ArticleWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ArticleWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ArticleWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a banner. */
export type Banner = ContentItem & {
  __typename?: 'banner';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  label?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  subtitle?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type BannerOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the banner content item filters */
export type BannerWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<BannerWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<BannerWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<BannerWhereInput>>>;
};

/** Represents a Campaign. */
export type Campaign = ContentItem & {
  __typename?: 'campaign';
  /** The author of the content item */
  author: Scalars['String'];
  /** A BagPart allows to add content items directly within another content item */
  components?: Maybe<BagPart>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Date field */
  date?: Maybe<Scalars['Date']>;
  /** Text field */
  description?: Maybe<Scalars['String']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Represents a externalContent. */
  externalContent?: Maybe<ExternalContent>;
  /** Boolean field */
  isFeature?: Maybe<Scalars['Boolean']>;
  /** Text field */
  keywords?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** TaxonomyField */
  locations?: Maybe<TaxonomyField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
  /** TaxonomyField */
  tags?: Maybe<TaxonomyField>;
  /** MediaField */
  thumbnail?: Maybe<MediaField>;
};

/** Represents a Card - Campaign. */
export type CampaignCard = ContentItem & {
  __typename?: 'campaignCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** ContentPickerField */
  campaign?: Maybe<ContentPickerField>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type CampaignCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the campaignCard content item filters */
export type CampaignCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<CampaignCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<CampaignCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<CampaignCardWhereInput>>>;
};

export type CampaignOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the campaign content item filters */
export type CampaignWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<CampaignWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<CampaignWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<CampaignWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Content block - HTML . */
export type Content = ContentItem & {
  __typename?: 'content';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** the HTML content */
  html?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
};

/** Represents a Card - Content external link. */
export type ContentExternalLinkCard = ContentItem & {
  __typename?: 'contentExternalLinkCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** LinkField */
  link?: Maybe<LinkField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  newTab?: Maybe<Scalars['Boolean']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type ContentExternalLinkCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the contentExternalLinkCard content item filters */
export type ContentExternalLinkCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ContentExternalLinkCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ContentExternalLinkCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ContentExternalLinkCardWhereInput>>>;
};

/** Represents a Content block - Feature introduction. */
export type ContentIntro = ContentItem & {
  __typename?: 'contentIntro';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Boolean field */
  isLanding?: Maybe<Scalars['Boolean']>;
  /** Text field */
  label?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** ContentPickerField */
  links?: Maybe<ContentPickerField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type ContentIntroOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the contentIntro content item filters */
export type ContentIntroWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ContentIntroWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ContentIntroWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ContentIntroWhereInput>>>;
};

export type ContentOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** Represents a Content block - Content page cards. */
export type ContentPageCards = ContentItem & {
  __typename?: 'contentPageCards';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

/** Represents a Content block List- Content Page card. */
export type ContentPageCardsGroup = ContentItem & {
  __typename?: 'contentPageCardsGroup';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type ContentPageCardsGroupOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the contentPageCardsGroup content item filters */
export type ContentPageCardsGroupWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ContentPageCardsGroupWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ContentPageCardsGroupWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ContentPageCardsGroupWhereInput>>>;
};

export type ContentPageCardsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the contentPageCards content item filters */
export type ContentPageCardsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ContentPageCardsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ContentPageCardsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ContentPageCardsWhereInput>>>;
};

/** the content content item filters */
export type ContentWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ContentWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ContentWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ContentWhereInput>>>;
};

/** Represents a UNFE Country. */
export type Country = ContentItem & {
  __typename?: 'country';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** TaxonomyField */
  locations?: Maybe<TaxonomyField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  name?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type CountryOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the country content item filters */
export type CountryWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<CountryWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<CountryWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<CountryWhereInput>>>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Item - Definition. */
export type DefinitionItem = ContentItem & {
  __typename?: 'definitionItem';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type DefinitionItemOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the definitionItem content item filters */
export type DefinitionItemWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<DefinitionItemWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<DefinitionItemWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<DefinitionItemWhereInput>>>;
};

/** Represents a Document . */
export type DownloadCard = ContentItem & {
  __typename?: 'downloadCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  file?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type DownloadCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the downloadCard content item filters */
export type DownloadCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<DownloadCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<DownloadCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<DownloadCardWhereInput>>>;
};

/** Represents a Grid - Download document . */
export type DownloadGrid = ContentItem & {
  __typename?: 'downloadGrid';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** ContentPickerField */
  items?: Maybe<ContentPickerField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type DownloadGridOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the downloadGrid content item filters */
export type DownloadGridWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<DownloadGridWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<DownloadGridWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<DownloadGridWhereInput>>>;
};

/** Represents a Download -  Media. */
export type DownloadMediaCard = ContentItem & {
  __typename?: 'downloadMediaCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** MediaField */
  bgImg?: Maybe<MediaField>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** MediaField */
  media?: Maybe<MediaField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type DownloadMediaCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the downloadMediaCard content item filters */
export type DownloadMediaCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<DownloadMediaCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<DownloadMediaCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<DownloadMediaCardWhereInput>>>;
};

export type ExternalContent = {
  __typename?: 'externalContent';
  /** Text field */
  externalUrl?: Maybe<Scalars['String']>;
  /** Boolean field */
  isExternal?: Maybe<Scalars['Boolean']>;
};

/** Represents a Content block - External Feature CTA. */
export type ExternalFeatureCta = ContentItem & {
  __typename?: 'externalFeatureCta';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** LinkField */
  link?: Maybe<LinkField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** Boolean field */
  newTab?: Maybe<Scalars['Boolean']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type ExternalFeatureCtaOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the externalFeatureCta content item filters */
export type ExternalFeatureCtaWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ExternalFeatureCtaWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ExternalFeatureCtaWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ExternalFeatureCtaWhereInput>>>;
};

/** Represents a Content block - External link cards. */
export type ExternalLinkCardGroup = ContentItem & {
  __typename?: 'externalLinkCardGroup';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Content stored as HTML. */
  htmlBody?: Maybe<HtmlBodyPart>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type ExternalLinkCardGroupOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the externalLinkCardGroup content item filters */
export type ExternalLinkCardGroupWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ExternalLinkCardGroupWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ExternalLinkCardGroupWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ExternalLinkCardGroupWhereInput>>>;
};

/** Represents a Fact Sheet. */
export type FactSheet = ContentItem & {
  __typename?: 'factSheet';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  description?: Maybe<Scalars['String']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  faqs?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureContent?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureImage?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  figuresBlock?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  htmlContent?: Maybe<BagPart>;
  /** Text field */
  keywords?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** TaxonomyField */
  locations?: Maybe<TaxonomyField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  relatedContent?: Maybe<BagPart>;
  render?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  secondHmlcontent?: Maybe<BagPart>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
  /** TaxonomyField */
  tags?: Maybe<TaxonomyField>;
  /** MediaField */
  thumbnail?: Maybe<MediaField>;
  /** Represents a toolbar. */
  toolbar?: Maybe<Toolbar>;
};

/** Represents a Card - Fact sheet. */
export type FactSheetCard = ContentItem & {
  __typename?: 'factSheetCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** ContentPickerField */
  factSheet?: Maybe<ContentPickerField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type FactSheetCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the factSheetCard content item filters */
export type FactSheetCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FactSheetCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FactSheetCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FactSheetCardWhereInput>>>;
};

/** Represents a Grid - Fact sheets. */
export type FactSheetGrid = ContentItem & {
  __typename?: 'factSheetGrid';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type FactSheetGridOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the factSheetGrid content item filters */
export type FactSheetGridWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FactSheetGridWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FactSheetGridWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FactSheetGridWhereInput>>>;
};

export type FactSheetOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the factSheet content item filters */
export type FactSheetWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FactSheetWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FactSheetWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FactSheetWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Image - Feature Image. */
export type FeatureImg = ContentItem & {
  __typename?: 'featureImg';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  caption?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  img?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type FeatureImgOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the featureImg content item filters */
export type FeatureImgWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FeatureImgWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FeatureImgWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FeatureImgWhereInput>>>;
};

/** Represents a Feature logo row. */
export type FeatureLogoRow = ContentItem & {
  __typename?: 'featureLogoRow';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type FeatureLogoRowOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the featureLogoRow content item filters */
export type FeatureLogoRowWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FeatureLogoRowWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FeatureLogoRowWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FeatureLogoRowWhereInput>>>;
};

/** Represents a Item- Figure. */
export type FigureBlock = ContentItem & {
  __typename?: 'figureBlock';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  unit?: Maybe<Scalars['String']>;
  /** Text field */
  value?: Maybe<Scalars['String']>;
};

export type FigureBlockOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the figureBlock content item filters */
export type FigureBlockWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FigureBlockWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FigureBlockWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FigureBlockWhereInput>>>;
};

/** Represents a Carousel - Figures. */
export type FiguresBlock = ContentItem & {
  __typename?: 'figuresBlock';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type FiguresBlockOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the figuresBlock content item filters */
export type FiguresBlockWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FiguresBlockWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FiguresBlockWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FiguresBlockWhereInput>>>;
};

/** Represents a Footer. */
export type Footer = ContentItem & {
  __typename?: 'footer';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  footerText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** ContentPickerField */
  pages?: Maybe<ContentPickerField>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type FooterOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the footer content item filters */
export type FooterWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<FooterWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<FooterWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<FooterWhereInput>>>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Image - Hero. */
export type HeroImage = ContentItem & {
  __typename?: 'heroImage';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  img?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type HeroImageOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the heroImage content item filters */
export type HeroImageWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<HeroImageWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<HeroImageWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<HeroImageWhereInput>>>;
};

/** Represents a Home page. */
export type Homepage = ContentItem & {
  __typename?: 'homepage';
  /** The author of the content item */
  author: Scalars['String'];
  /** A BagPart allows to add content items directly within another content item */
  colourCardRow?: Maybe<BagPart>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  homeBanner?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  homeFeatureIntro?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  homeImgContentCard?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  homeImgGroup?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  instagramCarousel?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type HomepageOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the homepage content item filters */
export type HomepageWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<HomepageWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<HomepageWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<HomepageWhereInput>>>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Item - Icon content. */
export type IconBlock = ContentItem & {
  __typename?: 'iconBlock';
  /** The author of the content item */
  author: Scalars['String'];
  /** MediaField */
  bgImg?: Maybe<MediaField>;
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type IconBlockOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the iconBlock content item filters */
export type IconBlockWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<IconBlockWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<IconBlockWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<IconBlockWhereInput>>>;
};

/** Represents a Iframe. */
export type Iframe = ContentItem & {
  __typename?: 'iframe';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  description?: Maybe<Scalars['String']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  embedCode?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type IframeOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the iframe content item filters */
export type IframeWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<IframeWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<IframeWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<IframeWhereInput>>>;
};

/** Represents a Content block - Image content. */
export type ImageContent = ContentItem & {
  __typename?: 'imageContent';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** MediaField */
  thumbnail?: Maybe<MediaField>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

/** Represents a Grid - Image content cards. */
export type ImageContentCardGrid = ContentItem & {
  __typename?: 'imageContentCardGrid';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type ImageContentCardGridOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imageContentCardGrid content item filters */
export type ImageContentCardGridWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImageContentCardGridWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImageContentCardGridWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImageContentCardGridWhereInput>>>;
};

export type ImageContentOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imageContent content item filters */
export type ImageContentWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImageContentWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImageContentWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImageContentWhereInput>>>;
};

/** Represents a Carousel - Image Gallery. */
export type ImageGalleryCarousel = ContentItem & {
  __typename?: 'imageGalleryCarousel';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type ImageGalleryCarouselOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imageGalleryCarousel content item filters */
export type ImageGalleryCarouselWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImageGalleryCarouselWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImageGalleryCarouselWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImageGalleryCarouselWhereInput>>>;
};

/** Represents a Image  - item (title , caption, description). */
export type ImageItem = ContentItem & {
  __typename?: 'imageItem';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  caption?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  description?: Maybe<Scalars['String']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  img?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type ImageItemOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imageItem content item filters */
export type ImageItemWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImageItemWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImageItemWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImageItemWhereInput>>>;
};

/** Represents a Feature card - Image article card. */
export type ImgArticleCard = ContentItem & {
  __typename?: 'imgArticleCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  displayShadow?: Maybe<Scalars['Boolean']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  imgAlignment?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** ContentPickerField */
  page?: Maybe<ContentPickerField>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type ImgArticleCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imgArticleCard content item filters */
export type ImgArticleCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImgArticleCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImgArticleCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImgArticleCardWhereInput>>>;
};

/** Represents a Feature card - Image campaign card. */
export type ImgCampaignCard = ContentItem & {
  __typename?: 'imgCampaignCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  displayShadow?: Maybe<Scalars['Boolean']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  imgAlignment?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** ContentPickerField */
  page?: Maybe<ContentPickerField>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type ImgCampaignCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imgCampaignCard content item filters */
export type ImgCampaignCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImgCampaignCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImgCampaignCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImgCampaignCardWhereInput>>>;
};

/** Represents a Feature card - Image content card. */
export type ImgContentBlock = ContentItem & {
  __typename?: 'imgContentBlock';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  displayShadow?: Maybe<Scalars['Boolean']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  img?: Maybe<MediaField>;
  /** Text field */
  imgAlignment?: Maybe<Scalars['String']>;
  /** Text field */
  label?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** LinkField */
  link?: Maybe<LinkField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  newTab?: Maybe<Scalars['Boolean']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type ImgContentBlockOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imgContentBlock content item filters */
export type ImgContentBlockWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImgContentBlockWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImgContentBlockWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImgContentBlockWhereInput>>>;
};

/** Represents a Feature card - Image page card. */
export type ImgContentCard = ContentItem & {
  __typename?: 'imgContentCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  displayShadow?: Maybe<Scalars['Boolean']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  imgAlignment?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** ContentPickerField */
  page?: Maybe<ContentPickerField>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type ImgContentCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imgContentCard content item filters */
export type ImgContentCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImgContentCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImgContentCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImgContentCardWhereInput>>>;
};

/** Represents a Feature card - Image fact sheet card. */
export type ImgFactSheetCard = ContentItem & {
  __typename?: 'imgFactSheetCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  displayShadow?: Maybe<Scalars['Boolean']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  imgAlignment?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** ContentPickerField */
  page?: Maybe<ContentPickerField>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type ImgFactSheetCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imgFactSheetCard content item filters */
export type ImgFactSheetCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImgFactSheetCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImgFactSheetCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImgFactSheetCardWhereInput>>>;
};

/** Represents a Grid - Image group. */
export type ImgGroup = ContentItem & {
  __typename?: 'imgGroup';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  imgs?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type ImgGroupOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the imgGroup content item filters */
export type ImgGroupWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<ImgGroupWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<ImgGroupWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<ImgGroupWhereInput>>>;
};

/** Represents a Instagram. */
export type Instagram = ContentItem & {
  __typename?: 'instagram';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  token?: Maybe<Scalars['String']>;
};


/** Represents a Instagram. */
export type InstagramContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

/** Represents a Carousel - Instagram. */
export type InstagramContentCarousel = ContentItem & {
  __typename?: 'instagramContentCarousel';
  /** Text field */
  account?: Maybe<Scalars['String']>;
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type InstagramContentCarouselOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the instagramContentCarousel content item filters */
export type InstagramContentCarouselWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<InstagramContentCarouselWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<InstagramContentCarouselWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<InstagramContentCarouselWhereInput>>>;
};

/** Represents a Instagram feed. */
export type InstagramFeed = ContentItem & {
  __typename?: 'instagramFeed';
  /** Text field */
  alt?: Maybe<Scalars['String']>;
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Text field */
  mediaType?: Maybe<Scalars['String']>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  url?: Maybe<Scalars['String']>;
};

export type InstagramFeedOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the instagramFeed content item filters */
export type InstagramFeedWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<InstagramFeedWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<InstagramFeedWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<InstagramFeedWhereInput>>>;
};

export type InstagramOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the instagram content item filters */
export type InstagramWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<InstagramWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<InstagramWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<InstagramWhereInput>>>;
};

/** Represents a Content block - Internal Feature CTA. */
export type InternalFeatureCta = ContentItem & {
  __typename?: 'internalFeatureCta';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** ContentPickerField */
  link?: Maybe<ContentPickerField>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type InternalFeatureCtaOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the internalFeatureCta content item filters */
export type InternalFeatureCtaWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<InternalFeatureCtaWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<InternalFeatureCtaWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<InternalFeatureCtaWhereInput>>>;
};

/** Represents a UNFE Region. */
export type LocationRegion = ContentItem & {
  __typename?: 'locationRegion';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  name?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  value?: Maybe<Scalars['String']>;
};

export type LocationRegionOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the locationRegion content item filters */
export type LocationRegionWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<LocationRegionWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<LocationRegionWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<LocationRegionWhereInput>>>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Map - Country. */
export type MapCountry = ContentItem & {
  __typename?: 'mapCountry';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** ContentPickerField */
  country?: Maybe<ContentPickerField>;
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  img?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  subTitle?: Maybe<Scalars['String']>;
};

export type MapCountryOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the mapCountry content item filters */
export type MapCountryWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<MapCountryWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<MapCountryWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<MapCountryWhereInput>>>;
};

/** Represents a Map - Region. */
export type MapRegion = ContentItem & {
  __typename?: 'mapRegion';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** A BagPart allows to add content items directly within another content item */
  countries?: Maybe<BagPart>;
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** ContentPickerField */
  region?: Maybe<ContentPickerField>;
  render?: Maybe<Scalars['String']>;
};

export type MapRegionOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the mapRegion content item filters */
export type MapRegionWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<MapRegionWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<MapRegionWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<MapRegionWhereInput>>>;
};

/** Represents a Carousel - Media Download . */
export type MediaDownloadCarousel = ContentItem & {
  __typename?: 'mediaDownloadCarousel';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type MediaDownloadCarouselOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the mediaDownloadCarousel content item filters */
export type MediaDownloadCarouselWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<MediaDownloadCarouselWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<MediaDownloadCarouselWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<MediaDownloadCarouselWhereInput>>>;
};

/** Represents a Newsletter. */
export type Newsletter = ContentItem & {
  __typename?: 'newsletter';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  description?: Maybe<Scalars['String']>;
  /** Text field */
  disclaimer?: Maybe<Scalars['String']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  submit?: Maybe<Scalars['String']>;
};

export type NewsletterOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the newsletter content item filters */
export type NewsletterWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<NewsletterWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<NewsletterWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<NewsletterWhereInput>>>;
};

/** Represents a page template - About us. */
export type PageAboutUs = ContentItem & {
  __typename?: 'pageAboutUs';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  featureLogoRow?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  imgContentCardGroup?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageAboutUsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageAboutUs content item filters */
export type PageAboutUsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageAboutUsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageAboutUsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageAboutUsWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - Act now. */
export type PageActNow = ContentItem & {
  __typename?: 'pageActNow';
  /** A BagPart allows to add content items directly within another content item */
  actContentCardCarousel?: Maybe<BagPart>;
  /** The author of the content item */
  author: Scalars['String'];
  /** A BagPart allows to add content items directly within another content item */
  contentBlockCard?: Maybe<BagPart>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  featureCards?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  socialContentCol?: Maybe<BagPart>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageActNowOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageActNow content item filters */
export type PageActNowWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageActNowWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageActNowWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageActNowWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Card - Page. */
export type PageCard = ContentItem & {
  __typename?: 'pageCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** ContentPickerField */
  page?: Maybe<ContentPickerField>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type PageCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageCard content item filters */
export type PageCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageCardWhereInput>>>;
};

/** Represents a page template - Challenges & Solutions. */
export type PageChallenges = ContentItem & {
  __typename?: 'pageChallenges';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  factSheetsGrid?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureCards?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureImg?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  greyContentRow?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageChallengesOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageChallenges content item filters */
export type PageChallengesWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageChallengesWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageChallengesWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageChallengesWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - Contact us. */
export type PageContactUs = ContentItem & {
  __typename?: 'pageContactUs';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  externalLinkContentBlock?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  smallCardContentGroup?: Maybe<BagPart>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageContactUsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageContactUs content item filters */
export type PageContactUsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageContactUsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageContactUsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageContactUsWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page templates - Definitions. */
export type PageDefinitions = ContentItem & {
  __typename?: 'pageDefinitions';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  definitionItemGroup?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  featureCards?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageDefinitionsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageDefinitions content item filters */
export type PageDefinitionsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageDefinitionsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageDefinitionsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageDefinitionsWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - Donate. */
export type PageDonate = ContentItem & {
  __typename?: 'pageDonate';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  donateIconBlockRow?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureCards?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureCtaGroup?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageDonateOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageDonate content item filters */
export type PageDonateWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageDonateWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageDonateWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageDonateWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - History of equal rights. */
export type PageEqualRights = ContentItem & {
  __typename?: 'pageEqualRights';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** A BagPart allows to add content items directly within another content item */
  map?: Maybe<BagPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageEqualRightsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageEqualRights content item filters */
export type PageEqualRightsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageEqualRightsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageEqualRightsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageEqualRightsWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - FAQs. */
export type PageFaqs = ContentItem & {
  __typename?: 'pageFaqs';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  faqs?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
  /** A BagPart allows to add content items directly within another content item */
  termBlockRow?: Maybe<BagPart>;
};

export type PageFaqsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageFaqs content item filters */
export type PageFaqsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageFaqsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageFaqsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageFaqsWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - General content. */
export type PageGeneralContent = ContentItem & {
  __typename?: 'pageGeneralContent';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Content stored as HTML. */
  htmlBody?: Maybe<HtmlBodyPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageGeneralContentOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageGeneralContent content item filters */
export type PageGeneralContentWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageGeneralContentWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageGeneralContentWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageGeneralContentWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - Know the facts. */
export type PageKnowTheFacts = ContentItem & {
  __typename?: 'pageKnowTheFacts';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  featureCards?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureImg?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  figureBlockCarousel?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  ktfGreyContentRow?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageKnowTheFactsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageKnowTheFacts content item filters */
export type PageKnowTheFactsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageKnowTheFactsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageKnowTheFactsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageKnowTheFactsWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Page template - Newsletter. */
export type PageNewsletter = ContentItem & {
  __typename?: 'pageNewsletter';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  newsletterForm?: Maybe<BagPart>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type PageNewsletterOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageNewsletter content item filters */
export type PageNewsletterWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageNewsletterWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageNewsletterWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageNewsletterWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - Our campaigns. */
export type PageOurCampaigns = ContentItem & {
  __typename?: 'pageOurCampaigns';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Represents a GridSettings. */
  gridSettings?: Maybe<GridSettings>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageOurCampaignsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageOurCampaigns content item filters */
export type PageOurCampaignsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageOurCampaignsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageOurCampaignsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageOurCampaignsWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - Our work. */
export type PageOurWork = ContentItem & {
  __typename?: 'pageOurWork';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  downloadGrid?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureContentCard?: Maybe<BagPart>;
  /** A BagPart allows to add content items directly within another content item */
  featureImg?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** A BagPart allows to add content items directly within another content item */
  map?: Maybe<BagPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageOurWorkOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageOurWork content item filters */
export type PageOurWorkWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageOurWorkWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageOurWorkWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageOurWorkWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - UN Resources. */
export type PageResources = ContentItem & {
  __typename?: 'pageResources';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageResourcesOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageResources content item filters */
export type PageResourcesWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageResourcesWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageResourcesWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageResourcesWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - History of the right to love. */
export type PageRightToLove = ContentItem & {
  __typename?: 'pageRightToLove';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  featureImg?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  iframe?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageRightToLoveOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageRightToLove content item filters */
export type PageRightToLoveWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageRightToLoveWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageRightToLoveWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageRightToLoveWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - Updates. */
export type PageUpdates = ContentItem & {
  __typename?: 'pageUpdates';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  discoverMore?: Maybe<BagPart>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  featureArticle?: Maybe<BagPart>;
  /** Represents a GridSettings. */
  gridSettings?: Maybe<GridSettings>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
};

export type PageUpdatesOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageUpdates content item filters */
export type PageUpdatesWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageUpdatesWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageUpdatesWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageUpdatesWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a page template - What we do. */
export type PageWhatWeDo = ContentItem & {
  __typename?: 'pageWhatWeDo';
  /** The author of the content item */
  author: Scalars['String'];
  /** A BagPart allows to add content items directly within another content item */
  campaignCarousel?: Maybe<BagPart>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  downloadGrid?: Maybe<BagPart>;
  /** Text field */
  identifier?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  imgTitleContentCardGroup?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Represents a PageMetaData. */
  pageMetaData?: Maybe<PageMetaData>;
  /** The permalinks for your content item. */
  path: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a subscriptionBlock. */
  subscriptionBlock?: Maybe<SubscriptionBlock>;
  /** A BagPart allows to add content items directly within another content item */
  whatWeDoFeatureCards?: Maybe<BagPart>;
};

export type PageWhatWeDoOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the pageWhatWeDo content item filters */
export type PageWhatWeDoWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<PageWhatWeDoWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<PageWhatWeDoWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<PageWhatWeDoWhereInput>>>;
  /** the path of the content item to filter is equal to */
  path?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is not equal to */
  path_not?: Maybe<Scalars['String']>;
  /** the path of the content item to filter is in collection */
  path_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter is not in collection */
  path_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the path of the content item to filter contains the string */
  path_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not contain the string */
  path_not_contains?: Maybe<Scalars['String']>;
  /** the path of the content item to filter starts with the string */
  path_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not start with the string */
  path_not_starts_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter ends with the string */
  path_ends_with?: Maybe<Scalars['String']>;
  /** the path of the content item to filter does not end with the string */
  path_not_ends_with?: Maybe<Scalars['String']>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Related Articles. */
export type RelatedArticles = ContentItem & {
  __typename?: 'relatedArticles';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type RelatedArticlesOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the relatedArticles content item filters */
export type RelatedArticlesWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<RelatedArticlesWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<RelatedArticlesWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<RelatedArticlesWhereInput>>>;
};

/** Represents a Related Campaigns. */
export type RelatedCampaigns = ContentItem & {
  __typename?: 'relatedCampaigns';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type RelatedCampaignsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the relatedCampaigns content item filters */
export type RelatedCampaignsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<RelatedCampaignsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<RelatedCampaignsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<RelatedCampaignsWhereInput>>>;
};

/** Represents a Related Fact sheets. */
export type RelatedFactSheets = ContentItem & {
  __typename?: 'relatedFactSheets';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type RelatedFactSheetsOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the relatedFactSheets content item filters */
export type RelatedFactSheetsWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<RelatedFactSheetsWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<RelatedFactSheetsWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<RelatedFactSheetsWhereInput>>>;
};

/** Represents a Accordion - Simple. */
export type SimpleAccordion = ContentItem & {
  __typename?: 'simpleAccordion';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

/** Represents a Accordion Group - Simple. */
export type SimpleAccordionGroup = ContentItem & {
  __typename?: 'simpleAccordionGroup';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
};

export type SimpleAccordionGroupOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the simpleAccordionGroup content item filters */
export type SimpleAccordionGroupWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SimpleAccordionGroupWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SimpleAccordionGroupWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SimpleAccordionGroupWhereInput>>>;
};

export type SimpleAccordionOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the simpleAccordion content item filters */
export type SimpleAccordionWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SimpleAccordionWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SimpleAccordionWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SimpleAccordionWhereInput>>>;
};

/** Represents a Content block - simple content. */
export type SimpleContentBlock = ContentItem & {
  __typename?: 'simpleContentBlock';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type SimpleContentBlockOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the simpleContentBlock content item filters */
export type SimpleContentBlockWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SimpleContentBlockWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SimpleContentBlockWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SimpleContentBlockWhereInput>>>;
};

/** Represents a Card - Simple content. */
export type SimpleContentCard = ContentItem & {
  __typename?: 'simpleContentCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Text field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type SimpleContentCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the simpleContentCard content item filters */
export type SimpleContentCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SimpleContentCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SimpleContentCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SimpleContentCardWhereInput>>>;
};

/** Represents a Grid - Terms. */
export type SimpleContentGrid = ContentItem & {
  __typename?: 'simpleContentGrid';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  items?: Maybe<BagPart>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
  /** Represents a toolbar. */
  toolbar?: Maybe<Toolbar>;
};

export type SimpleContentGridOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the simpleContentGrid content item filters */
export type SimpleContentGridWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SimpleContentGridWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SimpleContentGridWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SimpleContentGridWhereInput>>>;
};

/** Represents a Carousel - Simple page card . */
export type SimplePageCardCarousel = ContentItem & {
  __typename?: 'simplePageCardCarousel';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** ContentPickerField */
  items?: Maybe<ContentPickerField>;
  /** Text field */
  label?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type SimplePageCardCarouselOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the simplePageCardCarousel content item filters */
export type SimplePageCardCarouselWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SimplePageCardCarouselWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SimplePageCardCarouselWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SimplePageCardCarouselWhereInput>>>;
};

/** Represents a Content block - Social content . */
export type SocialContentCard = ContentItem & {
  __typename?: 'socialContentCard';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Text field */
  label?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type SocialContentCardOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the socialContentCard content item filters */
export type SocialContentCardWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SocialContentCardWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SocialContentCardWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SocialContentCardWhereInput>>>;
};

/** Represents a UNFE Social platform. */
export type SocialPlatform = ContentItem & {
  __typename?: 'socialPlatform';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  type?: Maybe<Scalars['String']>;
  /** Text field */
  url?: Maybe<Scalars['String']>;
};

export type SocialPlatformOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the socialPlatform content item filters */
export type SocialPlatformWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SocialPlatformWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SocialPlatformWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SocialPlatformWhereInput>>>;
};

/** Represents a Sub header. */
export type Subheader = ContentItem & {
  __typename?: 'subheader';
  /** The author of the content item */
  author: Scalars['String'];
  /** Html field */
  content?: Maybe<Scalars['String']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type SubheaderOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the subheader content item filters */
export type SubheaderWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SubheaderWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SubheaderWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SubheaderWhereInput>>>;
};

/** Represents a Subscription. */
export type Subscription = ContentItem & {
  __typename?: 'subscription';
  /** The author of the content item */
  author: Scalars['String'];
  /** Boolean field */
  blank?: Maybe<Scalars['Boolean']>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** LinkField */
  externalLink?: Maybe<LinkField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  text?: Maybe<Scalars['String']>;
  /** Text field */
  title?: Maybe<Scalars['String']>;
};

export type SubscriptionBlock = {
  __typename?: 'subscriptionBlock';
  /** Boolean field */
  displaySubscription?: Maybe<Scalars['Boolean']>;
};

export type SubscriptionOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the subscription content item filters */
export type SubscriptionWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<SubscriptionWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<SubscriptionWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<SubscriptionWhereInput>>>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

export type Toolbar = {
  __typename?: 'toolbar';
  /** MediaField */
  file?: Maybe<MediaField>;
  /** Boolean field */
  share?: Maybe<Scalars['Boolean']>;
};

/** Represents a UNFE Content Item. */
export type UnfeContentItem = ContentItem & {
  __typename?: 'unfeContentItem';
  /** The author of the content item */
  author: Scalars['String'];
  /** ContentPickerField */
  content?: Maybe<ContentPickerField>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type UnfeContentItemOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the unfeContentItem content item filters */
export type UnfeContentItemWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<UnfeContentItemWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<UnfeContentItemWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<UnfeContentItemWhereInput>>>;
};

/** Represents a UNFE home page item. */
export type UnfeHomePage = ContentItem & {
  __typename?: 'unfeHomePage';
  /** The author of the content item */
  author: Scalars['String'];
  /** ContentPickerField */
  content?: Maybe<ContentPickerField>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};

export type UnfeHomePageOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the unfeHomePage content item filters */
export type UnfeHomePageWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<UnfeHomePageWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<UnfeHomePageWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<UnfeHomePageWhereInput>>>;
};

/** Represents a Map. */
export type UnfeMap = ContentItem & {
  __typename?: 'unfeMap';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  displayRelatedItems?: Maybe<Scalars['Boolean']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Boolean field */
  popupIconStyle?: Maybe<Scalars['Boolean']>;
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** A BagPart allows to add content items directly within another content item */
  regions?: Maybe<BagPart>;
  render?: Maybe<Scalars['String']>;
  /** Represents a SectionIntro. */
  sectionIntro?: Maybe<SectionIntro>;
};

export type UnfeMapOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the unfeMap content item filters */
export type UnfeMapWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<UnfeMapWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<UnfeMapWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<UnfeMapWhereInput>>>;
};

/** Represents a UNFE Navigation Item. */
export type UnfeNavItem = ContentItem & {
  __typename?: 'unfeNavItem';
  /** The author of the content item */
  author: Scalars['String'];
  /** ContentPickerField */
  content?: Maybe<ContentPickerField>;
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
  /** A BagPart allows to add content items directly within another content item */
  subNav?: Maybe<BagPart>;
};

export type UnfeNavItemOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the unfeNavItem content item filters */
export type UnfeNavItemWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<UnfeNavItemWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<UnfeNavItemWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<UnfeNavItemWhereInput>>>;
};

/** Represents a UNFE Sitemap. */
export type UnfeNavigation = ContentItem & {
  __typename?: 'unfeNavigation';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** the content items */
  contentItems?: Maybe<Array<Maybe<ContentItem>>>;
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** Localization cultures for your content item. */
  localization?: Maybe<LocalizationPart>;
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  render?: Maybe<Scalars['String']>;
};


/** Represents a UNFE Sitemap. */
export type UnfeNavigationContentItemsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

export type UnfeNavigationOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the unfeNavigation content item filters */
export type UnfeNavigationWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<UnfeNavigationWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<UnfeNavigationWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<UnfeNavigationWhereInput>>>;
  /** the localization part of the content item */
  localization?: Maybe<LocalizationInputObjectType>;
};

/** Represents a Youtube Video. */
export type YoutubeVideo = ContentItem & {
  __typename?: 'youtubeVideo';
  /** The author of the content item */
  author: Scalars['String'];
  /** Content item id */
  contentItemId: Scalars['String'];
  /** The content item version id */
  contentItemVersionId: Scalars['String'];
  /** Type of content */
  contentType: Scalars['String'];
  /** The date and time of creation */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** The display text of the content item */
  displayText?: Maybe<Scalars['String']>;
  /** MediaField */
  img?: Maybe<MediaField>;
  /** Is the latest version */
  latest: Scalars['Boolean'];
  /** The date and time of modification */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** Text field */
  mods?: Maybe<Scalars['String']>;
  /** The owner of the content item */
  owner: Scalars['String'];
  /** Is the published version */
  published: Scalars['Boolean'];
  /** The date and time of publication */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** Boolean field */
  removeBottomSpacing?: Maybe<Scalars['Boolean']>;
  /** Boolean field */
  removeTopSpacing?: Maybe<Scalars['Boolean']>;
  render?: Maybe<Scalars['String']>;
  /** Text field */
  videoId?: Maybe<Scalars['String']>;
};

export type YoutubeVideoOrderByInput = {
  contentItemId?: Maybe<OrderByDirection>;
  contentItemVersionId?: Maybe<OrderByDirection>;
  contentType?: Maybe<OrderByDirection>;
  displayText?: Maybe<OrderByDirection>;
  published?: Maybe<OrderByDirection>;
  latest?: Maybe<OrderByDirection>;
  createdUtc?: Maybe<OrderByDirection>;
  modifiedUtc?: Maybe<OrderByDirection>;
  publishedUtc?: Maybe<OrderByDirection>;
  owner?: Maybe<OrderByDirection>;
  author?: Maybe<OrderByDirection>;
};

/** the youtubeVideo content item filters */
export type YoutubeVideoWhereInput = {
  /** content item id is equal to */
  contentItemId?: Maybe<Scalars['ID']>;
  /** content item id is not equal to */
  contentItemId_not?: Maybe<Scalars['ID']>;
  /** content item id is in collection */
  contentItemId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** content item id is not in collection */
  contentItemId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is equal to */
  contentItemVersionId?: Maybe<Scalars['ID']>;
  /** the content item version id is not equal to */
  contentItemVersionId_not?: Maybe<Scalars['ID']>;
  /** the content item version id is in collection */
  contentItemVersionId_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the content item version id is not in collection */
  contentItemVersionId_not_in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** the display text of the content item is equal to */
  displayText?: Maybe<Scalars['String']>;
  /** the display text of the content item is not equal to */
  displayText_not?: Maybe<Scalars['String']>;
  /** the display text of the content item is in collection */
  displayText_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item is not in collection */
  displayText_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the display text of the content item contains the string */
  displayText_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item does not contain the string */
  displayText_not_contains?: Maybe<Scalars['String']>;
  /** the display text of the content item starts with the string */
  displayText_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not start with the string */
  displayText_not_starts_with?: Maybe<Scalars['String']>;
  /** the display text of the content item ends with the string */
  displayText_ends_with?: Maybe<Scalars['String']>;
  /** the display text of the content item does not end with the string */
  displayText_not_ends_with?: Maybe<Scalars['String']>;
  /** the date and time of creation is equal to */
  createdUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is not equal to */
  createdUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is in collection */
  createdUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is not in collection */
  createdUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of creation is greater than */
  createdUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is greater than or equal */
  createdUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than */
  createdUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of creation is less than or equal */
  createdUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is equal to */
  modifiedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is not equal to */
  modifiedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is in collection */
  modifiedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is not in collection */
  modifiedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of modification is greater than */
  modifiedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is greater than or equal */
  modifiedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than */
  modifiedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of modification is less than or equal */
  modifiedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is equal to */
  publishedUtc?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is not equal to */
  publishedUtc_not?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is in collection */
  publishedUtc_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is not in collection */
  publishedUtc_not_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** the date and time of publication is greater than */
  publishedUtc_gt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is greater than or equal */
  publishedUtc_gte?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than */
  publishedUtc_lt?: Maybe<Scalars['DateTime']>;
  /** the date and time of publication is less than or equal */
  publishedUtc_lte?: Maybe<Scalars['DateTime']>;
  /** the owner of the content item is equal to */
  owner?: Maybe<Scalars['String']>;
  /** the owner of the content item is not equal to */
  owner_not?: Maybe<Scalars['String']>;
  /** the owner of the content item is in collection */
  owner_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item is not in collection */
  owner_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the owner of the content item contains the string */
  owner_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item does not contain the string */
  owner_not_contains?: Maybe<Scalars['String']>;
  /** the owner of the content item starts with the string */
  owner_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not start with the string */
  owner_not_starts_with?: Maybe<Scalars['String']>;
  /** the owner of the content item ends with the string */
  owner_ends_with?: Maybe<Scalars['String']>;
  /** the owner of the content item does not end with the string */
  owner_not_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item is equal to */
  author?: Maybe<Scalars['String']>;
  /** the author of the content item is not equal to */
  author_not?: Maybe<Scalars['String']>;
  /** the author of the content item is in collection */
  author_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item is not in collection */
  author_not_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the author of the content item contains the string */
  author_contains?: Maybe<Scalars['String']>;
  /** the author of the content item does not contain the string */
  author_not_contains?: Maybe<Scalars['String']>;
  /** the author of the content item starts with the string */
  author_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not start with the string */
  author_not_starts_with?: Maybe<Scalars['String']>;
  /** the author of the content item ends with the string */
  author_ends_with?: Maybe<Scalars['String']>;
  /** the author of the content item does not end with the string */
  author_not_ends_with?: Maybe<Scalars['String']>;
  /** OR logical operation */
  OR?: Maybe<Array<Maybe<YoutubeVideoWhereInput>>>;
  /** AND logical operation */
  AND?: Maybe<Array<Maybe<YoutubeVideoWhereInput>>>;
  /** NOT logical operation */
  NOT?: Maybe<Array<Maybe<YoutubeVideoWhereInput>>>;
};

export type SimpleAccordionFragmentFragment = (
  { __typename?: 'simpleAccordion' }
  & Pick<SimpleAccordion, 'contentItemId' | 'content'>
  & { title: SimpleAccordion['displayText'] }
);

export type AccordionFragmentFragment = (
  { __typename?: 'accordion' }
  & Pick<Accordion, 'contentItemId' | 'content'>
  & { title: Accordion['displayText'] }
  & { items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | (
      { __typename?: 'articleCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'banner' } | { __typename?: 'campaign' } | (
      { __typename?: 'campaignCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | (
      { __typename?: 'factSheetCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | (
      { __typename?: 'pageCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type AccordionGroupFragmentFragment = (
  { __typename?: 'accordionGroup' }
  & { title: AccordionGroup['displayText'] }
  & { items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | (
      { __typename?: 'accordion' }
      & AccordionFragmentFragment
    ) | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type SimpleAccordionGroupFragmentFragment = (
  { __typename?: 'simpleAccordionGroup' }
  & Pick<SimpleAccordionGroup, 'mods' | 'removeBottomSpacing' | 'removeTopSpacing'>
  & { title: SimpleAccordionGroup['displayText'] }
  & { items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | (
      { __typename?: 'simpleAccordion' }
      & SimpleAccordionFragmentFragment
    ) | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type ArticleListQueryVariables = Exact<{
  parameters?: Maybe<Scalars['String']>;
}>;


export type ArticleListQuery = (
  { __typename?: 'Query' }
  & { items?: Maybe<Array<Maybe<(
    { __typename?: 'article' }
    & Pick<Article, 'contentItemId' | 'contentType' | 'path' | 'date' | 'isFeature' | 'content'>
    & { title: Article['displayText'] }
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )> }
  )>>> }
);

export type ArticleMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ArticleMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'article' }
    & Pick<Article, 'content' | 'keywords' | 'path'>
    & { title: Article['displayText'] }
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )> }
  )>>> }
);

export type ArticleQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
}>;


export type ArticleQuery = (
  { __typename?: 'Query' }
  & { article?: Maybe<Array<Maybe<(
    { __typename?: 'article' }
    & Pick<Article, 'contentItemId' | 'content' | 'keywords' | 'path' | 'date'>
    & { title: Article['displayText'] }
    & { tags?: Maybe<(
      { __typename?: 'TaxonomyField' }
      & Pick<TaxonomyField, 'termContentItemIds'>
    )>, locations?: Maybe<(
      { __typename?: 'TaxonomyField' }
      & Pick<TaxonomyField, 'termContentItemIds'>
    )>, thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )>, youtubeVideo?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<(
        { __typename?: 'GenericTag' }
        & Pick<GenericTag, 'contentItemId'>
      ) | (
        { __typename?: 'Homepagebanner' }
        & Pick<Homepagebanner, 'contentItemId'>
      ) | (
        { __typename?: 'IconBlockRow' }
        & Pick<IconBlockRow, 'contentItemId'>
      ) | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & Pick<ImgTitleContentCardGroup, 'contentItemId'>
      ) | (
        { __typename?: 'LocationTag' }
        & Pick<LocationTag, 'contentItemId'>
      ) | (
        { __typename?: 'Taxonomy' }
        & Pick<Taxonomy, 'contentItemId'>
      ) | (
        { __typename?: 'accordion' }
        & Pick<Accordion, 'contentItemId'>
      ) | (
        { __typename?: 'accordionGroup' }
        & Pick<AccordionGroup, 'contentItemId'>
      ) | (
        { __typename?: 'article' }
        & Pick<Article, 'contentItemId'>
      ) | (
        { __typename?: 'articleCard' }
        & Pick<ArticleCard, 'contentItemId'>
      ) | (
        { __typename?: 'banner' }
        & Pick<Banner, 'contentItemId'>
      ) | (
        { __typename?: 'campaign' }
        & Pick<Campaign, 'contentItemId'>
      ) | (
        { __typename?: 'campaignCard' }
        & Pick<CampaignCard, 'contentItemId'>
      ) | (
        { __typename?: 'content' }
        & Pick<Content, 'contentItemId'>
      ) | (
        { __typename?: 'contentExternalLinkCard' }
        & Pick<ContentExternalLinkCard, 'contentItemId'>
      ) | (
        { __typename?: 'contentIntro' }
        & Pick<ContentIntro, 'contentItemId'>
      ) | (
        { __typename?: 'contentPageCards' }
        & Pick<ContentPageCards, 'contentItemId'>
      ) | (
        { __typename?: 'contentPageCardsGroup' }
        & Pick<ContentPageCardsGroup, 'contentItemId'>
      ) | (
        { __typename?: 'country' }
        & Pick<Country, 'contentItemId'>
      ) | (
        { __typename?: 'definitionItem' }
        & Pick<DefinitionItem, 'contentItemId'>
      ) | (
        { __typename?: 'downloadCard' }
        & Pick<DownloadCard, 'contentItemId'>
      ) | (
        { __typename?: 'downloadGrid' }
        & Pick<DownloadGrid, 'contentItemId'>
      ) | (
        { __typename?: 'downloadMediaCard' }
        & Pick<DownloadMediaCard, 'contentItemId'>
      ) | (
        { __typename?: 'externalFeatureCta' }
        & Pick<ExternalFeatureCta, 'contentItemId'>
      ) | (
        { __typename?: 'externalLinkCardGroup' }
        & Pick<ExternalLinkCardGroup, 'contentItemId'>
      ) | (
        { __typename?: 'factSheet' }
        & Pick<FactSheet, 'contentItemId'>
      ) | (
        { __typename?: 'factSheetCard' }
        & Pick<FactSheetCard, 'contentItemId'>
      ) | (
        { __typename?: 'factSheetGrid' }
        & Pick<FactSheetGrid, 'contentItemId'>
      ) | (
        { __typename?: 'featureImg' }
        & Pick<FeatureImg, 'contentItemId'>
      ) | (
        { __typename?: 'featureLogoRow' }
        & Pick<FeatureLogoRow, 'contentItemId'>
      ) | (
        { __typename?: 'figureBlock' }
        & Pick<FigureBlock, 'contentItemId'>
      ) | (
        { __typename?: 'figuresBlock' }
        & Pick<FiguresBlock, 'contentItemId'>
      ) | (
        { __typename?: 'footer' }
        & Pick<Footer, 'contentItemId'>
      ) | (
        { __typename?: 'heroImage' }
        & Pick<HeroImage, 'contentItemId'>
      ) | (
        { __typename?: 'homepage' }
        & Pick<Homepage, 'contentItemId'>
      ) | (
        { __typename?: 'iconBlock' }
        & Pick<IconBlock, 'contentItemId'>
      ) | (
        { __typename?: 'iframe' }
        & Pick<Iframe, 'contentItemId'>
      ) | (
        { __typename?: 'imageContent' }
        & Pick<ImageContent, 'contentItemId'>
      ) | (
        { __typename?: 'imageContentCardGrid' }
        & Pick<ImageContentCardGrid, 'contentItemId'>
      ) | (
        { __typename?: 'imageGalleryCarousel' }
        & Pick<ImageGalleryCarousel, 'contentItemId'>
      ) | (
        { __typename?: 'imageItem' }
        & Pick<ImageItem, 'contentItemId'>
      ) | (
        { __typename?: 'imgArticleCard' }
        & Pick<ImgArticleCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgCampaignCard' }
        & Pick<ImgCampaignCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgContentBlock' }
        & Pick<ImgContentBlock, 'contentItemId'>
      ) | (
        { __typename?: 'imgContentCard' }
        & Pick<ImgContentCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & Pick<ImgFactSheetCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgGroup' }
        & Pick<ImgGroup, 'contentItemId'>
      ) | (
        { __typename?: 'instagram' }
        & Pick<Instagram, 'contentItemId'>
      ) | (
        { __typename?: 'instagramContentCarousel' }
        & Pick<InstagramContentCarousel, 'contentItemId'>
      ) | (
        { __typename?: 'instagramFeed' }
        & Pick<InstagramFeed, 'contentItemId'>
      ) | (
        { __typename?: 'internalFeatureCta' }
        & Pick<InternalFeatureCta, 'contentItemId'>
      ) | (
        { __typename?: 'locationRegion' }
        & Pick<LocationRegion, 'contentItemId'>
      ) | (
        { __typename?: 'mapCountry' }
        & Pick<MapCountry, 'contentItemId'>
      ) | (
        { __typename?: 'mapRegion' }
        & Pick<MapRegion, 'contentItemId'>
      ) | (
        { __typename?: 'mediaDownloadCarousel' }
        & Pick<MediaDownloadCarousel, 'contentItemId'>
      ) | (
        { __typename?: 'newsletter' }
        & Pick<Newsletter, 'contentItemId'>
      ) | (
        { __typename?: 'pageAboutUs' }
        & Pick<PageAboutUs, 'contentItemId'>
      ) | (
        { __typename?: 'pageActNow' }
        & Pick<PageActNow, 'contentItemId'>
      ) | (
        { __typename?: 'pageCard' }
        & Pick<PageCard, 'contentItemId'>
      ) | (
        { __typename?: 'pageChallenges' }
        & Pick<PageChallenges, 'contentItemId'>
      ) | (
        { __typename?: 'pageContactUs' }
        & Pick<PageContactUs, 'contentItemId'>
      ) | (
        { __typename?: 'pageDefinitions' }
        & Pick<PageDefinitions, 'contentItemId'>
      ) | (
        { __typename?: 'pageDonate' }
        & Pick<PageDonate, 'contentItemId'>
      ) | (
        { __typename?: 'pageEqualRights' }
        & Pick<PageEqualRights, 'contentItemId'>
      ) | (
        { __typename?: 'pageFaqs' }
        & Pick<PageFaqs, 'contentItemId'>
      ) | (
        { __typename?: 'pageGeneralContent' }
        & Pick<PageGeneralContent, 'contentItemId'>
      ) | (
        { __typename?: 'pageKnowTheFacts' }
        & Pick<PageKnowTheFacts, 'contentItemId'>
      ) | (
        { __typename?: 'pageNewsletter' }
        & Pick<PageNewsletter, 'contentItemId'>
      ) | (
        { __typename?: 'pageOurCampaigns' }
        & Pick<PageOurCampaigns, 'contentItemId'>
      ) | (
        { __typename?: 'pageOurWork' }
        & Pick<PageOurWork, 'contentItemId'>
      ) | (
        { __typename?: 'pageResources' }
        & Pick<PageResources, 'contentItemId'>
      ) | (
        { __typename?: 'pageRightToLove' }
        & Pick<PageRightToLove, 'contentItemId'>
      ) | (
        { __typename?: 'pageUpdates' }
        & Pick<PageUpdates, 'contentItemId'>
      ) | (
        { __typename?: 'pageWhatWeDo' }
        & Pick<PageWhatWeDo, 'contentItemId'>
      ) | (
        { __typename?: 'relatedArticles' }
        & Pick<RelatedArticles, 'contentItemId'>
      ) | (
        { __typename?: 'relatedCampaigns' }
        & Pick<RelatedCampaigns, 'contentItemId'>
      ) | (
        { __typename?: 'relatedFactSheets' }
        & Pick<RelatedFactSheets, 'contentItemId'>
      ) | (
        { __typename?: 'simpleAccordion' }
        & Pick<SimpleAccordion, 'contentItemId'>
      ) | (
        { __typename?: 'simpleAccordionGroup' }
        & Pick<SimpleAccordionGroup, 'contentItemId'>
      ) | (
        { __typename?: 'simpleContentBlock' }
        & Pick<SimpleContentBlock, 'contentItemId'>
      ) | (
        { __typename?: 'simpleContentCard' }
        & Pick<SimpleContentCard, 'contentItemId'>
      ) | (
        { __typename?: 'simpleContentGrid' }
        & Pick<SimpleContentGrid, 'contentItemId'>
      ) | (
        { __typename?: 'simplePageCardCarousel' }
        & Pick<SimplePageCardCarousel, 'contentItemId'>
      ) | (
        { __typename?: 'socialContentCard' }
        & Pick<SocialContentCard, 'contentItemId'>
      ) | (
        { __typename?: 'socialPlatform' }
        & Pick<SocialPlatform, 'contentItemId'>
      ) | (
        { __typename?: 'subheader' }
        & Pick<Subheader, 'contentItemId'>
      ) | (
        { __typename?: 'subscription' }
        & Pick<Subscription, 'contentItemId'>
      ) | (
        { __typename?: 'unfeContentItem' }
        & Pick<UnfeContentItem, 'contentItemId'>
      ) | (
        { __typename?: 'unfeHomePage' }
        & Pick<UnfeHomePage, 'contentItemId'>
      ) | (
        { __typename?: 'unfeMap' }
        & Pick<UnfeMap, 'contentItemId'>
      ) | (
        { __typename?: 'unfeNavItem' }
        & Pick<UnfeNavItem, 'contentItemId'>
      ) | (
        { __typename?: 'unfeNavigation' }
        & Pick<UnfeNavigation, 'contentItemId'>
      ) | (
        { __typename?: 'youtubeVideo' }
        & Pick<YoutubeVideo, 'videoId' | 'contentItemId'>
        & { img?: Maybe<(
          { __typename?: 'MediaField' }
          & Pick<MediaField, 'urls'>
        )> }
      )>>> }
    )>, wysiwyg?: Maybe<(
      { __typename?: 'HtmlBodyPart' }
      & Pick<HtmlBodyPart, 'html'>
    )>, galleryCarousel?: Maybe<(
      { __typename?: 'BagPart' }
      & { items?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | (
        { __typename?: 'imageItem' }
        & GalleryFragmentFragment
      ) | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, relatedContent?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | (
        { __typename?: 'relatedArticles' }
        & RelatedArticlesFragmentFragment
      ) | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type CampaignListQueryVariables = Exact<{
  parameters?: Maybe<Scalars['String']>;
}>;


export type CampaignListQuery = (
  { __typename?: 'Query' }
  & { items?: Maybe<Array<Maybe<(
    { __typename?: 'campaign' }
    & Pick<Campaign, 'contentItemId' | 'contentType' | 'date' | 'isFeature' | 'path'>
    & { title: Campaign['displayText'], content: Campaign['description'] }
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )>, external?: Maybe<(
      { __typename?: 'externalContent' }
      & Pick<ExternalContent, 'isExternal'>
      & { url: ExternalContent['externalUrl'] }
    )> }
  )>>> }
);

export type CampaignMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type CampaignMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'campaign' }
    & Pick<Campaign, 'contentItemId' | 'description' | 'path' | 'keywords'>
    & { title: Campaign['displayText'] }
    & { external?: Maybe<(
      { __typename?: 'externalContent' }
      & Pick<ExternalContent, 'isExternal'>
      & { url: ExternalContent['externalUrl'] }
    )>, thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )> }
  )>>> }
);

export type CampaignQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
}>;


export type CampaignQuery = (
  { __typename?: 'Query' }
  & { campaign?: Maybe<Array<Maybe<(
    { __typename?: 'campaign' }
    & Pick<Campaign, 'contentItemId' | 'date' | 'description' | 'path' | 'keywords' | 'isFeature'>
    & { title: Campaign['displayText'] }
    & { external?: Maybe<(
      { __typename?: 'externalContent' }
      & Pick<ExternalContent, 'isExternal'>
      & { url: ExternalContent['externalUrl'] }
    )>, thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )>, tags?: Maybe<(
      { __typename?: 'TaxonomyField' }
      & Pick<TaxonomyField, 'termContentItemIds'>
    )>, locations?: Maybe<(
      { __typename?: 'TaxonomyField' }
      & Pick<TaxonomyField, 'termContentItemIds'>
    )>, components?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<(
        { __typename?: 'GenericTag' }
        & Pick<GenericTag, 'contentItemId'>
      ) | (
        { __typename?: 'Homepagebanner' }
        & Pick<Homepagebanner, 'contentItemId'>
      ) | (
        { __typename?: 'IconBlockRow' }
        & Pick<IconBlockRow, 'contentItemId'>
      ) | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & Pick<ImgTitleContentCardGroup, 'contentItemId'>
      ) | (
        { __typename?: 'LocationTag' }
        & Pick<LocationTag, 'contentItemId'>
      ) | (
        { __typename?: 'Taxonomy' }
        & Pick<Taxonomy, 'contentItemId'>
      ) | (
        { __typename?: 'accordion' }
        & Pick<Accordion, 'contentItemId'>
      ) | (
        { __typename?: 'accordionGroup' }
        & Pick<AccordionGroup, 'contentItemId'>
      ) | (
        { __typename?: 'article' }
        & Pick<Article, 'contentItemId'>
      ) | (
        { __typename?: 'articleCard' }
        & Pick<ArticleCard, 'contentItemId'>
      ) | (
        { __typename?: 'banner' }
        & Pick<Banner, 'contentItemId'>
      ) | (
        { __typename?: 'campaign' }
        & Pick<Campaign, 'contentItemId'>
      ) | (
        { __typename?: 'campaignCard' }
        & Pick<CampaignCard, 'contentItemId'>
      ) | (
        { __typename?: 'content' }
        & Pick<Content, 'html' | 'mods' | 'removeBottomSpacing' | 'removeTopSpacing' | 'contentItemId'>
      ) | (
        { __typename?: 'contentExternalLinkCard' }
        & Pick<ContentExternalLinkCard, 'contentItemId'>
      ) | (
        { __typename?: 'contentIntro' }
        & Pick<ContentIntro, 'contentItemId'>
      ) | (
        { __typename?: 'contentPageCards' }
        & Pick<ContentPageCards, 'contentItemId'>
      ) | (
        { __typename?: 'contentPageCardsGroup' }
        & Pick<ContentPageCardsGroup, 'contentItemId'>
      ) | (
        { __typename?: 'country' }
        & Pick<Country, 'contentItemId'>
      ) | (
        { __typename?: 'definitionItem' }
        & Pick<DefinitionItem, 'contentItemId'>
      ) | (
        { __typename?: 'downloadCard' }
        & Pick<DownloadCard, 'contentItemId'>
      ) | (
        { __typename?: 'downloadGrid' }
        & Pick<DownloadGrid, 'contentItemId'>
      ) | (
        { __typename?: 'downloadMediaCard' }
        & Pick<DownloadMediaCard, 'contentItemId'>
      ) | (
        { __typename?: 'externalFeatureCta' }
        & Pick<ExternalFeatureCta, 'contentItemId'>
      ) | (
        { __typename?: 'externalLinkCardGroup' }
        & Pick<ExternalLinkCardGroup, 'contentItemId'>
      ) | (
        { __typename?: 'factSheet' }
        & Pick<FactSheet, 'contentItemId'>
      ) | (
        { __typename?: 'factSheetCard' }
        & Pick<FactSheetCard, 'contentItemId'>
      ) | (
        { __typename?: 'factSheetGrid' }
        & Pick<FactSheetGrid, 'contentItemId'>
      ) | (
        { __typename?: 'featureImg' }
        & Pick<FeatureImg, 'contentItemId'>
      ) | (
        { __typename?: 'featureLogoRow' }
        & Pick<FeatureLogoRow, 'contentItemId'>
      ) | (
        { __typename?: 'figureBlock' }
        & Pick<FigureBlock, 'contentItemId'>
      ) | (
        { __typename?: 'figuresBlock' }
        & Pick<FiguresBlock, 'contentItemId'>
        & FiguresBlockFragmentFragment
      ) | (
        { __typename?: 'footer' }
        & Pick<Footer, 'contentItemId'>
      ) | (
        { __typename?: 'heroImage' }
        & Pick<HeroImage, 'contentItemId'>
        & { img?: Maybe<(
          { __typename?: 'MediaField' }
          & Pick<MediaField, 'urls'>
        )> }
      ) | (
        { __typename?: 'homepage' }
        & Pick<Homepage, 'contentItemId'>
      ) | (
        { __typename?: 'iconBlock' }
        & Pick<IconBlock, 'contentItemId'>
      ) | (
        { __typename?: 'iframe' }
        & Pick<Iframe, 'contentItemId'>
      ) | (
        { __typename?: 'imageContent' }
        & Pick<ImageContent, 'contentItemId'>
      ) | (
        { __typename?: 'imageContentCardGrid' }
        & Pick<ImageContentCardGrid, 'contentItemId'>
      ) | (
        { __typename?: 'imageGalleryCarousel' }
        & Pick<ImageGalleryCarousel, 'contentItemId'>
        & GalleryCarouselFragmentFragment
      ) | (
        { __typename?: 'imageItem' }
        & Pick<ImageItem, 'contentItemId'>
      ) | (
        { __typename?: 'imgArticleCard' }
        & Pick<ImgArticleCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgCampaignCard' }
        & Pick<ImgCampaignCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgContentBlock' }
        & Pick<ImgContentBlock, 'contentItemId'>
      ) | (
        { __typename?: 'imgContentCard' }
        & Pick<ImgContentCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & Pick<ImgFactSheetCard, 'contentItemId'>
      ) | (
        { __typename?: 'imgGroup' }
        & Pick<ImgGroup, 'contentItemId'>
      ) | (
        { __typename?: 'instagram' }
        & Pick<Instagram, 'contentItemId'>
      ) | (
        { __typename?: 'instagramContentCarousel' }
        & Pick<InstagramContentCarousel, 'contentItemId'>
      ) | (
        { __typename?: 'instagramFeed' }
        & Pick<InstagramFeed, 'contentItemId'>
      ) | (
        { __typename?: 'internalFeatureCta' }
        & Pick<InternalFeatureCta, 'contentItemId'>
      ) | (
        { __typename?: 'locationRegion' }
        & Pick<LocationRegion, 'contentItemId'>
      ) | (
        { __typename?: 'mapCountry' }
        & Pick<MapCountry, 'contentItemId'>
      ) | (
        { __typename?: 'mapRegion' }
        & Pick<MapRegion, 'contentItemId'>
      ) | (
        { __typename?: 'mediaDownloadCarousel' }
        & Pick<MediaDownloadCarousel, 'contentItemId'>
        & MediaDownloadCarouselFragmentFragment
      ) | (
        { __typename?: 'newsletter' }
        & Pick<Newsletter, 'contentItemId'>
      ) | (
        { __typename?: 'pageAboutUs' }
        & Pick<PageAboutUs, 'contentItemId'>
      ) | (
        { __typename?: 'pageActNow' }
        & Pick<PageActNow, 'contentItemId'>
      ) | (
        { __typename?: 'pageCard' }
        & Pick<PageCard, 'contentItemId'>
      ) | (
        { __typename?: 'pageChallenges' }
        & Pick<PageChallenges, 'contentItemId'>
      ) | (
        { __typename?: 'pageContactUs' }
        & Pick<PageContactUs, 'contentItemId'>
      ) | (
        { __typename?: 'pageDefinitions' }
        & Pick<PageDefinitions, 'contentItemId'>
      ) | (
        { __typename?: 'pageDonate' }
        & Pick<PageDonate, 'contentItemId'>
      ) | (
        { __typename?: 'pageEqualRights' }
        & Pick<PageEqualRights, 'contentItemId'>
      ) | (
        { __typename?: 'pageFaqs' }
        & Pick<PageFaqs, 'contentItemId'>
      ) | (
        { __typename?: 'pageGeneralContent' }
        & Pick<PageGeneralContent, 'contentItemId'>
      ) | (
        { __typename?: 'pageKnowTheFacts' }
        & Pick<PageKnowTheFacts, 'contentItemId'>
      ) | (
        { __typename?: 'pageNewsletter' }
        & Pick<PageNewsletter, 'contentItemId'>
      ) | (
        { __typename?: 'pageOurCampaigns' }
        & Pick<PageOurCampaigns, 'contentItemId'>
      ) | (
        { __typename?: 'pageOurWork' }
        & Pick<PageOurWork, 'contentItemId'>
      ) | (
        { __typename?: 'pageResources' }
        & Pick<PageResources, 'contentItemId'>
      ) | (
        { __typename?: 'pageRightToLove' }
        & Pick<PageRightToLove, 'contentItemId'>
      ) | (
        { __typename?: 'pageUpdates' }
        & Pick<PageUpdates, 'contentItemId'>
      ) | (
        { __typename?: 'pageWhatWeDo' }
        & Pick<PageWhatWeDo, 'contentItemId'>
      ) | (
        { __typename?: 'relatedArticles' }
        & Pick<RelatedArticles, 'contentItemId'>
      ) | (
        { __typename?: 'relatedCampaigns' }
        & Pick<RelatedCampaigns, 'contentItemId'>
        & RelatedCampaignsFragmentFragment
      ) | (
        { __typename?: 'relatedFactSheets' }
        & Pick<RelatedFactSheets, 'contentItemId'>
      ) | (
        { __typename?: 'simpleAccordion' }
        & Pick<SimpleAccordion, 'contentItemId'>
      ) | (
        { __typename?: 'simpleAccordionGroup' }
        & Pick<SimpleAccordionGroup, 'contentItemId'>
        & SimpleAccordionGroupFragmentFragment
      ) | (
        { __typename?: 'simpleContentBlock' }
        & Pick<SimpleContentBlock, 'contentItemId'>
      ) | (
        { __typename?: 'simpleContentCard' }
        & Pick<SimpleContentCard, 'contentItemId'>
      ) | (
        { __typename?: 'simpleContentGrid' }
        & Pick<SimpleContentGrid, 'contentItemId'>
      ) | (
        { __typename?: 'simplePageCardCarousel' }
        & Pick<SimplePageCardCarousel, 'contentItemId'>
      ) | (
        { __typename?: 'socialContentCard' }
        & Pick<SocialContentCard, 'contentItemId'>
      ) | (
        { __typename?: 'socialPlatform' }
        & Pick<SocialPlatform, 'contentItemId'>
      ) | (
        { __typename?: 'subheader' }
        & Pick<Subheader, 'contentItemId'>
      ) | (
        { __typename?: 'subscription' }
        & Pick<Subscription, 'contentItemId'>
      ) | (
        { __typename?: 'unfeContentItem' }
        & Pick<UnfeContentItem, 'contentItemId'>
      ) | (
        { __typename?: 'unfeHomePage' }
        & Pick<UnfeHomePage, 'contentItemId'>
      ) | (
        { __typename?: 'unfeMap' }
        & Pick<UnfeMap, 'contentItemId'>
      ) | (
        { __typename?: 'unfeNavItem' }
        & Pick<UnfeNavItem, 'contentItemId'>
      ) | (
        { __typename?: 'unfeNavigation' }
        & Pick<UnfeNavigation, 'contentItemId'>
      ) | (
        { __typename?: 'youtubeVideo' }
        & Pick<YoutubeVideo, 'videoId' | 'mods' | 'removeBottomSpacing' | 'removeTopSpacing' | 'contentItemId'>
        & { img?: Maybe<(
          { __typename?: 'MediaField' }
          & Pick<MediaField, 'urls'>
        )> }
      )>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type LocationRelatedContentQueryVariables = Exact<{
  parameter?: Maybe<Scalars['String']>;
}>;


export type LocationRelatedContentQuery = (
  { __typename?: 'Query' }
  & { articles?: Maybe<Array<Maybe<(
    { __typename?: 'article' }
    & Pick<Article, 'contentItemId' | 'path' | 'contentType' | 'content'>
    & { title: Article['displayText'] }
  )>>>, campaigns?: Maybe<Array<Maybe<(
    { __typename?: 'campaign' }
    & Pick<Campaign, 'path' | 'contentItemId' | 'contentType'>
    & { content: Campaign['description'], title: Campaign['displayText'] }
  )>>>, factSheets?: Maybe<Array<Maybe<(
    { __typename?: 'factSheet' }
    & Pick<FactSheet, 'contentItemId' | 'contentType' | 'path'>
    & { content: FactSheet['description'], title: FactSheet['displayText'] }
  )>>> }
);

export type ContentIntroFragmentFragment = (
  { __typename?: 'contentIntro' }
  & Pick<ContentIntro, 'content' | 'label' | 'title' | 'isLanding'>
  & { links?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & Pick<ContentPickerField, 'contentItemIds'>
  )> }
);

export type ContentPageCardsFragmentFragment = (
  { __typename?: 'contentPageCards' }
  & Pick<ContentPageCards, 'content'>
  & { items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | (
      { __typename?: 'articleCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'banner' } | { __typename?: 'campaign' } | (
      { __typename?: 'campaignCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | (
      { __typename?: 'factSheetCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | (
      { __typename?: 'pageCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type DownloadGridFragmentFragment = (
  { __typename?: 'downloadGrid' }
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )>, items?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | (
      { __typename?: 'downloadCard' }
      & Pick<DownloadCard, 'content'>
      & { title: DownloadCard['displayText'] }
      & { file?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    ) | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type ExternalFeatureCtaFragmentFragment = (
  { __typename?: 'externalFeatureCta' }
  & Pick<ExternalFeatureCta, 'removeTopSpacing' | 'removeBottomSpacing' | 'mods' | 'newTab'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )>, link?: Maybe<(
    { __typename?: 'LinkField' }
    & Pick<LinkField, 'url' | 'text'>
  )> }
);

export type ExternalLinkCardGroupFragmentFragment = (
  { __typename?: 'externalLinkCardGroup' }
  & Pick<ExternalLinkCardGroup, 'title'>
  & { content?: Maybe<(
    { __typename?: 'HtmlBodyPart' }
    & Pick<HtmlBodyPart, 'html'>
  )>, items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | (
      { __typename?: 'contentExternalLinkCard' }
      & Pick<ContentExternalLinkCard, 'content' | 'newTab'>
      & { link?: Maybe<(
        { __typename?: 'LinkField' }
        & Pick<LinkField, 'text' | 'url'>
      )> }
    ) | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type FactSheetListQueryVariables = Exact<{
  parameters?: Maybe<Scalars['String']>;
}>;


export type FactSheetListQuery = (
  { __typename?: 'Query' }
  & { items?: Maybe<Array<Maybe<(
    { __typename?: 'factSheet' }
    & Pick<FactSheet, 'contentItemId' | 'contentType' | 'description' | 'path'>
    & { title: FactSheet['displayText'] }
  )>>> }
);

export type FactSheetMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type FactSheetMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'factSheet' }
    & Pick<FactSheet, 'description' | 'path' | 'keywords'>
    & { title: FactSheet['displayText'] }
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )> }
  )>>> }
);

export type FactSheetQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
}>;


export type FactSheetQuery = (
  { __typename?: 'Query' }
  & { factSheet?: Maybe<Array<Maybe<(
    { __typename?: 'factSheet' }
    & Pick<FactSheet, 'contentItemId' | 'description' | 'path'>
    & { title: FactSheet['displayText'] }
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )>, tags?: Maybe<(
      { __typename?: 'TaxonomyField' }
      & Pick<TaxonomyField, 'termContentItemIds'>
    )>, locations?: Maybe<(
      { __typename?: 'TaxonomyField' }
      & Pick<TaxonomyField, 'termContentItemIds'>
    )>, toolbar?: Maybe<(
      { __typename?: 'toolbar' }
      & Pick<Toolbar, 'share'>
      & { file?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )>, htmlContent?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | (
        { __typename?: 'content' }
        & Pick<Content, 'html'>
      ) | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, figuresBlock?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | (
        { __typename?: 'figuresBlock' }
        & FiguresBlockFragmentFragment
      ) | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, secondHmlcontent?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | (
        { __typename?: 'content' }
        & Pick<Content, 'html'>
      ) | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureContent?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | (
        { __typename?: 'simpleContentBlock' }
        & SimpleContentBlockFragmentFragment
      ) | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureImage?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | (
        { __typename?: 'featureImg' }
        & FeatureImgFragmentFragment
      ) | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, faqs?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | (
        { __typename?: 'simpleAccordionGroup' }
        & SimpleAccordionGroupFragmentFragment
      ) | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, relatedContent?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | (
        { __typename?: 'relatedFactSheets' }
        & RelatedFactSheetsFragmentFragment
      ) | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type FeatureImgFragmentFragment = (
  { __typename?: 'featureImg' }
  & Pick<FeatureImg, 'caption'>
  & { img?: Maybe<(
    { __typename?: 'MediaField' }
    & Pick<MediaField, 'urls'>
  )> }
);

export type FeatureLogoRowFragmentFragment = (
  { __typename?: 'featureLogoRow' }
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )> }
);

export type FiguresBlockFragmentFragment = (
  { __typename?: 'figuresBlock' }
  & Pick<FiguresBlock, 'mods' | 'removeBottomSpacing' | 'removeTopSpacing'>
  & { items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | (
      { __typename?: 'figureBlock' }
      & Pick<FigureBlock, 'content' | 'unit' | 'value'>
    ) | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )>, sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )> }
);

export type GetFooterQueryVariables = Exact<{
  status?: Maybe<Status>;
}>;


export type GetFooterQuery = (
  { __typename?: 'Query' }
  & { footer?: Maybe<Array<Maybe<(
    { __typename?: 'footer' }
    & Pick<Footer, 'footerText'>
    & { links?: Maybe<(
      { __typename?: 'ContentPickerField' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | (
        { __typename?: 'pageAboutUs' }
        & Pick<PageAboutUs, 'path'>
        & { pageMetaData?: Maybe<(
          { __typename?: 'PageMetaData' }
          & Pick<PageMetaData, 'title'>
        )> }
      ) | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | (
        { __typename?: 'pageContactUs' }
        & Pick<PageContactUs, 'path'>
        & { pageMetaData?: Maybe<(
          { __typename?: 'PageMetaData' }
          & Pick<PageMetaData, 'title'>
        )> }
      ) | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | (
        { __typename?: 'pageGeneralContent' }
        & Pick<PageGeneralContent, 'path'>
        & { pageMetaData?: Maybe<(
          { __typename?: 'PageMetaData' }
          & Pick<PageMetaData, 'title'>
        )> }
      ) | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | (
        { __typename?: 'pageResources' }
        & Pick<PageResources, 'path'>
        & { pageMetaData?: Maybe<(
          { __typename?: 'PageMetaData' }
          & Pick<PageMetaData, 'title'>
        )> }
      ) | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, localization?: Maybe<(
      { __typename?: 'LocalizationPart' }
      & Pick<LocalizationPart, 'culture'>
    )> }
  )>>> }
);

export type GalleryFragmentFragment = (
  { __typename?: 'imageItem' }
  & { content: ImageItem['description'], title: ImageItem['displayText'] }
  & { img?: Maybe<(
    { __typename?: 'MediaField' }
    & Pick<MediaField, 'urls'>
  )> }
);

export type GalleryCarouselFragmentFragment = (
  { __typename?: 'imageGalleryCarousel' }
  & Pick<ImageGalleryCarousel, 'mods' | 'removeBottomSpacing' | 'removeTopSpacing'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )>, items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | (
      { __typename?: 'imageItem' }
      & GalleryFragmentFragment
    ) | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type IconBlockRowFragmentFragment = (
  { __typename?: 'IconBlockRow' }
  & Pick<IconBlockRow, 'content' | 'title'>
  & { items?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | (
    { __typename?: 'iconBlock' }
    & Pick<IconBlock, 'content'>
    & { bgImg?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )> }
  ) | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
);

export type IframeFragmentFragment = (
  { __typename?: 'iframe' }
  & Pick<Iframe, 'embedCode' | 'description'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )> }
);

export type ImageContentCardGridFragmentFragment = (
  { __typename?: 'imageContentCardGrid' }
  & { items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | (
      { __typename?: 'imageContent' }
      & Pick<ImageContent, 'title' | 'content'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    ) | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )>, sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )> }
);

export type ImgContentCardFragmentFragment = (
  { __typename?: 'imgContentCard' }
  & Pick<ImgContentCard, 'imgAlignment' | 'displayShadow' | 'title' | 'content'>
  & { page?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<(
      { __typename?: 'GenericTag' }
      & Pick<GenericTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Homepagebanner' }
      & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'IconBlockRow' }
      & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'ImgTitleContentCardGroup' }
      & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Taxonomy' }
      & Pick<Taxonomy, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordion' }
      & Pick<Accordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordionGroup' }
      & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'article' }
      & Pick<Article, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'articleCard' }
      & Pick<ArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'banner' }
      & Pick<Banner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaign' }
      & Pick<Campaign, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaignCard' }
      & Pick<CampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'content' }
      & Pick<Content, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentExternalLinkCard' }
      & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentIntro' }
      & Pick<ContentIntro, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCards' }
      & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCardsGroup' }
      & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'country' }
      & Pick<Country, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'definitionItem' }
      & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadCard' }
      & Pick<DownloadCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadGrid' }
      & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadMediaCard' }
      & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalFeatureCta' }
      & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalLinkCardGroup' }
      & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheet' }
      & Pick<FactSheet, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetCard' }
      & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetGrid' }
      & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureImg' }
      & Pick<FeatureImg, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureLogoRow' }
      & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figureBlock' }
      & Pick<FigureBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figuresBlock' }
      & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'footer' }
      & Pick<Footer, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'heroImage' }
      & Pick<HeroImage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'homepage' }
      & Pick<Homepage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iconBlock' }
      & Pick<IconBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iframe' }
      & Pick<Iframe, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContent' }
      & Pick<ImageContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContentCardGrid' }
      & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageGalleryCarousel' }
      & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageItem' }
      & Pick<ImageItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgArticleCard' }
      & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgCampaignCard' }
      & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentBlock' }
      & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentCard' }
      & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgFactSheetCard' }
      & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgGroup' }
      & Pick<ImgGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagram' }
      & Pick<Instagram, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramContentCarousel' }
      & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramFeed' }
      & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'internalFeatureCta' }
      & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'locationRegion' }
      & Pick<LocationRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapCountry' }
      & Pick<MapCountry, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapRegion' }
      & Pick<MapRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mediaDownloadCarousel' }
      & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'newsletter' }
      & Pick<Newsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageAboutUs' }
      & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageActNow' }
      & Pick<PageActNow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageCard' }
      & Pick<PageCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageChallenges' }
      & Pick<PageChallenges, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageContactUs' }
      & Pick<PageContactUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDefinitions' }
      & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDonate' }
      & Pick<PageDonate, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageEqualRights' }
      & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageFaqs' }
      & Pick<PageFaqs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageGeneralContent' }
      & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageKnowTheFacts' }
      & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageNewsletter' }
      & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurCampaigns' }
      & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurWork' }
      & Pick<PageOurWork, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageResources' }
      & Pick<PageResources, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageRightToLove' }
      & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageUpdates' }
      & Pick<PageUpdates, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageWhatWeDo' }
      & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedArticles' }
      & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedCampaigns' }
      & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedFactSheets' }
      & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordion' }
      & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordionGroup' }
      & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentBlock' }
      & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentCard' }
      & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentGrid' }
      & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simplePageCardCarousel' }
      & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialContentCard' }
      & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialPlatform' }
      & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subheader' }
      & Pick<Subheader, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subscription' }
      & Pick<Subscription, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeContentItem' }
      & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeHomePage' }
      & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeMap' }
      & Pick<UnfeMap, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavigation' }
      & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'youtubeVideo' }
      & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
    )>>> }
  )> }
);

export type ImgArticleCardFragmentFragment = (
  { __typename?: 'imgArticleCard' }
  & Pick<ImgArticleCard, 'imgAlignment' | 'displayShadow' | 'title' | 'content'>
  & { page?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<(
      { __typename?: 'GenericTag' }
      & Pick<GenericTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Homepagebanner' }
      & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'IconBlockRow' }
      & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'ImgTitleContentCardGroup' }
      & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Taxonomy' }
      & Pick<Taxonomy, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordion' }
      & Pick<Accordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordionGroup' }
      & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'article' }
      & Pick<Article, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'articleCard' }
      & Pick<ArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'banner' }
      & Pick<Banner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaign' }
      & Pick<Campaign, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaignCard' }
      & Pick<CampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'content' }
      & Pick<Content, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentExternalLinkCard' }
      & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentIntro' }
      & Pick<ContentIntro, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCards' }
      & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCardsGroup' }
      & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'country' }
      & Pick<Country, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'definitionItem' }
      & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadCard' }
      & Pick<DownloadCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadGrid' }
      & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadMediaCard' }
      & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalFeatureCta' }
      & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalLinkCardGroup' }
      & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheet' }
      & Pick<FactSheet, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetCard' }
      & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetGrid' }
      & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureImg' }
      & Pick<FeatureImg, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureLogoRow' }
      & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figureBlock' }
      & Pick<FigureBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figuresBlock' }
      & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'footer' }
      & Pick<Footer, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'heroImage' }
      & Pick<HeroImage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'homepage' }
      & Pick<Homepage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iconBlock' }
      & Pick<IconBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iframe' }
      & Pick<Iframe, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContent' }
      & Pick<ImageContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContentCardGrid' }
      & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageGalleryCarousel' }
      & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageItem' }
      & Pick<ImageItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgArticleCard' }
      & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgCampaignCard' }
      & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentBlock' }
      & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentCard' }
      & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgFactSheetCard' }
      & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgGroup' }
      & Pick<ImgGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagram' }
      & Pick<Instagram, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramContentCarousel' }
      & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramFeed' }
      & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'internalFeatureCta' }
      & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'locationRegion' }
      & Pick<LocationRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapCountry' }
      & Pick<MapCountry, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapRegion' }
      & Pick<MapRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mediaDownloadCarousel' }
      & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'newsletter' }
      & Pick<Newsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageAboutUs' }
      & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageActNow' }
      & Pick<PageActNow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageCard' }
      & Pick<PageCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageChallenges' }
      & Pick<PageChallenges, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageContactUs' }
      & Pick<PageContactUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDefinitions' }
      & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDonate' }
      & Pick<PageDonate, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageEqualRights' }
      & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageFaqs' }
      & Pick<PageFaqs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageGeneralContent' }
      & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageKnowTheFacts' }
      & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageNewsletter' }
      & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurCampaigns' }
      & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurWork' }
      & Pick<PageOurWork, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageResources' }
      & Pick<PageResources, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageRightToLove' }
      & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageUpdates' }
      & Pick<PageUpdates, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageWhatWeDo' }
      & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedArticles' }
      & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedCampaigns' }
      & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedFactSheets' }
      & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordion' }
      & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordionGroup' }
      & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentBlock' }
      & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentCard' }
      & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentGrid' }
      & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simplePageCardCarousel' }
      & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialContentCard' }
      & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialPlatform' }
      & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subheader' }
      & Pick<Subheader, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subscription' }
      & Pick<Subscription, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeContentItem' }
      & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeHomePage' }
      & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeMap' }
      & Pick<UnfeMap, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavigation' }
      & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'youtubeVideo' }
      & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
    )>>> }
  )> }
);

export type ImgCampaignCardFragmentFragment = (
  { __typename?: 'imgCampaignCard' }
  & Pick<ImgCampaignCard, 'imgAlignment' | 'displayShadow' | 'title' | 'content'>
  & { page?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<(
      { __typename?: 'GenericTag' }
      & Pick<GenericTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Homepagebanner' }
      & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'IconBlockRow' }
      & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'ImgTitleContentCardGroup' }
      & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Taxonomy' }
      & Pick<Taxonomy, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordion' }
      & Pick<Accordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordionGroup' }
      & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'article' }
      & Pick<Article, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'articleCard' }
      & Pick<ArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'banner' }
      & Pick<Banner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaign' }
      & Pick<Campaign, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaignCard' }
      & Pick<CampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'content' }
      & Pick<Content, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentExternalLinkCard' }
      & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentIntro' }
      & Pick<ContentIntro, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCards' }
      & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCardsGroup' }
      & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'country' }
      & Pick<Country, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'definitionItem' }
      & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadCard' }
      & Pick<DownloadCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadGrid' }
      & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadMediaCard' }
      & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalFeatureCta' }
      & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalLinkCardGroup' }
      & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheet' }
      & Pick<FactSheet, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetCard' }
      & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetGrid' }
      & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureImg' }
      & Pick<FeatureImg, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureLogoRow' }
      & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figureBlock' }
      & Pick<FigureBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figuresBlock' }
      & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'footer' }
      & Pick<Footer, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'heroImage' }
      & Pick<HeroImage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'homepage' }
      & Pick<Homepage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iconBlock' }
      & Pick<IconBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iframe' }
      & Pick<Iframe, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContent' }
      & Pick<ImageContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContentCardGrid' }
      & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageGalleryCarousel' }
      & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageItem' }
      & Pick<ImageItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgArticleCard' }
      & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgCampaignCard' }
      & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentBlock' }
      & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentCard' }
      & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgFactSheetCard' }
      & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgGroup' }
      & Pick<ImgGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagram' }
      & Pick<Instagram, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramContentCarousel' }
      & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramFeed' }
      & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'internalFeatureCta' }
      & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'locationRegion' }
      & Pick<LocationRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapCountry' }
      & Pick<MapCountry, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapRegion' }
      & Pick<MapRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mediaDownloadCarousel' }
      & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'newsletter' }
      & Pick<Newsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageAboutUs' }
      & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageActNow' }
      & Pick<PageActNow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageCard' }
      & Pick<PageCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageChallenges' }
      & Pick<PageChallenges, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageContactUs' }
      & Pick<PageContactUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDefinitions' }
      & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDonate' }
      & Pick<PageDonate, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageEqualRights' }
      & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageFaqs' }
      & Pick<PageFaqs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageGeneralContent' }
      & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageKnowTheFacts' }
      & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageNewsletter' }
      & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurCampaigns' }
      & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurWork' }
      & Pick<PageOurWork, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageResources' }
      & Pick<PageResources, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageRightToLove' }
      & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageUpdates' }
      & Pick<PageUpdates, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageWhatWeDo' }
      & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedArticles' }
      & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedCampaigns' }
      & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedFactSheets' }
      & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordion' }
      & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordionGroup' }
      & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentBlock' }
      & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentCard' }
      & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentGrid' }
      & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simplePageCardCarousel' }
      & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialContentCard' }
      & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialPlatform' }
      & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subheader' }
      & Pick<Subheader, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subscription' }
      & Pick<Subscription, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeContentItem' }
      & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeHomePage' }
      & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeMap' }
      & Pick<UnfeMap, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavigation' }
      & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'youtubeVideo' }
      & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
    )>>> }
  )> }
);

export type ImgFactSheetCardFragmentFragment = (
  { __typename?: 'imgFactSheetCard' }
  & Pick<ImgFactSheetCard, 'imgAlignment' | 'displayShadow' | 'title' | 'content'>
  & { page?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<(
      { __typename?: 'GenericTag' }
      & Pick<GenericTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Homepagebanner' }
      & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'IconBlockRow' }
      & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'ImgTitleContentCardGroup' }
      & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Taxonomy' }
      & Pick<Taxonomy, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordion' }
      & Pick<Accordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordionGroup' }
      & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'article' }
      & Pick<Article, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'articleCard' }
      & Pick<ArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'banner' }
      & Pick<Banner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaign' }
      & Pick<Campaign, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaignCard' }
      & Pick<CampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'content' }
      & Pick<Content, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentExternalLinkCard' }
      & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentIntro' }
      & Pick<ContentIntro, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCards' }
      & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCardsGroup' }
      & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'country' }
      & Pick<Country, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'definitionItem' }
      & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadCard' }
      & Pick<DownloadCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadGrid' }
      & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadMediaCard' }
      & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalFeatureCta' }
      & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalLinkCardGroup' }
      & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheet' }
      & Pick<FactSheet, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetCard' }
      & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetGrid' }
      & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureImg' }
      & Pick<FeatureImg, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureLogoRow' }
      & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figureBlock' }
      & Pick<FigureBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figuresBlock' }
      & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'footer' }
      & Pick<Footer, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'heroImage' }
      & Pick<HeroImage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'homepage' }
      & Pick<Homepage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iconBlock' }
      & Pick<IconBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iframe' }
      & Pick<Iframe, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContent' }
      & Pick<ImageContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContentCardGrid' }
      & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageGalleryCarousel' }
      & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageItem' }
      & Pick<ImageItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgArticleCard' }
      & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgCampaignCard' }
      & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentBlock' }
      & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentCard' }
      & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgFactSheetCard' }
      & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgGroup' }
      & Pick<ImgGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagram' }
      & Pick<Instagram, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramContentCarousel' }
      & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramFeed' }
      & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'internalFeatureCta' }
      & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'locationRegion' }
      & Pick<LocationRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapCountry' }
      & Pick<MapCountry, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapRegion' }
      & Pick<MapRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mediaDownloadCarousel' }
      & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'newsletter' }
      & Pick<Newsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageAboutUs' }
      & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageActNow' }
      & Pick<PageActNow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageCard' }
      & Pick<PageCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageChallenges' }
      & Pick<PageChallenges, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageContactUs' }
      & Pick<PageContactUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDefinitions' }
      & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDonate' }
      & Pick<PageDonate, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageEqualRights' }
      & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageFaqs' }
      & Pick<PageFaqs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageGeneralContent' }
      & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageKnowTheFacts' }
      & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageNewsletter' }
      & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurCampaigns' }
      & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurWork' }
      & Pick<PageOurWork, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageResources' }
      & Pick<PageResources, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageRightToLove' }
      & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageUpdates' }
      & Pick<PageUpdates, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageWhatWeDo' }
      & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedArticles' }
      & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedCampaigns' }
      & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedFactSheets' }
      & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordion' }
      & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordionGroup' }
      & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentBlock' }
      & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentCard' }
      & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentGrid' }
      & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simplePageCardCarousel' }
      & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialContentCard' }
      & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialPlatform' }
      & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subheader' }
      & Pick<Subheader, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subscription' }
      & Pick<Subscription, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeContentItem' }
      & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeHomePage' }
      & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeMap' }
      & Pick<UnfeMap, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavigation' }
      & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'youtubeVideo' }
      & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
    )>>> }
  )> }
);

export type ImgContentBlockFragmentFragment = (
  { __typename?: 'imgContentBlock' }
  & Pick<ImgContentBlock, 'content' | 'imgAlignment' | 'title' | 'label' | 'newTab'>
  & { img?: Maybe<(
    { __typename?: 'MediaField' }
    & Pick<MediaField, 'urls'>
  )>, link?: Maybe<(
    { __typename?: 'LinkField' }
    & Pick<LinkField, 'url' | 'text'>
  )> }
);

export type ImgGroupFragmentFragment = (
  { __typename?: 'imgGroup' }
  & { imgs?: Maybe<(
    { __typename?: 'MediaField' }
    & Pick<MediaField, 'urls'>
  )> }
);

export type ImgTitleContentGroupFragmentFragment = (
  { __typename?: 'ImgTitleContentCardGroup' }
  & Pick<ImgTitleContentCardGroup, 'removeTopSpacing'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )>, items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | (
      { __typename?: 'articleCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'banner' } | { __typename?: 'campaign' } | (
      { __typename?: 'campaignCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | (
      { __typename?: 'factSheetCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | (
      { __typename?: 'pageCard' }
      & { page?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type InstagramQueryQueryVariables = Exact<{
  status?: Maybe<Status>;
}>;


export type InstagramQueryQuery = (
  { __typename?: 'Query' }
  & { instagram?: Maybe<Array<Maybe<(
    { __typename?: 'instagram' }
    & Pick<Instagram, 'token'>
    & { imgs?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | (
      { __typename?: 'instagramFeed' }
      & Pick<InstagramFeed, 'alt' | 'url' | 'mediaType'>
      & { title: InstagramFeed['displayText'] }
    ) | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )>>> }
);

export type InternalFeatureCtaFragmentFragment = (
  { __typename?: 'internalFeatureCta' }
  & Pick<InternalFeatureCta, 'removeTopSpacing' | 'removeBottomSpacing' | 'mods'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )>, link?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & Pick<ContentPickerField, 'contentItemIds'>
  )> }
);

export type MapCountryFragmentFragment = (
  { __typename?: 'mapCountry' }
  & Pick<MapCountry, 'content' | 'subTitle'>
  & { img?: Maybe<(
    { __typename?: 'MediaField' }
    & Pick<MediaField, 'urls'>
  )>, country?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | (
      { __typename?: 'country' }
      & Pick<Country, 'name'>
      & { locations?: Maybe<(
        { __typename?: 'TaxonomyField' }
        & Pick<TaxonomyField, 'termContentItemIds'>
      )> }
    ) | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type MapFragmentFragment = (
  { __typename?: 'unfeMap' }
  & Pick<UnfeMap, 'popupIconStyle' | 'displayRelatedItems'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )>, regions?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | (
      { __typename?: 'mapRegion' }
      & MapRegionFragmentFragment
    ) | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type MapRegionFragmentFragment = (
  { __typename?: 'mapRegion' }
  & { region?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | (
      { __typename?: 'locationRegion' }
      & Pick<LocationRegion, 'name' | 'value'>
    ) | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )>, countries?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | (
      { __typename?: 'mapCountry' }
      & MapCountryFragmentFragment
    ) | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type MediaDownloadCarouselFragmentFragment = (
  { __typename?: 'mediaDownloadCarousel' }
  & Pick<MediaDownloadCarousel, 'mods' | 'removeBottomSpacing' | 'removeTopSpacing'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )>, items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<(
      { __typename?: 'GenericTag' }
      & Pick<GenericTag, 'contentItemId'>
    ) | (
      { __typename?: 'Homepagebanner' }
      & Pick<Homepagebanner, 'contentItemId'>
    ) | (
      { __typename?: 'IconBlockRow' }
      & Pick<IconBlockRow, 'contentItemId'>
    ) | (
      { __typename?: 'ImgTitleContentCardGroup' }
      & Pick<ImgTitleContentCardGroup, 'contentItemId'>
    ) | (
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'contentItemId'>
    ) | (
      { __typename?: 'Taxonomy' }
      & Pick<Taxonomy, 'contentItemId'>
    ) | (
      { __typename?: 'accordion' }
      & Pick<Accordion, 'contentItemId'>
    ) | (
      { __typename?: 'accordionGroup' }
      & Pick<AccordionGroup, 'contentItemId'>
    ) | (
      { __typename?: 'article' }
      & Pick<Article, 'contentItemId'>
    ) | (
      { __typename?: 'articleCard' }
      & Pick<ArticleCard, 'contentItemId'>
    ) | (
      { __typename?: 'banner' }
      & Pick<Banner, 'contentItemId'>
    ) | (
      { __typename?: 'campaign' }
      & Pick<Campaign, 'contentItemId'>
    ) | (
      { __typename?: 'campaignCard' }
      & Pick<CampaignCard, 'contentItemId'>
    ) | (
      { __typename?: 'content' }
      & Pick<Content, 'contentItemId'>
    ) | (
      { __typename?: 'contentExternalLinkCard' }
      & Pick<ContentExternalLinkCard, 'contentItemId'>
    ) | (
      { __typename?: 'contentIntro' }
      & Pick<ContentIntro, 'contentItemId'>
    ) | (
      { __typename?: 'contentPageCards' }
      & Pick<ContentPageCards, 'contentItemId'>
    ) | (
      { __typename?: 'contentPageCardsGroup' }
      & Pick<ContentPageCardsGroup, 'contentItemId'>
    ) | (
      { __typename?: 'country' }
      & Pick<Country, 'contentItemId'>
    ) | (
      { __typename?: 'definitionItem' }
      & Pick<DefinitionItem, 'contentItemId'>
    ) | (
      { __typename?: 'downloadCard' }
      & Pick<DownloadCard, 'contentItemId'>
    ) | (
      { __typename?: 'downloadGrid' }
      & Pick<DownloadGrid, 'contentItemId'>
    ) | (
      { __typename?: 'downloadMediaCard' }
      & Pick<DownloadMediaCard, 'contentItemId'>
      & { bgImg?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )>, media?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    ) | (
      { __typename?: 'externalFeatureCta' }
      & Pick<ExternalFeatureCta, 'contentItemId'>
    ) | (
      { __typename?: 'externalLinkCardGroup' }
      & Pick<ExternalLinkCardGroup, 'contentItemId'>
    ) | (
      { __typename?: 'factSheet' }
      & Pick<FactSheet, 'contentItemId'>
    ) | (
      { __typename?: 'factSheetCard' }
      & Pick<FactSheetCard, 'contentItemId'>
    ) | (
      { __typename?: 'factSheetGrid' }
      & Pick<FactSheetGrid, 'contentItemId'>
    ) | (
      { __typename?: 'featureImg' }
      & Pick<FeatureImg, 'contentItemId'>
    ) | (
      { __typename?: 'featureLogoRow' }
      & Pick<FeatureLogoRow, 'contentItemId'>
    ) | (
      { __typename?: 'figureBlock' }
      & Pick<FigureBlock, 'contentItemId'>
    ) | (
      { __typename?: 'figuresBlock' }
      & Pick<FiguresBlock, 'contentItemId'>
    ) | (
      { __typename?: 'footer' }
      & Pick<Footer, 'contentItemId'>
    ) | (
      { __typename?: 'heroImage' }
      & Pick<HeroImage, 'contentItemId'>
    ) | (
      { __typename?: 'homepage' }
      & Pick<Homepage, 'contentItemId'>
    ) | (
      { __typename?: 'iconBlock' }
      & Pick<IconBlock, 'contentItemId'>
    ) | (
      { __typename?: 'iframe' }
      & Pick<Iframe, 'contentItemId'>
    ) | (
      { __typename?: 'imageContent' }
      & Pick<ImageContent, 'contentItemId'>
    ) | (
      { __typename?: 'imageContentCardGrid' }
      & Pick<ImageContentCardGrid, 'contentItemId'>
    ) | (
      { __typename?: 'imageGalleryCarousel' }
      & Pick<ImageGalleryCarousel, 'contentItemId'>
    ) | (
      { __typename?: 'imageItem' }
      & Pick<ImageItem, 'contentItemId'>
    ) | (
      { __typename?: 'imgArticleCard' }
      & Pick<ImgArticleCard, 'contentItemId'>
    ) | (
      { __typename?: 'imgCampaignCard' }
      & Pick<ImgCampaignCard, 'contentItemId'>
    ) | (
      { __typename?: 'imgContentBlock' }
      & Pick<ImgContentBlock, 'contentItemId'>
    ) | (
      { __typename?: 'imgContentCard' }
      & Pick<ImgContentCard, 'contentItemId'>
    ) | (
      { __typename?: 'imgFactSheetCard' }
      & Pick<ImgFactSheetCard, 'contentItemId'>
    ) | (
      { __typename?: 'imgGroup' }
      & Pick<ImgGroup, 'contentItemId'>
    ) | (
      { __typename?: 'instagram' }
      & Pick<Instagram, 'contentItemId'>
    ) | (
      { __typename?: 'instagramContentCarousel' }
      & Pick<InstagramContentCarousel, 'contentItemId'>
    ) | (
      { __typename?: 'instagramFeed' }
      & Pick<InstagramFeed, 'contentItemId'>
    ) | (
      { __typename?: 'internalFeatureCta' }
      & Pick<InternalFeatureCta, 'contentItemId'>
    ) | (
      { __typename?: 'locationRegion' }
      & Pick<LocationRegion, 'contentItemId'>
    ) | (
      { __typename?: 'mapCountry' }
      & Pick<MapCountry, 'contentItemId'>
    ) | (
      { __typename?: 'mapRegion' }
      & Pick<MapRegion, 'contentItemId'>
    ) | (
      { __typename?: 'mediaDownloadCarousel' }
      & Pick<MediaDownloadCarousel, 'contentItemId'>
    ) | (
      { __typename?: 'newsletter' }
      & Pick<Newsletter, 'contentItemId'>
    ) | (
      { __typename?: 'pageAboutUs' }
      & Pick<PageAboutUs, 'contentItemId'>
    ) | (
      { __typename?: 'pageActNow' }
      & Pick<PageActNow, 'contentItemId'>
    ) | (
      { __typename?: 'pageCard' }
      & Pick<PageCard, 'contentItemId'>
    ) | (
      { __typename?: 'pageChallenges' }
      & Pick<PageChallenges, 'contentItemId'>
    ) | (
      { __typename?: 'pageContactUs' }
      & Pick<PageContactUs, 'contentItemId'>
    ) | (
      { __typename?: 'pageDefinitions' }
      & Pick<PageDefinitions, 'contentItemId'>
    ) | (
      { __typename?: 'pageDonate' }
      & Pick<PageDonate, 'contentItemId'>
    ) | (
      { __typename?: 'pageEqualRights' }
      & Pick<PageEqualRights, 'contentItemId'>
    ) | (
      { __typename?: 'pageFaqs' }
      & Pick<PageFaqs, 'contentItemId'>
    ) | (
      { __typename?: 'pageGeneralContent' }
      & Pick<PageGeneralContent, 'contentItemId'>
    ) | (
      { __typename?: 'pageKnowTheFacts' }
      & Pick<PageKnowTheFacts, 'contentItemId'>
    ) | (
      { __typename?: 'pageNewsletter' }
      & Pick<PageNewsletter, 'contentItemId'>
    ) | (
      { __typename?: 'pageOurCampaigns' }
      & Pick<PageOurCampaigns, 'contentItemId'>
    ) | (
      { __typename?: 'pageOurWork' }
      & Pick<PageOurWork, 'contentItemId'>
    ) | (
      { __typename?: 'pageResources' }
      & Pick<PageResources, 'contentItemId'>
    ) | (
      { __typename?: 'pageRightToLove' }
      & Pick<PageRightToLove, 'contentItemId'>
    ) | (
      { __typename?: 'pageUpdates' }
      & Pick<PageUpdates, 'contentItemId'>
    ) | (
      { __typename?: 'pageWhatWeDo' }
      & Pick<PageWhatWeDo, 'contentItemId'>
    ) | (
      { __typename?: 'relatedArticles' }
      & Pick<RelatedArticles, 'contentItemId'>
    ) | (
      { __typename?: 'relatedCampaigns' }
      & Pick<RelatedCampaigns, 'contentItemId'>
    ) | (
      { __typename?: 'relatedFactSheets' }
      & Pick<RelatedFactSheets, 'contentItemId'>
    ) | (
      { __typename?: 'simpleAccordion' }
      & Pick<SimpleAccordion, 'contentItemId'>
    ) | (
      { __typename?: 'simpleAccordionGroup' }
      & Pick<SimpleAccordionGroup, 'contentItemId'>
    ) | (
      { __typename?: 'simpleContentBlock' }
      & Pick<SimpleContentBlock, 'contentItemId'>
    ) | (
      { __typename?: 'simpleContentCard' }
      & Pick<SimpleContentCard, 'contentItemId'>
    ) | (
      { __typename?: 'simpleContentGrid' }
      & Pick<SimpleContentGrid, 'contentItemId'>
    ) | (
      { __typename?: 'simplePageCardCarousel' }
      & Pick<SimplePageCardCarousel, 'contentItemId'>
    ) | (
      { __typename?: 'socialContentCard' }
      & Pick<SocialContentCard, 'contentItemId'>
    ) | (
      { __typename?: 'socialPlatform' }
      & Pick<SocialPlatform, 'contentItemId'>
    ) | (
      { __typename?: 'subheader' }
      & Pick<Subheader, 'contentItemId'>
    ) | (
      { __typename?: 'subscription' }
      & Pick<Subscription, 'contentItemId'>
    ) | (
      { __typename?: 'unfeContentItem' }
      & Pick<UnfeContentItem, 'contentItemId'>
    ) | (
      { __typename?: 'unfeHomePage' }
      & Pick<UnfeHomePage, 'contentItemId'>
    ) | (
      { __typename?: 'unfeMap' }
      & Pick<UnfeMap, 'contentItemId'>
    ) | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'contentItemId'>
    ) | (
      { __typename?: 'unfeNavigation' }
      & Pick<UnfeNavigation, 'contentItemId'>
    ) | (
      { __typename?: 'youtubeVideo' }
      & Pick<YoutubeVideo, 'contentItemId'>
    )>>> }
  )> }
);

export type NavigationQueryVariables = Exact<{
  status?: Maybe<Status>;
}>;


export type NavigationQuery = (
  { __typename?: 'Query' }
  & { unfeNavigation?: Maybe<Array<Maybe<(
    { __typename?: 'unfeNavigation' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'displayText' | 'contentType'>
      & { content?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & Pick<ContentPickerField, 'contentItemIds'>
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )>, subNav?: Maybe<(
        { __typename?: 'BagPart' }
        & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentType' | 'displayText'>
          & { content?: Maybe<(
            { __typename?: 'ContentPickerField' }
            & Pick<ContentPickerField, 'contentItemIds'>
            & { contentItems?: Maybe<Array<Maybe<(
              { __typename?: 'GenericTag' }
              & Pick<GenericTag, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'Homepagebanner' }
              & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'IconBlockRow' }
              & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'ImgTitleContentCardGroup' }
              & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'LocationTag' }
              & Pick<LocationTag, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'Taxonomy' }
              & Pick<Taxonomy, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'accordion' }
              & Pick<Accordion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'accordionGroup' }
              & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'article' }
              & Pick<Article, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'articleCard' }
              & Pick<ArticleCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'banner' }
              & Pick<Banner, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'campaign' }
              & Pick<Campaign, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'campaignCard' }
              & Pick<CampaignCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'content' }
              & Pick<Content, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentExternalLinkCard' }
              & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentIntro' }
              & Pick<ContentIntro, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentPageCards' }
              & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentPageCardsGroup' }
              & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'country' }
              & Pick<Country, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'definitionItem' }
              & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadCard' }
              & Pick<DownloadCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadGrid' }
              & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadMediaCard' }
              & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'externalFeatureCta' }
              & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'externalLinkCardGroup' }
              & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheet' }
              & Pick<FactSheet, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheetCard' }
              & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheetGrid' }
              & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'featureImg' }
              & Pick<FeatureImg, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'featureLogoRow' }
              & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'figureBlock' }
              & Pick<FigureBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'figuresBlock' }
              & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'footer' }
              & Pick<Footer, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'heroImage' }
              & Pick<HeroImage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'homepage' }
              & Pick<Homepage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'iconBlock' }
              & Pick<IconBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'iframe' }
              & Pick<Iframe, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageContent' }
              & Pick<ImageContent, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageContentCardGrid' }
              & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageGalleryCarousel' }
              & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageItem' }
              & Pick<ImageItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgArticleCard' }
              & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgCampaignCard' }
              & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgContentBlock' }
              & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgContentCard' }
              & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgFactSheetCard' }
              & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgGroup' }
              & Pick<ImgGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagram' }
              & Pick<Instagram, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagramContentCarousel' }
              & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagramFeed' }
              & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'internalFeatureCta' }
              & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'locationRegion' }
              & Pick<LocationRegion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mapCountry' }
              & Pick<MapCountry, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mapRegion' }
              & Pick<MapRegion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mediaDownloadCarousel' }
              & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'newsletter' }
              & Pick<Newsletter, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageAboutUs' }
              & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageActNow' }
              & Pick<PageActNow, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageCard' }
              & Pick<PageCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageChallenges' }
              & Pick<PageChallenges, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageContactUs' }
              & Pick<PageContactUs, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageDefinitions' }
              & Pick<PageDefinitions, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageDonate' }
              & Pick<PageDonate, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageEqualRights' }
              & Pick<PageEqualRights, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageFaqs' }
              & Pick<PageFaqs, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageGeneralContent' }
              & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageKnowTheFacts' }
              & Pick<PageKnowTheFacts, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageNewsletter' }
              & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageOurCampaigns' }
              & Pick<PageOurCampaigns, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageOurWork' }
              & Pick<PageOurWork, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageResources' }
              & Pick<PageResources, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageRightToLove' }
              & Pick<PageRightToLove, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageUpdates' }
              & Pick<PageUpdates, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageWhatWeDo' }
              & Pick<PageWhatWeDo, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedArticles' }
              & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedCampaigns' }
              & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedFactSheets' }
              & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleAccordion' }
              & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleAccordionGroup' }
              & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentBlock' }
              & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentCard' }
              & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentGrid' }
              & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simplePageCardCarousel' }
              & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'socialContentCard' }
              & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'socialPlatform' }
              & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'subheader' }
              & Pick<Subheader, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'subscription' }
              & Pick<Subscription, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeContentItem' }
              & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeHomePage' }
              & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeMap' }
              & Pick<UnfeMap, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeNavItem' }
              & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeNavigation' }
              & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'youtubeVideo' }
              & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
            )>>> }
          )> }
        ) | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
      )> }
    ) | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>>, localization?: Maybe<(
      { __typename?: 'LocalizationPart' }
      & Pick<LocalizationPart, 'culture'>
    )> }
  )>>> }
);

export type NavigationOldQueryVariables = Exact<{
  localizationSet?: Maybe<Scalars['String']>;
  culture?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
}>;


export type NavigationOldQuery = (
  { __typename?: 'Query' }
  & { unfeNavigation?: Maybe<Array<Maybe<(
    { __typename?: 'unfeNavigation' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'displayText' | 'contentType'>
      & { content?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & Pick<ContentPickerField, 'contentItemIds'>
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )>, subNav?: Maybe<(
        { __typename?: 'BagPart' }
        & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentType' | 'displayText'>
          & { content?: Maybe<(
            { __typename?: 'ContentPickerField' }
            & Pick<ContentPickerField, 'contentItemIds'>
            & { contentItems?: Maybe<Array<Maybe<(
              { __typename?: 'GenericTag' }
              & Pick<GenericTag, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'Homepagebanner' }
              & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'IconBlockRow' }
              & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'ImgTitleContentCardGroup' }
              & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'LocationTag' }
              & Pick<LocationTag, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'Taxonomy' }
              & Pick<Taxonomy, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'accordion' }
              & Pick<Accordion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'accordionGroup' }
              & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'article' }
              & Pick<Article, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'articleCard' }
              & Pick<ArticleCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'banner' }
              & Pick<Banner, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'campaign' }
              & Pick<Campaign, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'campaignCard' }
              & Pick<CampaignCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'content' }
              & Pick<Content, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentExternalLinkCard' }
              & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentIntro' }
              & Pick<ContentIntro, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentPageCards' }
              & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentPageCardsGroup' }
              & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'country' }
              & Pick<Country, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'definitionItem' }
              & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadCard' }
              & Pick<DownloadCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadGrid' }
              & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadMediaCard' }
              & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'externalFeatureCta' }
              & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'externalLinkCardGroup' }
              & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheet' }
              & Pick<FactSheet, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheetCard' }
              & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheetGrid' }
              & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'featureImg' }
              & Pick<FeatureImg, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'featureLogoRow' }
              & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'figureBlock' }
              & Pick<FigureBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'figuresBlock' }
              & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'footer' }
              & Pick<Footer, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'heroImage' }
              & Pick<HeroImage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'homepage' }
              & Pick<Homepage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'iconBlock' }
              & Pick<IconBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'iframe' }
              & Pick<Iframe, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageContent' }
              & Pick<ImageContent, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageContentCardGrid' }
              & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageGalleryCarousel' }
              & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageItem' }
              & Pick<ImageItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgArticleCard' }
              & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgCampaignCard' }
              & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgContentBlock' }
              & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgContentCard' }
              & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgFactSheetCard' }
              & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgGroup' }
              & Pick<ImgGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagram' }
              & Pick<Instagram, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagramContentCarousel' }
              & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagramFeed' }
              & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'internalFeatureCta' }
              & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'locationRegion' }
              & Pick<LocationRegion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mapCountry' }
              & Pick<MapCountry, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mapRegion' }
              & Pick<MapRegion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mediaDownloadCarousel' }
              & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'newsletter' }
              & Pick<Newsletter, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageAboutUs' }
              & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageActNow' }
              & Pick<PageActNow, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageCard' }
              & Pick<PageCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageChallenges' }
              & Pick<PageChallenges, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageContactUs' }
              & Pick<PageContactUs, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageDefinitions' }
              & Pick<PageDefinitions, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageDonate' }
              & Pick<PageDonate, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageEqualRights' }
              & Pick<PageEqualRights, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageFaqs' }
              & Pick<PageFaqs, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageGeneralContent' }
              & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageKnowTheFacts' }
              & Pick<PageKnowTheFacts, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageNewsletter' }
              & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageOurCampaigns' }
              & Pick<PageOurCampaigns, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageOurWork' }
              & Pick<PageOurWork, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageResources' }
              & Pick<PageResources, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageRightToLove' }
              & Pick<PageRightToLove, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageUpdates' }
              & Pick<PageUpdates, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageWhatWeDo' }
              & Pick<PageWhatWeDo, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedArticles' }
              & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedCampaigns' }
              & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedFactSheets' }
              & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleAccordion' }
              & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleAccordionGroup' }
              & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentBlock' }
              & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentCard' }
              & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentGrid' }
              & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simplePageCardCarousel' }
              & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'socialContentCard' }
              & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'socialPlatform' }
              & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'subheader' }
              & Pick<Subheader, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'subscription' }
              & Pick<Subscription, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeContentItem' }
              & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeHomePage' }
              & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeMap' }
              & Pick<UnfeMap, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeNavItem' }
              & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeNavigation' }
              & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'youtubeVideo' }
              & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
            )>>> }
          )> }
        ) | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
      )> }
    ) | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )>>> }
);

export type AboutUsComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type AboutUsComponentsQuery = (
  { __typename?: 'Query' }
  & { pageAboutUs?: Maybe<Array<Maybe<(
    { __typename?: 'pageAboutUs' }
    & Pick<PageAboutUs, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, featureLogoRow?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | (
        { __typename?: 'featureLogoRow' }
        & FeatureLogoRowFragmentFragment
      ) | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, imgContentCardGroup?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | (
        { __typename?: 'imgContentBlock' }
        & ImgContentBlockFragmentFragment
      ) | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type AboutUsMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type AboutUsMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageAboutUs' }
    & Pick<PageAboutUs, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type ActNowComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ActNowComponentsQuery = (
  { __typename?: 'Query' }
  & { pageActNow?: Maybe<Array<Maybe<(
    { __typename?: 'pageActNow' }
    & Pick<PageActNow, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, actContentCardCarousel?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | (
        { __typename?: 'simplePageCardCarousel' }
        & SimplePageCarouselFragmentFragment
      ) | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, socialContentCol?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | (
        { __typename?: 'socialContentCard' }
        & Pick<SocialContentCard, 'content' | 'label' | 'title'>
      ) | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, contentBlockCard?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | (
        { __typename?: 'imgContentBlock' }
        & ImgContentBlockFragmentFragment
      ) | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureCards?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | (
        { __typename?: 'imgArticleCard' }
        & ImgArticleCardFragmentFragment
      ) | (
        { __typename?: 'imgCampaignCard' }
        & ImgCampaignCardFragmentFragment
      ) | { __typename?: 'imgContentBlock' } | (
        { __typename?: 'imgContentCard' }
        & ImgContentCardFragmentFragment
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & ImgFactSheetCardFragmentFragment
      ) | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type ActNowMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ActNowMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageActNow' }
    & Pick<PageActNow, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type ChallengesComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ChallengesComponentsQuery = (
  { __typename?: 'Query' }
  & { pageChallenges?: Maybe<Array<Maybe<(
    { __typename?: 'pageChallenges' }
    & Pick<PageChallenges, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, featureImg?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | (
        { __typename?: 'featureImg' }
        & FeatureImgFragmentFragment
      ) | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, factSheetsGrid?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | (
        { __typename?: 'factSheetGrid' }
        & { sectionIntro?: Maybe<(
          { __typename?: 'SectionIntro' }
          & Pick<SectionIntro, 'title' | 'content'>
        )> }
      ) | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, greyContentRow?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | (
        { __typename?: 'downloadGrid' }
        & DownloadGridFragmentFragment
      ) | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureCards?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | (
        { __typename?: 'imgArticleCard' }
        & ImgArticleCardFragmentFragment
      ) | (
        { __typename?: 'imgCampaignCard' }
        & ImgCampaignCardFragmentFragment
      ) | { __typename?: 'imgContentBlock' } | (
        { __typename?: 'imgContentCard' }
        & ImgContentCardFragmentFragment
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & ImgFactSheetCardFragmentFragment
      ) | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type ChallengesMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ChallengesMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageChallenges' }
    & Pick<PageChallenges, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type ContactUsComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ContactUsComponentsQuery = (
  { __typename?: 'Query' }
  & { pageContactUs?: Maybe<Array<Maybe<(
    { __typename?: 'pageContactUs' }
    & Pick<PageContactUs, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, smallCardContentGroup?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | (
        { __typename?: 'contentPageCards' }
        & ContentPageCardsFragmentFragment
      ) | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | (
        { __typename?: 'subheader' }
        & Pick<Subheader, 'content'>
        & { title: Subheader['displayText'] }
      ) | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, externalLinkContentBlock?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | (
        { __typename?: 'externalLinkCardGroup' }
        & ExternalLinkCardGroupFragmentFragment
      ) | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type ContactUsMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ContactUsMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageContactUs' }
    & Pick<PageContactUs, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type DefinitionsComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type DefinitionsComponentsQuery = (
  { __typename?: 'Query' }
  & { pageDefinitions?: Maybe<Array<Maybe<(
    { __typename?: 'pageDefinitions' }
    & Pick<PageDefinitions, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, definitionItemGroup?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | (
        { __typename?: 'accordion' }
        & AccordionFragmentFragment
      ) | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureCards?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | (
        { __typename?: 'imgArticleCard' }
        & ImgArticleCardFragmentFragment
      ) | (
        { __typename?: 'imgCampaignCard' }
        & ImgCampaignCardFragmentFragment
      ) | { __typename?: 'imgContentBlock' } | (
        { __typename?: 'imgContentCard' }
        & ImgContentCardFragmentFragment
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & ImgFactSheetCardFragmentFragment
      ) | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type DefinitionsMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type DefinitionsMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageDefinitions' }
    & Pick<PageDefinitions, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type DonatePageComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type DonatePageComponentsQuery = (
  { __typename?: 'Query' }
  & { pageDonate?: Maybe<Array<Maybe<(
    { __typename?: 'pageDonate' }
    & Pick<PageDonate, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, featureCards?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | (
        { __typename?: 'imgContentBlock' }
        & ImgContentBlockFragmentFragment
      ) | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, iconBlockRow?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | (
        { __typename?: 'IconBlockRow' }
        & IconBlockRowFragmentFragment
      ) | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureCtaGroup?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<(
        { __typename?: 'GenericTag' }
        & Pick<GenericTag, 'contentType'>
      ) | (
        { __typename?: 'Homepagebanner' }
        & Pick<Homepagebanner, 'contentType'>
      ) | (
        { __typename?: 'IconBlockRow' }
        & Pick<IconBlockRow, 'contentType'>
      ) | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & Pick<ImgTitleContentCardGroup, 'contentType'>
      ) | (
        { __typename?: 'LocationTag' }
        & Pick<LocationTag, 'contentType'>
      ) | (
        { __typename?: 'Taxonomy' }
        & Pick<Taxonomy, 'contentType'>
      ) | (
        { __typename?: 'accordion' }
        & Pick<Accordion, 'contentType'>
      ) | (
        { __typename?: 'accordionGroup' }
        & Pick<AccordionGroup, 'contentType'>
      ) | (
        { __typename?: 'article' }
        & Pick<Article, 'contentType'>
      ) | (
        { __typename?: 'articleCard' }
        & Pick<ArticleCard, 'contentType'>
      ) | (
        { __typename?: 'banner' }
        & Pick<Banner, 'contentType'>
      ) | (
        { __typename?: 'campaign' }
        & Pick<Campaign, 'contentType'>
      ) | (
        { __typename?: 'campaignCard' }
        & Pick<CampaignCard, 'contentType'>
      ) | (
        { __typename?: 'content' }
        & Pick<Content, 'contentType'>
      ) | (
        { __typename?: 'contentExternalLinkCard' }
        & Pick<ContentExternalLinkCard, 'contentType'>
      ) | (
        { __typename?: 'contentIntro' }
        & Pick<ContentIntro, 'contentType'>
      ) | (
        { __typename?: 'contentPageCards' }
        & Pick<ContentPageCards, 'contentType'>
      ) | (
        { __typename?: 'contentPageCardsGroup' }
        & Pick<ContentPageCardsGroup, 'contentType'>
      ) | (
        { __typename?: 'country' }
        & Pick<Country, 'contentType'>
      ) | (
        { __typename?: 'definitionItem' }
        & Pick<DefinitionItem, 'contentType'>
      ) | (
        { __typename?: 'downloadCard' }
        & Pick<DownloadCard, 'contentType'>
      ) | (
        { __typename?: 'downloadGrid' }
        & Pick<DownloadGrid, 'contentType'>
      ) | (
        { __typename?: 'downloadMediaCard' }
        & Pick<DownloadMediaCard, 'contentType'>
      ) | (
        { __typename?: 'externalFeatureCta' }
        & Pick<ExternalFeatureCta, 'contentType'>
        & ExternalFeatureCtaFragmentFragment
      ) | (
        { __typename?: 'externalLinkCardGroup' }
        & Pick<ExternalLinkCardGroup, 'contentType'>
      ) | (
        { __typename?: 'factSheet' }
        & Pick<FactSheet, 'contentType'>
      ) | (
        { __typename?: 'factSheetCard' }
        & Pick<FactSheetCard, 'contentType'>
      ) | (
        { __typename?: 'factSheetGrid' }
        & Pick<FactSheetGrid, 'contentType'>
      ) | (
        { __typename?: 'featureImg' }
        & Pick<FeatureImg, 'contentType'>
      ) | (
        { __typename?: 'featureLogoRow' }
        & Pick<FeatureLogoRow, 'contentType'>
      ) | (
        { __typename?: 'figureBlock' }
        & Pick<FigureBlock, 'contentType'>
      ) | (
        { __typename?: 'figuresBlock' }
        & Pick<FiguresBlock, 'contentType'>
      ) | (
        { __typename?: 'footer' }
        & Pick<Footer, 'contentType'>
      ) | (
        { __typename?: 'heroImage' }
        & Pick<HeroImage, 'contentType'>
      ) | (
        { __typename?: 'homepage' }
        & Pick<Homepage, 'contentType'>
      ) | (
        { __typename?: 'iconBlock' }
        & Pick<IconBlock, 'contentType'>
      ) | (
        { __typename?: 'iframe' }
        & Pick<Iframe, 'contentType'>
      ) | (
        { __typename?: 'imageContent' }
        & Pick<ImageContent, 'contentType'>
      ) | (
        { __typename?: 'imageContentCardGrid' }
        & Pick<ImageContentCardGrid, 'contentType'>
      ) | (
        { __typename?: 'imageGalleryCarousel' }
        & Pick<ImageGalleryCarousel, 'contentType'>
      ) | (
        { __typename?: 'imageItem' }
        & Pick<ImageItem, 'contentType'>
      ) | (
        { __typename?: 'imgArticleCard' }
        & Pick<ImgArticleCard, 'contentType'>
      ) | (
        { __typename?: 'imgCampaignCard' }
        & Pick<ImgCampaignCard, 'contentType'>
      ) | (
        { __typename?: 'imgContentBlock' }
        & Pick<ImgContentBlock, 'contentType'>
      ) | (
        { __typename?: 'imgContentCard' }
        & Pick<ImgContentCard, 'contentType'>
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & Pick<ImgFactSheetCard, 'contentType'>
      ) | (
        { __typename?: 'imgGroup' }
        & Pick<ImgGroup, 'contentType'>
      ) | (
        { __typename?: 'instagram' }
        & Pick<Instagram, 'contentType'>
      ) | (
        { __typename?: 'instagramContentCarousel' }
        & Pick<InstagramContentCarousel, 'contentType'>
      ) | (
        { __typename?: 'instagramFeed' }
        & Pick<InstagramFeed, 'contentType'>
      ) | (
        { __typename?: 'internalFeatureCta' }
        & Pick<InternalFeatureCta, 'contentType'>
        & InternalFeatureCtaFragmentFragment
      ) | (
        { __typename?: 'locationRegion' }
        & Pick<LocationRegion, 'contentType'>
      ) | (
        { __typename?: 'mapCountry' }
        & Pick<MapCountry, 'contentType'>
      ) | (
        { __typename?: 'mapRegion' }
        & Pick<MapRegion, 'contentType'>
      ) | (
        { __typename?: 'mediaDownloadCarousel' }
        & Pick<MediaDownloadCarousel, 'contentType'>
      ) | (
        { __typename?: 'newsletter' }
        & Pick<Newsletter, 'contentType'>
      ) | (
        { __typename?: 'pageAboutUs' }
        & Pick<PageAboutUs, 'contentType'>
      ) | (
        { __typename?: 'pageActNow' }
        & Pick<PageActNow, 'contentType'>
      ) | (
        { __typename?: 'pageCard' }
        & Pick<PageCard, 'contentType'>
      ) | (
        { __typename?: 'pageChallenges' }
        & Pick<PageChallenges, 'contentType'>
      ) | (
        { __typename?: 'pageContactUs' }
        & Pick<PageContactUs, 'contentType'>
      ) | (
        { __typename?: 'pageDefinitions' }
        & Pick<PageDefinitions, 'contentType'>
      ) | (
        { __typename?: 'pageDonate' }
        & Pick<PageDonate, 'contentType'>
      ) | (
        { __typename?: 'pageEqualRights' }
        & Pick<PageEqualRights, 'contentType'>
      ) | (
        { __typename?: 'pageFaqs' }
        & Pick<PageFaqs, 'contentType'>
      ) | (
        { __typename?: 'pageGeneralContent' }
        & Pick<PageGeneralContent, 'contentType'>
      ) | (
        { __typename?: 'pageKnowTheFacts' }
        & Pick<PageKnowTheFacts, 'contentType'>
      ) | (
        { __typename?: 'pageNewsletter' }
        & Pick<PageNewsletter, 'contentType'>
      ) | (
        { __typename?: 'pageOurCampaigns' }
        & Pick<PageOurCampaigns, 'contentType'>
      ) | (
        { __typename?: 'pageOurWork' }
        & Pick<PageOurWork, 'contentType'>
      ) | (
        { __typename?: 'pageResources' }
        & Pick<PageResources, 'contentType'>
      ) | (
        { __typename?: 'pageRightToLove' }
        & Pick<PageRightToLove, 'contentType'>
      ) | (
        { __typename?: 'pageUpdates' }
        & Pick<PageUpdates, 'contentType'>
      ) | (
        { __typename?: 'pageWhatWeDo' }
        & Pick<PageWhatWeDo, 'contentType'>
      ) | (
        { __typename?: 'relatedArticles' }
        & Pick<RelatedArticles, 'contentType'>
      ) | (
        { __typename?: 'relatedCampaigns' }
        & Pick<RelatedCampaigns, 'contentType'>
      ) | (
        { __typename?: 'relatedFactSheets' }
        & Pick<RelatedFactSheets, 'contentType'>
      ) | (
        { __typename?: 'simpleAccordion' }
        & Pick<SimpleAccordion, 'contentType'>
      ) | (
        { __typename?: 'simpleAccordionGroup' }
        & Pick<SimpleAccordionGroup, 'contentType'>
      ) | (
        { __typename?: 'simpleContentBlock' }
        & Pick<SimpleContentBlock, 'contentType'>
      ) | (
        { __typename?: 'simpleContentCard' }
        & Pick<SimpleContentCard, 'contentType'>
      ) | (
        { __typename?: 'simpleContentGrid' }
        & Pick<SimpleContentGrid, 'contentType'>
      ) | (
        { __typename?: 'simplePageCardCarousel' }
        & Pick<SimplePageCardCarousel, 'contentType'>
      ) | (
        { __typename?: 'socialContentCard' }
        & Pick<SocialContentCard, 'contentType'>
      ) | (
        { __typename?: 'socialPlatform' }
        & Pick<SocialPlatform, 'contentType'>
      ) | (
        { __typename?: 'subheader' }
        & Pick<Subheader, 'contentType'>
      ) | (
        { __typename?: 'subscription' }
        & Pick<Subscription, 'contentType'>
      ) | (
        { __typename?: 'unfeContentItem' }
        & Pick<UnfeContentItem, 'contentType'>
      ) | (
        { __typename?: 'unfeHomePage' }
        & Pick<UnfeHomePage, 'contentType'>
      ) | (
        { __typename?: 'unfeMap' }
        & Pick<UnfeMap, 'contentType'>
      ) | (
        { __typename?: 'unfeNavItem' }
        & Pick<UnfeNavItem, 'contentType'>
      ) | (
        { __typename?: 'unfeNavigation' }
        & Pick<UnfeNavigation, 'contentType'>
      ) | (
        { __typename?: 'youtubeVideo' }
        & Pick<YoutubeVideo, 'contentType'>
      )>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type DonateMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type DonateMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageDonate' }
    & Pick<PageDonate, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type EqualRightsComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type EqualRightsComponentsQuery = (
  { __typename?: 'Query' }
  & { pageEqualRights?: Maybe<Array<Maybe<(
    { __typename?: 'pageEqualRights' }
    & Pick<PageEqualRights, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, map?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | (
        { __typename?: 'unfeMap' }
        & MapFragmentFragment
      ) | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type EqualRightsMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type EqualRightsMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageEqualRights' }
    & Pick<PageEqualRights, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type FaqsComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type FaqsComponentsQuery = (
  { __typename?: 'Query' }
  & { pageFaqs?: Maybe<Array<Maybe<(
    { __typename?: 'pageFaqs' }
    & Pick<PageFaqs, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, termBlockRow?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | (
        { __typename?: 'simpleContentGrid' }
        & SimpleContentGridFragmentFragment
      ) | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, faqs?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | (
        { __typename?: 'accordionGroup' }
        & AccordionGroupFragmentFragment
      ) | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type FaqsMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type FaqsMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageFaqs' }
    & Pick<PageFaqs, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type GeneralContentComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type GeneralContentComponentsQuery = (
  { __typename?: 'Query' }
  & { pageGeneralContent?: Maybe<Array<Maybe<(
    { __typename?: 'pageGeneralContent' }
    & Pick<PageGeneralContent, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, wysiwyg?: Maybe<(
      { __typename?: 'HtmlBodyPart' }
      & Pick<HtmlBodyPart, 'html'>
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type GeneralContentMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type GeneralContentMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageGeneralContent' }
    & Pick<PageGeneralContent, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type HomeComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type HomeComponentsQuery = (
  { __typename?: 'Query' }
  & { homepage?: Maybe<Array<Maybe<(
    { __typename?: 'homepage' }
    & Pick<Homepage, 'displayText' | 'contentType' | 'contentItemId'>
    & { homeBanner?: Maybe<(
      { __typename?: 'BagPart' }
      & { slides?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | (
        { __typename?: 'Homepagebanner' }
        & Pick<Homepagebanner, 'title'>
      ) | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, homeFeatureIntro?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | (
        { __typename?: 'contentIntro' }
        & ContentIntroFragmentFragment
      ) | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, homeImgGroup?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | (
        { __typename?: 'imgGroup' }
        & ImgGroupFragmentFragment
      ) | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, colourCardRow?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, homeImgContentCard?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | (
        { __typename?: 'imgArticleCard' }
        & ImgArticleCardFragmentFragment
      ) | (
        { __typename?: 'imgCampaignCard' }
        & ImgCampaignCardFragmentFragment
      ) | { __typename?: 'imgContentBlock' } | (
        { __typename?: 'imgContentCard' }
        & ImgContentCardFragmentFragment
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & ImgFactSheetCardFragmentFragment
      ) | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, instagramCarousel?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | (
        { __typename?: 'instagramContentCarousel' }
        & Pick<InstagramContentCarousel, 'account' | 'title'>
      ) | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type HomeMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type HomeMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'homepage' }
    & Pick<Homepage, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type KnowTheFactsComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type KnowTheFactsComponentsQuery = (
  { __typename?: 'Query' }
  & { pageKnowTheFacts?: Maybe<Array<Maybe<(
    { __typename?: 'pageKnowTheFacts' }
    & Pick<PageKnowTheFacts, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, featureImg?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | (
        { __typename?: 'featureImg' }
        & FeatureImgFragmentFragment
      ) | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, figureBlockCarousel?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | (
        { __typename?: 'figuresBlock' }
        & FiguresBlockFragmentFragment
      ) | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, greyContentRow?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureCards?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | (
        { __typename?: 'imgArticleCard' }
        & ImgArticleCardFragmentFragment
      ) | (
        { __typename?: 'imgCampaignCard' }
        & ImgCampaignCardFragmentFragment
      ) | { __typename?: 'imgContentBlock' } | (
        { __typename?: 'imgContentCard' }
        & ImgContentCardFragmentFragment
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & ImgFactSheetCardFragmentFragment
      ) | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type KnowTheFactsMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type KnowTheFactsMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageKnowTheFacts' }
    & Pick<PageKnowTheFacts, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type NewsletterComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type NewsletterComponentsQuery = (
  { __typename?: 'Query' }
  & { pageNewsletter?: Maybe<Array<Maybe<(
    { __typename?: 'pageNewsletter' }
    & Pick<PageNewsletter, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, newsletterForm?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | (
        { __typename?: 'newsletter' }
        & Pick<Newsletter, 'description' | 'submit' | 'disclaimer'>
      ) | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )> }
  )>>> }
);

export type NewsletterMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type NewsletterMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageNewsletter' }
    & Pick<PageNewsletter, 'contentItemId' | 'path'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type OurCampaignsComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type OurCampaignsComponentsQuery = (
  { __typename?: 'Query' }
  & { pageOurCampaigns?: Maybe<Array<Maybe<(
    { __typename?: 'pageOurCampaigns' }
    & Pick<PageOurCampaigns, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, campaignCardGrid?: Maybe<(
      { __typename?: 'GridSettings' }
      & Pick<GridSettings, 'loadMore'>
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type OurCampaignsMetaDatasQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type OurCampaignsMetaDatasQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageOurCampaigns' }
    & Pick<PageOurCampaigns, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type OurWorkComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type OurWorkComponentsQuery = (
  { __typename?: 'Query' }
  & { pageOurWork?: Maybe<Array<Maybe<(
    { __typename?: 'pageOurWork' }
    & Pick<PageOurWork, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, featureImg?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | (
        { __typename?: 'featureImg' }
        & FeatureImgFragmentFragment
      ) | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, map?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | (
        { __typename?: 'unfeMap' }
        & MapFragmentFragment
      ) | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, featureContentCard?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | (
        { __typename?: 'imgArticleCard' }
        & ImgArticleCardFragmentFragment
      ) | (
        { __typename?: 'imgCampaignCard' }
        & ImgCampaignCardFragmentFragment
      ) | { __typename?: 'imgContentBlock' } | (
        { __typename?: 'imgContentCard' }
        & ImgContentCardFragmentFragment
      ) | (
        { __typename?: 'imgFactSheetCard' }
        & ImgFactSheetCardFragmentFragment
      ) | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )> }
  )>>> }
);

export type OurWorkComponents1QueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type OurWorkComponents1Query = (
  { __typename?: 'Query' }
  & { pageOurWork?: Maybe<Array<Maybe<(
    { __typename?: 'pageOurWork' }
    & Pick<PageOurWork, 'displayText' | 'contentType' | 'contentItemId'>
    & { downloadGrid?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | (
        { __typename?: 'downloadGrid' }
        & DownloadGridFragmentFragment
      ) | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type OurWorkMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type OurWorkMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageOurWork' }
    & Pick<PageOurWork, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type ResourcesComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ResourcesComponentsQuery = (
  { __typename?: 'Query' }
  & { pageResources?: Maybe<Array<Maybe<(
    { __typename?: 'pageResources' }
    & Pick<PageResources, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, contentBlocks?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | (
        { __typename?: 'externalLinkCardGroup' }
        & ExternalLinkCardGroupFragmentFragment
      ) | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type ResourcesMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type ResourcesMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageResources' }
    & Pick<PageResources, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type RightToLoveComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type RightToLoveComponentsQuery = (
  { __typename?: 'Query' }
  & { pageRightToLove?: Maybe<Array<Maybe<(
    { __typename?: 'pageRightToLove' }
    & Pick<PageRightToLove, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, featureImg?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | (
        { __typename?: 'featureImg' }
        & FeatureImgFragmentFragment
      ) | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, iframe?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | (
        { __typename?: 'iframe' }
        & IframeFragmentFragment
      ) | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type RightToLoveMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type RightToLoveMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageRightToLove' }
    & Pick<PageRightToLove, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type UpdatesComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type UpdatesComponentsQuery = (
  { __typename?: 'Query' }
  & { pageUpdates?: Maybe<Array<Maybe<(
    { __typename?: 'pageUpdates' }
    & Pick<PageUpdates, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, featureArticle?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | (
        { __typename?: 'imgArticleCard' }
        & ImgArticleCardFragmentFragment
      ) | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, updateCardGrid?: Maybe<(
      { __typename?: 'GridSettings' }
      & Pick<GridSettings, 'loadMore'>
    )>, discoverMore?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type UpdatesMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type UpdatesMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageUpdates' }
    & Pick<PageUpdates, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type WhatWeDoComponentsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type WhatWeDoComponentsQuery = (
  { __typename?: 'Query' }
  & { pageWhatWeDo?: Maybe<Array<Maybe<(
    { __typename?: 'pageWhatWeDo' }
    & Pick<PageWhatWeDo, 'displayText' | 'contentType' | 'contentItemId'>
    & { contentBanner?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'label'>
      & { subTitle: PageMetaData['description'] }
    )>, campaignCarousel?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | (
        { __typename?: 'imageContentCardGrid' }
        & ImageContentCardGridFragmentFragment
      ) | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, whatWeDoFeatureCards?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | (
        { __typename?: 'imgContentCard' }
        & ImgContentCardFragmentFragment
      ) | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, downloadGrid?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | (
        { __typename?: 'downloadGrid' }
        & DownloadGridFragmentFragment
      ) | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, imgTitleContentCardGroup?: Maybe<(
      { __typename?: 'BagPart' }
      & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | (
        { __typename?: 'ImgTitleContentCardGroup' }
        & ImgTitleContentGroupFragmentFragment
      ) | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
    )>, subscriptionBlock?: Maybe<(
      { __typename?: 'subscriptionBlock' }
      & Pick<SubscriptionBlock, 'displaySubscription'>
    )> }
  )>>> }
);

export type WhatWeDoMetaDataQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Status>;
}>;


export type WhatWeDoMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<Array<Maybe<(
    { __typename?: 'pageWhatWeDo' }
    & Pick<PageWhatWeDo, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'label' | 'keywords'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  )>>> }
);

export type RelatedArticlesFragmentFragment = (
  { __typename?: 'relatedArticles' }
  & Pick<RelatedArticles, 'removeBottomSpacing' | 'removeTopSpacing' | 'contentType' | 'contentItemId'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )> }
);

export type RelatedCampaignsFragmentFragment = (
  { __typename?: 'relatedCampaigns' }
  & Pick<RelatedCampaigns, 'mods' | 'removeBottomSpacing' | 'removeTopSpacing' | 'contentType' | 'contentItemId'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )> }
);

export type RelatedFactSheetsFragmentFragment = (
  { __typename?: 'relatedFactSheets' }
  & Pick<RelatedFactSheets, 'removeBottomSpacing' | 'removeTopSpacing' | 'contentType' | 'contentItemId'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )> }
);

export type SimpleContentBlockFragmentFragment = (
  { __typename?: 'simpleContentBlock' }
  & Pick<SimpleContentBlock, 'mods' | 'removeBottomSpacing' | 'removeTopSpacing'>
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'title' | 'content'>
  )> }
);

export type SimpleContentGridFragmentFragment = (
  { __typename?: 'simpleContentGrid' }
  & { sectionIntro?: Maybe<(
    { __typename?: 'SectionIntro' }
    & Pick<SectionIntro, 'content' | 'title'>
  )>, toolbar?: Maybe<(
    { __typename?: 'toolbar' }
    & Pick<Toolbar, 'share'>
    & { file?: Maybe<(
      { __typename?: 'MediaField' }
      & Pick<MediaField, 'urls'>
    )> }
  )>, items?: Maybe<(
    { __typename?: 'BagPart' }
    & { contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | (
      { __typename?: 'simpleContentCard' }
      & Pick<SimpleContentCard, 'content' | 'title'>
    ) | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )> }
);

export type SimplePageCarouselFragmentFragment = (
  { __typename?: 'simplePageCardCarousel' }
  & Pick<SimplePageCardCarousel, 'content' | 'title' | 'label'>
  & { items?: Maybe<(
    { __typename?: 'ContentPickerField' }
    & { contentItems?: Maybe<Array<Maybe<(
      { __typename?: 'GenericTag' }
      & Pick<GenericTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Homepagebanner' }
      & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'IconBlockRow' }
      & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'ImgTitleContentCardGroup' }
      & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'LocationTag' }
      & Pick<LocationTag, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'Taxonomy' }
      & Pick<Taxonomy, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordion' }
      & Pick<Accordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'accordionGroup' }
      & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'article' }
      & Pick<Article, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'articleCard' }
      & Pick<ArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'banner' }
      & Pick<Banner, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaign' }
      & Pick<Campaign, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'campaignCard' }
      & Pick<CampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'content' }
      & Pick<Content, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentExternalLinkCard' }
      & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentIntro' }
      & Pick<ContentIntro, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCards' }
      & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'contentPageCardsGroup' }
      & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'country' }
      & Pick<Country, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'definitionItem' }
      & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadCard' }
      & Pick<DownloadCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadGrid' }
      & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'downloadMediaCard' }
      & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalFeatureCta' }
      & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'externalLinkCardGroup' }
      & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheet' }
      & Pick<FactSheet, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetCard' }
      & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'factSheetGrid' }
      & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureImg' }
      & Pick<FeatureImg, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'featureLogoRow' }
      & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figureBlock' }
      & Pick<FigureBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'figuresBlock' }
      & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'footer' }
      & Pick<Footer, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'heroImage' }
      & Pick<HeroImage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'homepage' }
      & Pick<Homepage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iconBlock' }
      & Pick<IconBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'iframe' }
      & Pick<Iframe, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContent' }
      & Pick<ImageContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageContentCardGrid' }
      & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageGalleryCarousel' }
      & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imageItem' }
      & Pick<ImageItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgArticleCard' }
      & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgCampaignCard' }
      & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentBlock' }
      & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgContentCard' }
      & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgFactSheetCard' }
      & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'imgGroup' }
      & Pick<ImgGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagram' }
      & Pick<Instagram, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramContentCarousel' }
      & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'instagramFeed' }
      & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'internalFeatureCta' }
      & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'locationRegion' }
      & Pick<LocationRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapCountry' }
      & Pick<MapCountry, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mapRegion' }
      & Pick<MapRegion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'mediaDownloadCarousel' }
      & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'newsletter' }
      & Pick<Newsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageAboutUs' }
      & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageActNow' }
      & Pick<PageActNow, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageCard' }
      & Pick<PageCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageChallenges' }
      & Pick<PageChallenges, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageContactUs' }
      & Pick<PageContactUs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDefinitions' }
      & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageDonate' }
      & Pick<PageDonate, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageEqualRights' }
      & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageFaqs' }
      & Pick<PageFaqs, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageGeneralContent' }
      & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageKnowTheFacts' }
      & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageNewsletter' }
      & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurCampaigns' }
      & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageOurWork' }
      & Pick<PageOurWork, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageResources' }
      & Pick<PageResources, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageRightToLove' }
      & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageUpdates' }
      & Pick<PageUpdates, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'pageWhatWeDo' }
      & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedArticles' }
      & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedCampaigns' }
      & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'relatedFactSheets' }
      & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordion' }
      & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleAccordionGroup' }
      & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentBlock' }
      & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentCard' }
      & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simpleContentGrid' }
      & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'simplePageCardCarousel' }
      & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialContentCard' }
      & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'socialPlatform' }
      & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subheader' }
      & Pick<Subheader, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'subscription' }
      & Pick<Subscription, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeContentItem' }
      & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeHomePage' }
      & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeMap' }
      & Pick<UnfeMap, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'unfeNavigation' }
      & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
    ) | (
      { __typename?: 'youtubeVideo' }
      & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
    )>>> }
  )> }
);

export type SiteMapQueryVariables = Exact<{
  status?: Maybe<Status>;
}>;


export type SiteMapQuery = (
  { __typename?: 'Query' }
  & { navPages?: Maybe<Array<Maybe<(
    { __typename?: 'unfeNavigation' }
    & { localization?: Maybe<(
      { __typename?: 'LocalizationPart' }
      & Pick<LocalizationPart, 'culture'>
    )>, contentItems?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | (
      { __typename?: 'unfeContentItem' }
      & Pick<UnfeContentItem, 'displayText' | 'contentType'>
      & { content?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & Pick<ContentPickerField, 'contentItemIds'>
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | (
      { __typename?: 'unfeHomePage' }
      & Pick<UnfeHomePage, 'displayText' | 'contentType'>
      & { content?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & Pick<ContentPickerField, 'contentItemIds'>
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )> }
    ) | { __typename?: 'unfeMap' } | (
      { __typename?: 'unfeNavItem' }
      & Pick<UnfeNavItem, 'contentType' | 'displayText'>
      & { content?: Maybe<(
        { __typename?: 'ContentPickerField' }
        & Pick<ContentPickerField, 'contentItemIds'>
        & { contentItems?: Maybe<Array<Maybe<(
          { __typename?: 'GenericTag' }
          & Pick<GenericTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Homepagebanner' }
          & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'IconBlockRow' }
          & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'ImgTitleContentCardGroup' }
          & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'LocationTag' }
          & Pick<LocationTag, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'Taxonomy' }
          & Pick<Taxonomy, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordion' }
          & Pick<Accordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'accordionGroup' }
          & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'article' }
          & Pick<Article, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'articleCard' }
          & Pick<ArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'banner' }
          & Pick<Banner, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaign' }
          & Pick<Campaign, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'campaignCard' }
          & Pick<CampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'content' }
          & Pick<Content, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentExternalLinkCard' }
          & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentIntro' }
          & Pick<ContentIntro, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCards' }
          & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'contentPageCardsGroup' }
          & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'country' }
          & Pick<Country, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'definitionItem' }
          & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadCard' }
          & Pick<DownloadCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadGrid' }
          & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'downloadMediaCard' }
          & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalFeatureCta' }
          & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'externalLinkCardGroup' }
          & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheet' }
          & Pick<FactSheet, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetCard' }
          & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'factSheetGrid' }
          & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureImg' }
          & Pick<FeatureImg, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'featureLogoRow' }
          & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figureBlock' }
          & Pick<FigureBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'figuresBlock' }
          & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'footer' }
          & Pick<Footer, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'heroImage' }
          & Pick<HeroImage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'homepage' }
          & Pick<Homepage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iconBlock' }
          & Pick<IconBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'iframe' }
          & Pick<Iframe, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContent' }
          & Pick<ImageContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageContentCardGrid' }
          & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageGalleryCarousel' }
          & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imageItem' }
          & Pick<ImageItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgArticleCard' }
          & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgCampaignCard' }
          & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentBlock' }
          & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgContentCard' }
          & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgFactSheetCard' }
          & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'imgGroup' }
          & Pick<ImgGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagram' }
          & Pick<Instagram, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramContentCarousel' }
          & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'instagramFeed' }
          & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'internalFeatureCta' }
          & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'locationRegion' }
          & Pick<LocationRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapCountry' }
          & Pick<MapCountry, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mapRegion' }
          & Pick<MapRegion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'mediaDownloadCarousel' }
          & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'newsletter' }
          & Pick<Newsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageAboutUs' }
          & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageActNow' }
          & Pick<PageActNow, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageCard' }
          & Pick<PageCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageChallenges' }
          & Pick<PageChallenges, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageContactUs' }
          & Pick<PageContactUs, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDefinitions' }
          & Pick<PageDefinitions, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageDonate' }
          & Pick<PageDonate, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageEqualRights' }
          & Pick<PageEqualRights, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageFaqs' }
          & Pick<PageFaqs, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageGeneralContent' }
          & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageKnowTheFacts' }
          & Pick<PageKnowTheFacts, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageNewsletter' }
          & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurCampaigns' }
          & Pick<PageOurCampaigns, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageOurWork' }
          & Pick<PageOurWork, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageResources' }
          & Pick<PageResources, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageRightToLove' }
          & Pick<PageRightToLove, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageUpdates' }
          & Pick<PageUpdates, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'pageWhatWeDo' }
          & Pick<PageWhatWeDo, 'path' | 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedArticles' }
          & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedCampaigns' }
          & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'relatedFactSheets' }
          & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordion' }
          & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleAccordionGroup' }
          & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentBlock' }
          & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentCard' }
          & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simpleContentGrid' }
          & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'simplePageCardCarousel' }
          & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialContentCard' }
          & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'socialPlatform' }
          & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subheader' }
          & Pick<Subheader, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'subscription' }
          & Pick<Subscription, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeContentItem' }
          & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeHomePage' }
          & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeMap' }
          & Pick<UnfeMap, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'unfeNavigation' }
          & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
        ) | (
          { __typename?: 'youtubeVideo' }
          & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
        )>>> }
      )>, subNav?: Maybe<(
        { __typename?: 'BagPart' }
        & { nav?: Maybe<Array<Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | { __typename?: 'pageAboutUs' } | { __typename?: 'pageActNow' } | { __typename?: 'pageCard' } | { __typename?: 'pageChallenges' } | { __typename?: 'pageContactUs' } | { __typename?: 'pageDefinitions' } | { __typename?: 'pageDonate' } | { __typename?: 'pageEqualRights' } | { __typename?: 'pageFaqs' } | { __typename?: 'pageGeneralContent' } | { __typename?: 'pageKnowTheFacts' } | { __typename?: 'pageNewsletter' } | { __typename?: 'pageOurCampaigns' } | { __typename?: 'pageOurWork' } | { __typename?: 'pageResources' } | { __typename?: 'pageRightToLove' } | { __typename?: 'pageUpdates' } | { __typename?: 'pageWhatWeDo' } | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | (
          { __typename?: 'unfeNavItem' }
          & Pick<UnfeNavItem, 'contentType' | 'displayText'>
          & { content?: Maybe<(
            { __typename?: 'ContentPickerField' }
            & Pick<ContentPickerField, 'contentItemIds'>
            & { contentItems?: Maybe<Array<Maybe<(
              { __typename?: 'GenericTag' }
              & Pick<GenericTag, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'Homepagebanner' }
              & Pick<Homepagebanner, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'IconBlockRow' }
              & Pick<IconBlockRow, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'ImgTitleContentCardGroup' }
              & Pick<ImgTitleContentCardGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'LocationTag' }
              & Pick<LocationTag, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'Taxonomy' }
              & Pick<Taxonomy, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'accordion' }
              & Pick<Accordion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'accordionGroup' }
              & Pick<AccordionGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'article' }
              & Pick<Article, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'articleCard' }
              & Pick<ArticleCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'banner' }
              & Pick<Banner, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'campaign' }
              & Pick<Campaign, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'campaignCard' }
              & Pick<CampaignCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'content' }
              & Pick<Content, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentExternalLinkCard' }
              & Pick<ContentExternalLinkCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentIntro' }
              & Pick<ContentIntro, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentPageCards' }
              & Pick<ContentPageCards, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'contentPageCardsGroup' }
              & Pick<ContentPageCardsGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'country' }
              & Pick<Country, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'definitionItem' }
              & Pick<DefinitionItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadCard' }
              & Pick<DownloadCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadGrid' }
              & Pick<DownloadGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'downloadMediaCard' }
              & Pick<DownloadMediaCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'externalFeatureCta' }
              & Pick<ExternalFeatureCta, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'externalLinkCardGroup' }
              & Pick<ExternalLinkCardGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheet' }
              & Pick<FactSheet, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheetCard' }
              & Pick<FactSheetCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'factSheetGrid' }
              & Pick<FactSheetGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'featureImg' }
              & Pick<FeatureImg, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'featureLogoRow' }
              & Pick<FeatureLogoRow, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'figureBlock' }
              & Pick<FigureBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'figuresBlock' }
              & Pick<FiguresBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'footer' }
              & Pick<Footer, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'heroImage' }
              & Pick<HeroImage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'homepage' }
              & Pick<Homepage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'iconBlock' }
              & Pick<IconBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'iframe' }
              & Pick<Iframe, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageContent' }
              & Pick<ImageContent, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageContentCardGrid' }
              & Pick<ImageContentCardGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageGalleryCarousel' }
              & Pick<ImageGalleryCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imageItem' }
              & Pick<ImageItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgArticleCard' }
              & Pick<ImgArticleCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgCampaignCard' }
              & Pick<ImgCampaignCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgContentBlock' }
              & Pick<ImgContentBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgContentCard' }
              & Pick<ImgContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgFactSheetCard' }
              & Pick<ImgFactSheetCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'imgGroup' }
              & Pick<ImgGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagram' }
              & Pick<Instagram, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagramContentCarousel' }
              & Pick<InstagramContentCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'instagramFeed' }
              & Pick<InstagramFeed, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'internalFeatureCta' }
              & Pick<InternalFeatureCta, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'locationRegion' }
              & Pick<LocationRegion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mapCountry' }
              & Pick<MapCountry, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mapRegion' }
              & Pick<MapRegion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'mediaDownloadCarousel' }
              & Pick<MediaDownloadCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'newsletter' }
              & Pick<Newsletter, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageAboutUs' }
              & Pick<PageAboutUs, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageActNow' }
              & Pick<PageActNow, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageCard' }
              & Pick<PageCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageChallenges' }
              & Pick<PageChallenges, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageContactUs' }
              & Pick<PageContactUs, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageDefinitions' }
              & Pick<PageDefinitions, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageDonate' }
              & Pick<PageDonate, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageEqualRights' }
              & Pick<PageEqualRights, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageFaqs' }
              & Pick<PageFaqs, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageGeneralContent' }
              & Pick<PageGeneralContent, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageKnowTheFacts' }
              & Pick<PageKnowTheFacts, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageNewsletter' }
              & Pick<PageNewsletter, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageOurCampaigns' }
              & Pick<PageOurCampaigns, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageOurWork' }
              & Pick<PageOurWork, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageResources' }
              & Pick<PageResources, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageRightToLove' }
              & Pick<PageRightToLove, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageUpdates' }
              & Pick<PageUpdates, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'pageWhatWeDo' }
              & Pick<PageWhatWeDo, 'path' | 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedArticles' }
              & Pick<RelatedArticles, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedCampaigns' }
              & Pick<RelatedCampaigns, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'relatedFactSheets' }
              & Pick<RelatedFactSheets, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleAccordion' }
              & Pick<SimpleAccordion, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleAccordionGroup' }
              & Pick<SimpleAccordionGroup, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentBlock' }
              & Pick<SimpleContentBlock, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentCard' }
              & Pick<SimpleContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simpleContentGrid' }
              & Pick<SimpleContentGrid, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'simplePageCardCarousel' }
              & Pick<SimplePageCardCarousel, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'socialContentCard' }
              & Pick<SocialContentCard, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'socialPlatform' }
              & Pick<SocialPlatform, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'subheader' }
              & Pick<Subheader, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'subscription' }
              & Pick<Subscription, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeContentItem' }
              & Pick<UnfeContentItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeHomePage' }
              & Pick<UnfeHomePage, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeMap' }
              & Pick<UnfeMap, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeNavItem' }
              & Pick<UnfeNavItem, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'unfeNavigation' }
              & Pick<UnfeNavigation, 'contentItemId' | 'contentType'>
            ) | (
              { __typename?: 'youtubeVideo' }
              & Pick<YoutubeVideo, 'contentItemId' | 'contentType'>
            )>>> }
          )> }
        ) | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
      )> }
    ) | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }>>> }
  )>>> }
);

export type SocialPlatformsQueryVariables = Exact<{
  status?: Maybe<Status>;
}>;


export type SocialPlatformsQuery = (
  { __typename?: 'Query' }
  & { socialPlatform?: Maybe<Array<Maybe<(
    { __typename?: 'socialPlatform' }
    & Pick<SocialPlatform, 'url'>
    & { name: SocialPlatform['type'] }
  )>>> }
);

export type GetSubscriptionQueryVariables = Exact<{
  status?: Maybe<Status>;
}>;


export type GetSubscriptionQuery = (
  { __typename?: 'Query' }
  & { subscription?: Maybe<Array<Maybe<(
    { __typename?: 'subscription' }
    & Pick<Subscription, 'title' | 'blank'>
    & { externalLink?: Maybe<(
      { __typename?: 'LinkField' }
      & Pick<LinkField, 'url' | 'text'>
    )>, localization?: Maybe<(
      { __typename?: 'LocalizationPart' }
      & Pick<LocalizationPart, 'culture'>
    )> }
  )>>> }
);

export type GetPageMetaDataQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPageMetaDataQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<{ __typename?: 'GenericTag' } | { __typename?: 'Homepagebanner' } | { __typename?: 'IconBlockRow' } | { __typename?: 'ImgTitleContentCardGroup' } | { __typename?: 'LocationTag' } | { __typename?: 'Taxonomy' } | { __typename?: 'accordion' } | { __typename?: 'accordionGroup' } | { __typename?: 'article' } | { __typename?: 'articleCard' } | { __typename?: 'banner' } | { __typename?: 'campaign' } | { __typename?: 'campaignCard' } | { __typename?: 'content' } | { __typename?: 'contentExternalLinkCard' } | { __typename?: 'contentIntro' } | { __typename?: 'contentPageCards' } | { __typename?: 'contentPageCardsGroup' } | { __typename?: 'country' } | { __typename?: 'definitionItem' } | { __typename?: 'downloadCard' } | { __typename?: 'downloadGrid' } | { __typename?: 'downloadMediaCard' } | { __typename?: 'externalFeatureCta' } | { __typename?: 'externalLinkCardGroup' } | { __typename?: 'factSheet' } | { __typename?: 'factSheetCard' } | { __typename?: 'factSheetGrid' } | { __typename?: 'featureImg' } | { __typename?: 'featureLogoRow' } | { __typename?: 'figureBlock' } | { __typename?: 'figuresBlock' } | { __typename?: 'footer' } | { __typename?: 'heroImage' } | { __typename?: 'homepage' } | { __typename?: 'iconBlock' } | { __typename?: 'iframe' } | { __typename?: 'imageContent' } | { __typename?: 'imageContentCardGrid' } | { __typename?: 'imageGalleryCarousel' } | { __typename?: 'imageItem' } | { __typename?: 'imgArticleCard' } | { __typename?: 'imgCampaignCard' } | { __typename?: 'imgContentBlock' } | { __typename?: 'imgContentCard' } | { __typename?: 'imgFactSheetCard' } | { __typename?: 'imgGroup' } | { __typename?: 'instagram' } | { __typename?: 'instagramContentCarousel' } | { __typename?: 'instagramFeed' } | { __typename?: 'internalFeatureCta' } | { __typename?: 'locationRegion' } | { __typename?: 'mapCountry' } | { __typename?: 'mapRegion' } | { __typename?: 'mediaDownloadCarousel' } | { __typename?: 'newsletter' } | (
    { __typename?: 'pageAboutUs' }
    & Pick<PageAboutUs, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
    )> }
  ) | (
    { __typename?: 'pageActNow' }
    & Pick<PageActNow, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | { __typename?: 'pageCard' } | (
    { __typename?: 'pageChallenges' }
    & Pick<PageChallenges, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageContactUs' }
    & Pick<PageContactUs, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageDefinitions' }
    & Pick<PageDefinitions, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageDonate' }
    & Pick<PageDonate, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageEqualRights' }
    & Pick<PageEqualRights, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageFaqs' }
    & Pick<PageFaqs, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageGeneralContent' }
    & Pick<PageGeneralContent, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageKnowTheFacts' }
    & Pick<PageKnowTheFacts, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageNewsletter' }
    & Pick<PageNewsletter, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageOurCampaigns' }
    & Pick<PageOurCampaigns, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageOurWork' }
    & Pick<PageOurWork, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageResources' }
    & Pick<PageResources, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageRightToLove' }
    & Pick<PageRightToLove, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageUpdates' }
    & Pick<PageUpdates, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | (
    { __typename?: 'pageWhatWeDo' }
    & Pick<PageWhatWeDo, 'contentItemId'>
    & { pageMetaData?: Maybe<(
      { __typename?: 'PageMetaData' }
      & Pick<PageMetaData, 'title' | 'description' | 'keywords' | 'label'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaField' }
        & Pick<MediaField, 'urls'>
      )> }
    )> }
  ) | { __typename?: 'relatedArticles' } | { __typename?: 'relatedCampaigns' } | { __typename?: 'relatedFactSheets' } | { __typename?: 'simpleAccordion' } | { __typename?: 'simpleAccordionGroup' } | { __typename?: 'simpleContentBlock' } | { __typename?: 'simpleContentCard' } | { __typename?: 'simpleContentGrid' } | { __typename?: 'simplePageCardCarousel' } | { __typename?: 'socialContentCard' } | { __typename?: 'socialPlatform' } | { __typename?: 'subheader' } | { __typename?: 'subscription' } | { __typename?: 'unfeContentItem' } | { __typename?: 'unfeHomePage' } | { __typename?: 'unfeMap' } | { __typename?: 'unfeNavItem' } | { __typename?: 'unfeNavigation' } | { __typename?: 'youtubeVideo' }> }
);

export const AccordionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"accordionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"campaignCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"articleCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"factSheetCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"factSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccordionFragmentFragment, unknown>;
export const AccordionGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"accordionGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordionGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accordionFragment"}}]}}]}}]}},...AccordionFragmentFragmentDoc.definitions]} as unknown as DocumentNode<AccordionGroupFragmentFragment, unknown>;
export const SimpleAccordionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"simpleAccordionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"simpleAccordion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]} as unknown as DocumentNode<SimpleAccordionFragmentFragment, unknown>;
export const SimpleAccordionGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"simpleAccordionGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"simpleAccordionGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"simpleAccordionFragment"}}]}}]}}]}},...SimpleAccordionFragmentFragmentDoc.definitions]} as unknown as DocumentNode<SimpleAccordionGroupFragmentFragment, unknown>;
export const ContentIntroFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentIntroFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contentIntro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isLanding"}}]}}]} as unknown as DocumentNode<ContentIntroFragmentFragment, unknown>;
export const ContentPageCardsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"contentPageCardsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contentPageCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"campaignCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"articleCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"factSheetCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"factSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContentPageCardsFragmentFragment, unknown>;
export const DownloadGridFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"downloadGridFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"downloadGrid"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"downloadCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DownloadGridFragmentFragment, unknown>;
export const ExternalFeatureCtaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"externalFeatureCtaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"externalFeatureCta"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}}]} as unknown as DocumentNode<ExternalFeatureCtaFragmentFragment, unknown>;
export const ExternalLinkCardGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"externalLinkCardGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"externalLinkCardGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"htmlBody"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"contentExternalLinkCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExternalLinkCardGroupFragmentFragment, unknown>;
export const FeatureImgFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"featureImgFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"featureImg"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]} as unknown as DocumentNode<FeatureImgFragmentFragment, unknown>;
export const FeatureLogoRowFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"featureLogoRowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"featureLogoRow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<FeatureLogoRowFragmentFragment, unknown>;
export const FiguresBlockFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"figuresBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"figuresBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"figureBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<FiguresBlockFragmentFragment, unknown>;
export const GalleryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"galleryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imageItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}}]}}]} as unknown as DocumentNode<GalleryFragmentFragment, unknown>;
export const GalleryCarouselFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"galleryCarouselFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imageGalleryCarousel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"galleryFragment"}}]}}]}}]}},...GalleryFragmentFragmentDoc.definitions]} as unknown as DocumentNode<GalleryCarouselFragmentFragment, unknown>;
export const IconBlockRowFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"iconBlockRowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IconBlockRow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"iconBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"bgImg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IconBlockRowFragmentFragment, unknown>;
export const IframeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"iframeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"iframe"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"embedCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<IframeFragmentFragment, unknown>;
export const ImageContentCardGridFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imageContentCardGridFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imageContentCardGrid"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imageContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<ImageContentCardGridFragmentFragment, unknown>;
export const ImgContentCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imgContentCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imgContentCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imgAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"displayShadow"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<ImgContentCardFragmentFragment, unknown>;
export const ImgArticleCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imgArticleCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imgArticleCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imgAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"displayShadow"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<ImgArticleCardFragmentFragment, unknown>;
export const ImgCampaignCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imgCampaignCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imgCampaignCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imgAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"displayShadow"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<ImgCampaignCardFragmentFragment, unknown>;
export const ImgFactSheetCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imgFactSheetCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imgFactSheetCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imgAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"displayShadow"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<ImgFactSheetCardFragmentFragment, unknown>;
export const ImgContentBlockFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imgContentBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imgContentBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newTab"}}]}}]} as unknown as DocumentNode<ImgContentBlockFragmentFragment, unknown>;
export const ImgGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imgGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"imgGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]} as unknown as DocumentNode<ImgGroupFragmentFragment, unknown>;
export const ImgTitleContentGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"imgTitleContentGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImgTitleContentCardGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"campaignCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"articleCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"factSheetCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"factSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ImgTitleContentGroupFragmentFragment, unknown>;
export const InternalFeatureCtaFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"internalFeatureCtaFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"internalFeatureCta"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}}]}}]}}]} as unknown as DocumentNode<InternalFeatureCtaFragmentFragment, unknown>;
export const MapCountryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"mapCountryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mapCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTitle"}},{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"country"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termContentItemIds"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MapCountryFragmentFragment, unknown>;
export const MapRegionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"mapRegionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mapRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locationRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"mapCountryFragment"}}]}}]}}]}},...MapCountryFragmentFragmentDoc.definitions]} as unknown as DocumentNode<MapRegionFragmentFragment, unknown>;
export const MapFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"mapFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeMap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"popupIconStyle"}},{"kind":"Field","name":{"kind":"Name","value":"displayRelatedItems"}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"mapRegionFragment"}}]}}]}}]}},...MapRegionFragmentFragmentDoc.definitions]} as unknown as DocumentNode<MapFragmentFragment, unknown>;
export const MediaDownloadCarouselFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"mediaDownloadCarouselFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"mediaDownloadCarousel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"downloadMediaCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bgImg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MediaDownloadCarouselFragmentFragment, unknown>;
export const RelatedArticlesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"relatedArticlesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relatedArticles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}}]}}]} as unknown as DocumentNode<RelatedArticlesFragmentFragment, unknown>;
export const RelatedCampaignsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"relatedCampaignsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relatedCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}}]}}]} as unknown as DocumentNode<RelatedCampaignsFragmentFragment, unknown>;
export const RelatedFactSheetsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"relatedFactSheetsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"relatedFactSheets"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}}]}}]} as unknown as DocumentNode<RelatedFactSheetsFragmentFragment, unknown>;
export const SimpleContentBlockFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"simpleContentBlockFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"simpleContentBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}}]}}]} as unknown as DocumentNode<SimpleContentBlockFragmentFragment, unknown>;
export const SimpleContentGridFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"simpleContentGridFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"simpleContentGrid"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toolbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"simpleContentCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SimpleContentGridFragmentFragment, unknown>;
export const SimplePageCarouselFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"simplePageCarouselFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"simplePageCardCarousel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<SimplePageCarouselFragmentFragment, unknown>;
export const ArticleListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parameters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"articleList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parameters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"isFeature"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<ArticleListQuery, ArticleListQueryVariables>;
export const ArticleMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]} as unknown as DocumentNode<ArticleMetaDataQuery, ArticleMetaDataQueryVariables>;
export const ArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Article"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termContentItemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termContentItemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"youtubeVideo"},"name":{"kind":"Name","value":"articleVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"youtubeVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wysiwyg"},"name":{"kind":"Name","value":"htmlBody"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}}]}},{"kind":"Field","name":{"kind":"Name","value":"galleryCarousel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"galleryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"relatedArticlesFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...GalleryFragmentFragmentDoc.definitions,...RelatedArticlesFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ArticleQuery, ArticleQueryVariables>;
export const CampaignListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CampaignList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parameters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"campaignList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parameters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isFeature"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","alias":{"kind":"Name","value":"external"},"name":{"kind":"Name","value":"externalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"externalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isExternal"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignListQuery, CampaignListQueryVariables>;
export const CampaignMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CampaignMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","alias":{"kind":"Name","value":"external"},"name":{"kind":"Name","value":"externalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"externalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isExternal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignMetaDataQuery, CampaignMetaDataQueryVariables>;
export const CampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Campaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"isFeature"}},{"kind":"Field","alias":{"kind":"Name","value":"external"},"name":{"kind":"Name","value":"externalContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"externalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isExternal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termContentItemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termContentItemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"components"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"youtubeVideo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}},{"kind":"Field","name":{"kind":"Name","value":"mods"}},{"kind":"Field","name":{"kind":"Name","value":"removeBottomSpacing"}},{"kind":"Field","name":{"kind":"Name","value":"removeTopSpacing"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"heroImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"img"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"figuresBlockFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"simpleAccordionGroupFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"mediaDownloadCarouselFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"relatedCampaignsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"galleryCarouselFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...FiguresBlockFragmentFragmentDoc.definitions,...SimpleAccordionGroupFragmentFragmentDoc.definitions,...MediaDownloadCarouselFragmentFragmentDoc.definitions,...RelatedCampaignsFragmentFragmentDoc.definitions,...GalleryCarouselFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CampaignQuery, CampaignQueryVariables>;
export const LocationRelatedContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationRelatedContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parameter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"articles"},"name":{"kind":"Name","value":"articleByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parameter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"campaigns"},"name":{"kind":"Name","value":"campaignByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parameter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"factSheets"},"name":{"kind":"Name","value":"factSheetsByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parameter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"content"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]} as unknown as DocumentNode<LocationRelatedContentQuery, LocationRelatedContentQueryVariables>;
export const FactSheetListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FactSheetList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parameters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"factSheetList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parameters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]} as unknown as DocumentNode<FactSheetListQuery, FactSheetListQueryVariables>;
export const FactSheetMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FactSheetMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"factSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]} as unknown as DocumentNode<FactSheetMetaDataQuery, FactSheetMetaDataQueryVariables>;
export const FactSheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FactSheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termContentItemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termContentItemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"toolbar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"share"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"figuresBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"figuresBlockFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondHmlcontent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"simpleContentBlockFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"featureImgFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"simpleAccordionGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"relatedFactSheetsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...FiguresBlockFragmentFragmentDoc.definitions,...SimpleContentBlockFragmentFragmentDoc.definitions,...FeatureImgFragmentFragmentDoc.definitions,...SimpleAccordionGroupFragmentFragmentDoc.definitions,...RelatedFactSheetsFragmentFragmentDoc.definitions]} as unknown as DocumentNode<FactSheetQuery, FactSheetQueryVariables>;
export const GetFooterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFooter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"footer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"footer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"links"},"name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageAboutUs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageContactUs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageGeneralContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageResources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"footerText"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"culture"}}]}}]}}]}}]} as unknown as DocumentNode<GetFooterQuery, GetFooterQueryVariables>;
export const InstagramQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InstagramQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","alias":{"kind":"Name","value":"imgs"},"name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"instagramFeed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InstagramQueryQuery, InstagramQueryQueryVariables>;
export const NavigationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"navigation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unfeNavigation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeNavigation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeNavItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageKnowTheFacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageActNow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurWork"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageUpdates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageWhatWeDo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDonate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageEqualRights"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageChallenges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageFaqs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageRightToLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subNav"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeNavItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageKnowTheFacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageActNow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurWork"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageUpdates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageWhatWeDo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDonate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageEqualRights"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageChallenges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageFaqs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageRightToLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"culture"}}]}}]}}]}}]} as unknown as DocumentNode<NavigationQuery, NavigationQueryVariables>;
export const NavigationOldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"navigationOld"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localizationSet"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"4btvb6xmg551h02p77xbc9ye47","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"culture"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"en","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"defaultValue":{"kind":"EnumValue","value":"ALL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unfeNavigation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"localization"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"localizationSet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localizationSet"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"culture"},"value":{"kind":"Variable","name":{"kind":"Name","value":"culture"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeNavItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageKnowTheFacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageActNow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurWork"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageUpdates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageWhatWeDo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDonate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageEqualRights"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageChallenges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageFaqs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageRightToLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subNav"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeNavItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageKnowTheFacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageActNow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurWork"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageUpdates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageWhatWeDo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDonate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageEqualRights"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageChallenges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageFaqs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageRightToLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NavigationOldQuery, NavigationOldQueryVariables>;
export const AboutUsComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AboutUsComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageAboutUs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureLogoRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"featureLogoRowFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgContentCardGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentBlockFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...FeatureLogoRowFragmentFragmentDoc.definitions,...ImgContentBlockFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<AboutUsComponentsQuery, AboutUsComponentsQueryVariables>;
export const AboutUsMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AboutUsMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageAboutUs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AboutUsMetaDataQuery, AboutUsMetaDataQueryVariables>;
export const ActNowComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActNowComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageActNow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actContentCardCarousel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"simplePageCarouselFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialContentCol"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"socialContentCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentBlockCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentBlockFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgArticleCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgCampaignCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgFactSheetCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...SimplePageCarouselFragmentFragmentDoc.definitions,...ImgContentBlockFragmentFragmentDoc.definitions,...ImgContentCardFragmentFragmentDoc.definitions,...ImgArticleCardFragmentFragmentDoc.definitions,...ImgCampaignCardFragmentFragmentDoc.definitions,...ImgFactSheetCardFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ActNowComponentsQuery, ActNowComponentsQueryVariables>;
export const ActNowMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActNowMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageActNow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActNowMetaDataQuery, ActNowMetaDataQueryVariables>;
export const ChallengesComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChallengesComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageChallenges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureImg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"featureImgFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"factSheetsGrid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"factSheetGrid"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"greyContentRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"downloadGridFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgArticleCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgCampaignCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgFactSheetCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...FeatureImgFragmentFragmentDoc.definitions,...DownloadGridFragmentFragmentDoc.definitions,...ImgContentCardFragmentFragmentDoc.definitions,...ImgArticleCardFragmentFragmentDoc.definitions,...ImgCampaignCardFragmentFragmentDoc.definitions,...ImgFactSheetCardFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ChallengesComponentsQuery, ChallengesComponentsQueryVariables>;
export const ChallengesMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChallengesMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageChallenges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChallengesMetaDataQuery, ChallengesMetaDataQueryVariables>;
export const ContactUsComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactUsComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageContactUs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smallCardContentGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"subheader"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"displayText"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentPageCardsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalLinkContentBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"externalLinkCardGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...ContentPageCardsFragmentFragmentDoc.definitions,...ExternalLinkCardGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ContactUsComponentsQuery, ContactUsComponentsQueryVariables>;
export const ContactUsMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactUsMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageContactUs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContactUsMetaDataQuery, ContactUsMetaDataQueryVariables>;
export const DefinitionsComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DefinitionsComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"definitionItemGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accordionFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgArticleCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgCampaignCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgFactSheetCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...AccordionFragmentFragmentDoc.definitions,...ImgContentCardFragmentFragmentDoc.definitions,...ImgArticleCardFragmentFragmentDoc.definitions,...ImgCampaignCardFragmentFragmentDoc.definitions,...ImgFactSheetCardFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<DefinitionsComponentsQuery, DefinitionsComponentsQueryVariables>;
export const DefinitionsMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DefinitionsMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DefinitionsMetaDataQuery, DefinitionsMetaDataQueryVariables>;
export const DonatePageComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DonatePageComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageDonate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentBlockFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"iconBlockRow"},"name":{"kind":"Name","value":"donateIconBlockRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"iconBlockRowFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureCtaGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"internalFeatureCtaFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"externalFeatureCtaFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...ImgContentBlockFragmentFragmentDoc.definitions,...IconBlockRowFragmentFragmentDoc.definitions,...InternalFeatureCtaFragmentFragmentDoc.definitions,...ExternalFeatureCtaFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<DonatePageComponentsQuery, DonatePageComponentsQueryVariables>;
export const DonateMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DonateMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageDonate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DonateMetaDataQuery, DonateMetaDataQueryVariables>;
export const EqualRightsComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EqualRightsComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageEqualRights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"map"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"mapFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...MapFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<EqualRightsComponentsQuery, EqualRightsComponentsQueryVariables>;
export const EqualRightsMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EqualRightsMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageEqualRights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EqualRightsMetaDataQuery, EqualRightsMetaDataQueryVariables>;
export const FaqsComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FAQSComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageFaqs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termBlockRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"simpleContentGridFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"accordionGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...SimpleContentGridFragmentFragmentDoc.definitions,...AccordionGroupFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<FaqsComponentsQuery, FaqsComponentsQueryVariables>;
export const FaqsMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FAQSMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageFaqs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FaqsMetaDataQuery, FaqsMetaDataQueryVariables>;
export const GeneralContentComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeneralContentComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageGeneralContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"wysiwyg"},"name":{"kind":"Name","value":"htmlBody"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"html"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}}]} as unknown as DocumentNode<GeneralContentComponentsQuery, GeneralContentComponentsQueryVariables>;
export const GeneralContentMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeneralContentMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageGeneralContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GeneralContentMetaDataQuery, GeneralContentMetaDataQueryVariables>;
export const HomeComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homepage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"homeBanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"slides"},"name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Homepagebanner"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeFeatureIntro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"contentIntroFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeImgGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"colourCardRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeImgContentCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgArticleCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgCampaignCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgFactSheetCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"instagramCarousel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"instagramContentCarousel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...ContentIntroFragmentFragmentDoc.definitions,...ImgGroupFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions,...ImgContentCardFragmentFragmentDoc.definitions,...ImgArticleCardFragmentFragmentDoc.definitions,...ImgCampaignCardFragmentFragmentDoc.definitions,...ImgFactSheetCardFragmentFragmentDoc.definitions]} as unknown as DocumentNode<HomeComponentsQuery, HomeComponentsQueryVariables>;
export const HomeMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"homepage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HomeMetaDataQuery, HomeMetaDataQueryVariables>;
export const KnowTheFactsComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KnowTheFactsComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageKnowTheFacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureImg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"featureImgFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"figureBlockCarousel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"figuresBlockFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"greyContentRow"},"name":{"kind":"Name","value":"ktfGreyContentRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgArticleCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgCampaignCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgFactSheetCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...FeatureImgFragmentFragmentDoc.definitions,...FiguresBlockFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions,...ImgContentCardFragmentFragmentDoc.definitions,...ImgArticleCardFragmentFragmentDoc.definitions,...ImgCampaignCardFragmentFragmentDoc.definitions,...ImgFactSheetCardFragmentFragmentDoc.definitions]} as unknown as DocumentNode<KnowTheFactsComponentsQuery, KnowTheFactsComponentsQueryVariables>;
export const KnowTheFactsMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KnowTheFactsMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageKnowTheFacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<KnowTheFactsMetaDataQuery, KnowTheFactsMetaDataQueryVariables>;
export const NewsletterComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsletterComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNewsletter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsletterForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"newsletter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"submit"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimer"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsletterComponentsQuery, NewsletterComponentsQueryVariables>;
export const NewsletterMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsletterMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageNewsletter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsletterMetaDataQuery, NewsletterMetaDataQueryVariables>;
export const OurCampaignsComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OurCampaignsComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageOurCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"campaignCardGrid"},"name":{"kind":"Name","value":"gridSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loadMore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<OurCampaignsComponentsQuery, OurCampaignsComponentsQueryVariables>;
export const OurCampaignsMetaDatasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OurCampaignsMetaDatas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageOurCampaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OurCampaignsMetaDatasQuery, OurCampaignsMetaDatasQueryVariables>;
export const OurWorkComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OurWorkComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageOurWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureImg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"featureImgFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"map"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"mapFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureContentCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgArticleCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgCampaignCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgFactSheetCardFragment"}}]}}]}}]}}]}},...FeatureImgFragmentFragmentDoc.definitions,...MapFragmentFragmentDoc.definitions,...ImgContentCardFragmentFragmentDoc.definitions,...ImgArticleCardFragmentFragmentDoc.definitions,...ImgCampaignCardFragmentFragmentDoc.definitions,...ImgFactSheetCardFragmentFragmentDoc.definitions]} as unknown as DocumentNode<OurWorkComponentsQuery, OurWorkComponentsQueryVariables>;
export const OurWorkComponents1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OurWorkComponents1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageOurWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"downloadGrid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"downloadGridFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...DownloadGridFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<OurWorkComponents1Query, OurWorkComponents1QueryVariables>;
export const OurWorkMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OurWorkMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageOurWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OurWorkMetaDataQuery, OurWorkMetaDataQueryVariables>;
export const ResourcesComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourcesComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageResources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contentBlocks"},"name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"externalLinkCardGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...ExternalLinkCardGroupFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<ResourcesComponentsQuery, ResourcesComponentsQueryVariables>;
export const ResourcesMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourcesMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageResources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResourcesMetaDataQuery, ResourcesMetaDataQueryVariables>;
export const RightToLoveComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RightToLoveComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageRightToLove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureImg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"featureImgFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iframe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"iframeFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...FeatureImgFragmentFragmentDoc.definitions,...IframeFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<RightToLoveComponentsQuery, RightToLoveComponentsQueryVariables>;
export const RightToLoveMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RightToLoveMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageRightToLove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RightToLoveMetaDataQuery, RightToLoveMetaDataQueryVariables>;
export const UpdatesComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpdatesComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featureArticle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgArticleCardFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"updateCardGrid"},"name":{"kind":"Name","value":"gridSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loadMore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discoverMore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...ImgArticleCardFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<UpdatesComponentsQuery, UpdatesComponentsQueryVariables>;
export const UpdatesMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpdatesMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageUpdates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatesMetaDataQuery, UpdatesMetaDataQueryVariables>;
export const WhatWeDoComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatWeDoComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageWhatWeDo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","alias":{"kind":"Name","value":"contentBanner"},"name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"subTitle"},"name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignCarousel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imageContentCardGridFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"whatWeDoFeatureCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgContentCardFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"downloadGrid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"downloadGridFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imgTitleContentCardGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"imgTitleContentGroupFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySubscription"}}]}}]}}]}},...ImageContentCardGridFragmentFragmentDoc.definitions,...ImgContentCardFragmentFragmentDoc.definitions,...DownloadGridFragmentFragmentDoc.definitions,...ImgTitleContentGroupFragmentFragmentDoc.definitions]} as unknown as DocumentNode<WhatWeDoComponentsQuery, WhatWeDoComponentsQueryVariables>;
export const WhatWeDoMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatWeDoMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"pageWhatWeDo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WhatWeDoMetaDataQuery, WhatWeDoMetaDataQueryVariables>;
export const SiteMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"navPages"},"name":{"kind":"Name","value":"unfeNavigation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"localization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"culture"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeHomePage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeContentItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageAboutUs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageContactUs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageGeneralContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageResources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageNewsletter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeNavItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageKnowTheFacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageActNow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurWork"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageUpdates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageWhatWeDo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDonate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageEqualRights"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageChallenges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageFaqs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageRightToLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subNav"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"nav"},"name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unfeNavItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"displayText"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"contentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageKnowTheFacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageActNow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurWork"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageUpdates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageWhatWeDo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDonate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageEqualRights"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageChallenges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageFaqs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageRightToLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SiteMapQuery, SiteMapQueryVariables>;
export const SocialPlatformsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SocialPlatforms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"socialPlatform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<SocialPlatformsQuery, SocialPlatformsQueryVariables>;
export const GetSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"blank"}},{"kind":"Field","name":{"kind":"Name","value":"externalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"culture"}}]}}]}}]}}]} as unknown as DocumentNode<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const GetPageMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPageMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"contentItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contentItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageAboutUs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageActNow"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageChallenges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageContactUs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDefinitions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageDonate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageEqualRights"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageFaqs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageGeneralContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageKnowTheFacts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageNewsletter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurCampaigns"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageOurWork"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageResources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageRightToLove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageUpdates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pageWhatWeDo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentItemId"}},{"kind":"Field","name":{"kind":"Name","value":"pageMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPageMetaDataQuery, GetPageMetaDataQueryVariables>;